var items = {
  "block.minecraft.acacia_button": "Acaciaboallu",
  "block.minecraft.acacia_door": "Acaciauksa",
  "block.minecraft.acacia_fence": "Acaciaáidi",
  "block.minecraft.acacia_fence_gate": "Acaciaverrát",
  "block.minecraft.acacia_hanging_sign": "Heŋgejuvvon acaciagalba",
  "block.minecraft.acacia_leaves": "Acacialasttat",
  "block.minecraft.acacia_log": "Acaciabelko",
  "block.minecraft.acacia_planks": "Acaciafiellut",
  "block.minecraft.acacia_pressure_plate": "Acaciadeattopláhtta",
  "block.minecraft.acacia_sapling": "Acaciamuoraš",
  "block.minecraft.acacia_shelf": "Acaciahildu",
  "block.minecraft.acacia_sign": "Acaciagalba",
  "block.minecraft.acacia_slab": "Acaciapláhtta",
  "block.minecraft.acacia_stairs": "Acaciatráhppá",
  "block.minecraft.acacia_trapdoor": "Acacialuŋká",
  "block.minecraft.acacia_wall_hanging_sign": "Heŋgejuvvon acaciagalba seainnis",
  "block.minecraft.acacia_wall_sign": "Heŋgojuvvon Acaciagalba",
  "block.minecraft.acacia_wood": "Acaciamuorra",
  "block.minecraft.activator_rail": "Álggahahttin Ruovdemáđđi",
  "block.minecraft.air": "Áibmu",
  "block.minecraft.allium": "Ruksesluovvar",
  "block.minecraft.amethyst_block": "Ametistablohkka",
  "block.minecraft.amethyst_cluster": "Ametistačoaltu",
  "block.minecraft.ancient_debris": "Dološ Bázahusat",
  "block.minecraft.andesite": "Ándasihtta",
  "block.minecraft.andesite_slab": "Ándasihttapláhtta",
  "block.minecraft.andesite_stairs": "Ándasihttatráhppá",
  "block.minecraft.andesite_wall": "Ándasihtta Seaidni",
  "block.minecraft.anvil": "Stáđđi",
  "block.minecraft.attached_melon_stem": "Čatnasan Meluvdna Máddu",
  "block.minecraft.attached_pumpkin_stem": "Čatnasan Gurbbet Máddu",
  "block.minecraft.azalea": "Asalea",
  "block.minecraft.azalea_leaves": "Asalealasttat",
  "block.minecraft.azure_bluet": "Nuorsá",
  "block.minecraft.bamboo": "Bamboa",
  "block.minecraft.bamboo_block": "Bábmublohkka",
  "block.minecraft.bamboo_button": "Bámbuboallu",
  "block.minecraft.bamboo_door": "Bámbuuksa",
  "block.minecraft.bamboo_fence": "Bámbuáidi",
  "block.minecraft.bamboo_fence_gate": "Bámbuverrát",
  "block.minecraft.bamboo_hanging_sign": "Heŋgejuvvon bámbugalba",
  "block.minecraft.bamboo_mosaic": "Bámbumosaihkka",
  "block.minecraft.bamboo_mosaic_slab": "Bámbumosaihkkabealli",
  "block.minecraft.bamboo_mosaic_stairs": "Bámbumosaihkkatráhppát",
  "block.minecraft.bamboo_planks": "Bámbufiellut",
  "block.minecraft.bamboo_pressure_plate": "Bámbudeaddopláhtta",
  "block.minecraft.bamboo_sapling": "Bambusšaddu",
  "block.minecraft.bamboo_shelf": "Bambushildu",
  "block.minecraft.bamboo_sign": "Bámbugalba",
  "block.minecraft.bamboo_slab": "Bámbubealli",
  "block.minecraft.bamboo_stairs": "Bámbutráhppát",
  "block.minecraft.bamboo_trapdoor": "Bámbuluŋká",
  "block.minecraft.bamboo_wall_hanging_sign": "Heŋgejuvvon bámbugalba seainnis",
  "block.minecraft.bamboo_wall_sign": "Heŋgojuvvon bámbugalba",
  "block.minecraft.banner.base.black": "Áibbas čáhppes vuolimus oassi",
  "block.minecraft.banner.base.blue": "Áibbas alit vuolimus oassi",
  "block.minecraft.banner.base.brown": "Áibbas ruškes vuolimus oassi",
  "block.minecraft.banner.base.cyan": "Áibbas čuvgesalit vuolimus oassi",
  "block.minecraft.banner.base.gray": "Áibbas ránes vuolimus oassi",
  "block.minecraft.banner.base.green": "Áibbas ruoná vuolimus oassi",
  "block.minecraft.banner.base.light_blue": "Áibbas čuvgesalit vuolimus oassi",
  "block.minecraft.banner.base.light_gray": "Áibbas čuvgesránes vuolimus oassi",
  "block.minecraft.banner.base.lime": "Áibbas čugesruoná vuolimus oassi",
  "block.minecraft.banner.base.magenta": "Áibbas čuvgessáhppes vuolimus oassi",
  "block.minecraft.banner.base.orange": "Áibbas runta vuolimus oassi",
  "block.minecraft.banner.base.pink": "Áibbas čuvgesrukses vuolimus oassi",
  "block.minecraft.banner.base.purple": "Áibbas sáhppes vuolimus oassi",
  "block.minecraft.banner.base.red": "Áibbas rukses vuolimus oassi",
  "block.minecraft.banner.base.white": "Áibbas vilges vuolimus oassi",
  "block.minecraft.banner.base.yellow": "Áibbas fiskes vuolimus oassi",
  "block.minecraft.banner.border.black": "Čáhppes Ravdasáhcu",
  "block.minecraft.banner.border.blue": "Alit Ravdasáhcu",
  "block.minecraft.banner.border.brown": "Ruškes Ravdasáhcu",
  "block.minecraft.banner.border.cyan": "Turkiisa Ravdasáhcu",
  "block.minecraft.banner.border.gray": "Ránes Ravdasáhcu",
  "block.minecraft.banner.border.green": "Ruoná Ravdasáhcu",
  "block.minecraft.banner.border.light_blue": "Čuvgesalit Ravdasáhcu",
  "block.minecraft.banner.border.light_gray": "Čuvgesránes Ravdasáhcu",
  "block.minecraft.banner.border.lime": "Čuvgesruoná Ravdasáhcu",
  "block.minecraft.banner.border.magenta": "Čuvgessáhppes Ravdasáhcu",
  "block.minecraft.banner.border.orange": "Runta Ravdasáhcu",
  "block.minecraft.banner.border.pink": "Čuvgesrukses Ravdasáhcu",
  "block.minecraft.banner.border.purple": "Sáhppes Ravdasáhcu",
  "block.minecraft.banner.border.red": "Rukses Ravdasáhcu",
  "block.minecraft.banner.border.white": "Vilges Ravdasáhcu",
  "block.minecraft.banner.border.yellow": "Fiskes Ravdasáhcu",
  "block.minecraft.banner.bricks.black": "Čáhppes Muvraminsttar",
  "block.minecraft.banner.bricks.blue": "Alit Muvraminsttar",
  "block.minecraft.banner.bricks.brown": "Ruškes Muvraminsttar",
  "block.minecraft.banner.bricks.cyan": "Turkiisa Muvraminsttar",
  "block.minecraft.banner.bricks.gray": "Ránes Muvraminsttar",
  "block.minecraft.banner.bricks.green": "Ruoná Muvraminsttar",
  "block.minecraft.banner.bricks.light_blue": "Čuvgesalit Muvraminsttar",
  "block.minecraft.banner.bricks.light_gray": "Čuvgesránes Muvraminsttar",
  "block.minecraft.banner.bricks.lime": "Čuvgesruoná Muvraminsttar",
  "block.minecraft.banner.bricks.magenta": "Čuvgessáhppes Muvraminsttar",
  "block.minecraft.banner.bricks.orange": "Runta Muvraminsttar",
  "block.minecraft.banner.bricks.pink": "Čuvgesrukses Muvraminsttar",
  "block.minecraft.banner.bricks.purple": "Sáhppes Muvraminsttar",
  "block.minecraft.banner.bricks.red": "Rukses Muvraminsttar",
  "block.minecraft.banner.bricks.white": "Vilges Muvraminsttar",
  "block.minecraft.banner.bricks.yellow": "Fiskes Muvraminsttar",
  "block.minecraft.banner.circle.black": "Čáhppes Guovdogierdu",
  "block.minecraft.banner.circle.blue": "Alit Guovdogierdu",
  "block.minecraft.banner.circle.brown": "Ruškes Guovdogierdu",
  "block.minecraft.banner.circle.cyan": "Turkiisa Guovdogierdu",
  "block.minecraft.banner.circle.gray": "Ránes Guovdogierdu",
  "block.minecraft.banner.circle.green": "Ruoná Guovdogierdu",
  "block.minecraft.banner.circle.light_blue": "Čuvgesalit Guovdogierdu",
  "block.minecraft.banner.circle.light_gray": "Čuvgesránes Guovdogierdu",
  "block.minecraft.banner.circle.lime": "Čuvgesruoná Guovdogierdu",
  "block.minecraft.banner.circle.magenta": "Čuvgessáhppes Guovdogierdu",
  "block.minecraft.banner.circle.orange": "Runta Guovdogierdu",
  "block.minecraft.banner.circle.pink": "Čuvgesrukses Guovdogierdu",
  "block.minecraft.banner.circle.purple": "Sáhppes Guovdogierdu",
  "block.minecraft.banner.circle.red": "Rukses Guovdogierdu",
  "block.minecraft.banner.circle.white": "Vilges Guovdogierdu",
  "block.minecraft.banner.circle.yellow": "Fiskes Guovdogierdu",
  "block.minecraft.banner.creeper.black": "Čáhppes Creeperminsttar",
  "block.minecraft.banner.creeper.blue": "Alit Creeperminsttar",
  "block.minecraft.banner.creeper.brown": "Ruškes Creeperminsttar",
  "block.minecraft.banner.creeper.cyan": "Turkiisa Creeperminsttar",
  "block.minecraft.banner.creeper.gray": "Ránes Creeperminsttar",
  "block.minecraft.banner.creeper.green": "Ruoná Creeperminsttar",
  "block.minecraft.banner.creeper.light_blue": "Čuvgesalit Creeperminsttar",
  "block.minecraft.banner.creeper.light_gray": "Čuvgesránes Creeperminsttar",
  "block.minecraft.banner.creeper.lime": "Čuvgesruoná Creeperminsttar",
  "block.minecraft.banner.creeper.magenta": "Čuvgessáhppes Creeperminsttar",
  "block.minecraft.banner.creeper.orange": "Runta Creeperminsttar",
  "block.minecraft.banner.creeper.pink": "Čuvgesrukses Creeperminsttar",
  "block.minecraft.banner.creeper.purple": "Sáhppes Creeperminsttar",
  "block.minecraft.banner.creeper.red": "Rukses Creeperminsttar",
  "block.minecraft.banner.creeper.white": "Vilges Creeperminsttar",
  "block.minecraft.banner.creeper.yellow": "Fiskes Creeperminsttar",
  "block.minecraft.banner.cross.black": "Čáhppes Ruossa",
  "block.minecraft.banner.cross.blue": "Alit Ruossa",
  "block.minecraft.banner.cross.brown": "Ruškes Ruossa",
  "block.minecraft.banner.cross.cyan": "Turkiisa Rista",
  "block.minecraft.banner.cross.gray": "Ránes Ruossa",
  "block.minecraft.banner.cross.green": "Ruoná Ruossa",
  "block.minecraft.banner.cross.light_blue": "Čuvgesalit Ruossa",
  "block.minecraft.banner.cross.light_gray": "Čuovgesránes Ruossa",
  "block.minecraft.banner.cross.lime": "Čuvgesruoná Ruossa",
  "block.minecraft.banner.cross.magenta": "Čuvgessáhppes Ruossa",
  "block.minecraft.banner.cross.orange": "Runta Ruossa",
  "block.minecraft.banner.cross.pink": "Čuvgesrukses Ruossa",
  "block.minecraft.banner.cross.purple": "Sáhppes Ruossa",
  "block.minecraft.banner.cross.red": "Ruskes Ruossa",
  "block.minecraft.banner.cross.white": "Vilges Ruossa",
  "block.minecraft.banner.cross.yellow": "Fiskes Ruossa",
  "block.minecraft.banner.curly_border.black": "Čáhppes Barvvasravda",
  "block.minecraft.banner.curly_border.blue": "Alit Barvvasravda",
  "block.minecraft.banner.curly_border.brown": "Ruškes Barvvasravda",
  "block.minecraft.banner.curly_border.cyan": "Turkiisa Barvvasravda",
  "block.minecraft.banner.curly_border.gray": "Ránes Barvvasravda",
  "block.minecraft.banner.curly_border.green": "Ruoná Barvvasravda",
  "block.minecraft.banner.curly_border.light_blue": "Čuvgesalit Barvvasravda",
  "block.minecraft.banner.curly_border.light_gray": "Čuvgesránes Barvvasravda",
  "block.minecraft.banner.curly_border.lime": "Čuvgesruoná Barvvasravda",
  "block.minecraft.banner.curly_border.magenta": "Čuvgessáhppes Barvvasravda",
  "block.minecraft.banner.curly_border.orange": "Runta Barvvasravda",
  "block.minecraft.banner.curly_border.pink": "Čuvgesrukses Barvvasravda",
  "block.minecraft.banner.curly_border.purple": "Sáhppes Barvvasravda",
  "block.minecraft.banner.curly_border.red": "Rukses Barvvasravda",
  "block.minecraft.banner.curly_border.white": "Vilges Barvvasravda",
  "block.minecraft.banner.curly_border.yellow": "Fiskes Barvvasravda",
  "block.minecraft.banner.diagonal_left.black": "Čáhppes Bajit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_left.blue": "Alit Bajit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_left.brown": "Ruškes Bajit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_left.cyan": "Turkiisa Bajit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_left.gray": "Ránes Bajit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_left.green": "Ruoná Bajit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_left.light_blue": "Čuvgesalit Bajit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_left.light_gray": "Čuvgesránes Bajit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_left.lime": "Čuvgesruoná Bajit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_left.magenta": "Čuvgessáhppes Bajit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_left.orange": "Runta Bajit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_left.pink": "Čuvgesrukses Bajit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_left.purple": "Sáhppes Bajit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_left.red": "Rukses Bajit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_left.white": "Vilges Bajit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_left.yellow": "Fiskes Bajit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_right.black": "Čáhppes Bajit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_right.blue": "Alit Bajit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_right.brown": "Ruškes Bajit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_right.cyan": "Turkiisa Bajit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_right.gray": "Ránes Bajit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_right.green": "Ruoná Bajit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_right.light_blue": "Čuvgesalit Bajit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_right.light_gray": "Čuvgesránes Bajit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_right.lime": "Čuvgesruoná Bajit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_right.magenta": "Čuvgessáhppes Bajit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_right.orange": "Runta Bajit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_right.pink": "Čuvgesrukses Bajit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_right.purple": "Sáhppes Bajit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_right.red": "Rukses Bajit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_right.white": "Vilges Bajit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_right.yellow": "Fiskes Bajit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_up_left.black": "Čáhppes Vuolit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_up_left.blue": "Alit Vuolit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_up_left.brown": "Ruškes Vuolit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_up_left.cyan": "Turkiisa Vuolit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_up_left.gray": "Ránes Vuolit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_up_left.green": "Ruoná Vuolit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Čuvgesalit Vuolit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Čuvgesránes Vuolit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_up_left.lime": "Čuvgesruoná Vuolit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_up_left.magenta": "Čuvgessáhppes Vuolit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_up_left.orange": "Runta Vuolit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_up_left.pink": "Čuvgesrukses Vuolit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_up_left.purple": "Sáhppes Vuolit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_up_left.red": "Rukses Vuolit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_up_left.white": "Vilges Vuolit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_up_left.yellow": "Fiskes Vuolit Gurutbealečiehka",
  "block.minecraft.banner.diagonal_up_right.black": "Čáhppes Vuolit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_up_right.blue": "Alit Vuolit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_up_right.brown": "Ruškes Vuolit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_up_right.cyan": "Turkiisa Vuolit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_up_right.gray": "Ránes Vuolit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_up_right.green": "Ruoná Vuolit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Čuvgesalit Vuolit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Čuvgesránes Vuolit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_up_right.lime": "Čuvgesruoná Vuolit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_up_right.magenta": "Čuvgessáhppes Vuolit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_up_right.orange": "Runta Vuolit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_up_right.pink": "Čuvgesrukses Vuolit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_up_right.purple": "Sáhppes Vuolit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_up_right.red": "Rukses Vuolit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_up_right.white": "Runta Vuolit Olgešbealečiehka",
  "block.minecraft.banner.diagonal_up_right.yellow": "Fiskes Vuolit Olgešbealečiehka",
  "block.minecraft.banner.flow.black": "Čáhppes golgan",
  "block.minecraft.banner.flow.blue": "Alit golgan",
  "block.minecraft.banner.flow.brown": "Ruškes golgan",
  "block.minecraft.banner.flow.cyan": "Turkiisa golgan",
  "block.minecraft.banner.flow.gray": "Ránes golgan",
  "block.minecraft.banner.flow.green": "Ruoná golgan",
  "block.minecraft.banner.flow.light_blue": "Čuvgesalit golgan",
  "block.minecraft.banner.flow.light_gray": "Čuvgesránes golgan",
  "block.minecraft.banner.flow.lime": "Čuvgesruoná golgan",
  "block.minecraft.banner.flow.magenta": "Čuvgessáhppes golgan",
  "block.minecraft.banner.flow.orange": "Runta golgan",
  "block.minecraft.banner.flow.pink": "Čuvgesrukses golgan",
  "block.minecraft.banner.flow.purple": "Sáhppes golgan",
  "block.minecraft.banner.flow.red": "Rukses golgan",
  "block.minecraft.banner.flow.white": "Vilges golgan",
  "block.minecraft.banner.flow.yellow": "Fiskes golgan",
  "block.minecraft.banner.flower.black": "Čáhppes Lieđđeminsttar",
  "block.minecraft.banner.flower.blue": "Alit Lieđđeminsttar",
  "block.minecraft.banner.flower.brown": "Ruškes Lieđđeminsttar",
  "block.minecraft.banner.flower.cyan": "Turkiisa Lieđđeminsttar",
  "block.minecraft.banner.flower.gray": "Ránes Lieđđeminsttar",
  "block.minecraft.banner.flower.green": "Ruoná Lieđđeminsttar",
  "block.minecraft.banner.flower.light_blue": "Čuvgesalit Lieđđeminsttar",
  "block.minecraft.banner.flower.light_gray": "Čuvgesránes Lieđđeminsttar",
  "block.minecraft.banner.flower.lime": "Čuvgesruoná Lieđđeminsttar",
  "block.minecraft.banner.flower.magenta": "Čuvgessáhppes Lieđđeminsttar",
  "block.minecraft.banner.flower.orange": "Runta Lieđđeminsttar",
  "block.minecraft.banner.flower.pink": "Čuvgesrukses Lieđđeminsttar",
  "block.minecraft.banner.flower.purple": "Sáhppes Lieđđeminsttar",
  "block.minecraft.banner.flower.red": "Rukses Lieđđeminsttar",
  "block.minecraft.banner.flower.white": "Vilges Lieđđeminsttar",
  "block.minecraft.banner.flower.yellow": "Fiskes Lieđđeminsttar",
  "block.minecraft.banner.globe.black": "Čáhppes Máilmmespábba",
  "block.minecraft.banner.globe.blue": "Alit Máilmmespábba",
  "block.minecraft.banner.globe.brown": "Ruškes Máilmmespábba",
  "block.minecraft.banner.globe.cyan": "Turkiisa Máilmmespábba",
  "block.minecraft.banner.globe.gray": "Ránes Máilmmespábba",
  "block.minecraft.banner.globe.green": "Ruoná Máilmmespábba",
  "block.minecraft.banner.globe.light_blue": "Čuvgesalit Máilmmespábba",
  "block.minecraft.banner.globe.light_gray": "Čuvgesránes Máilmmespábba",
  "block.minecraft.banner.globe.lime": "Čuvgesruoná Máilmmespábba",
  "block.minecraft.banner.globe.magenta": "Čuvgessáhppes Máilmmespábba",
  "block.minecraft.banner.globe.orange": "Runta Máilmmespábba",
  "block.minecraft.banner.globe.pink": "Čuvgesrukses Máilmmespábba",
  "block.minecraft.banner.globe.purple": "Sáhppes Máilmmespábba",
  "block.minecraft.banner.globe.red": "Rukses Máilmmespábba",
  "block.minecraft.banner.globe.white": "Vilges Máilmmespábba",
  "block.minecraft.banner.globe.yellow": "Fiskes Máilmmespábba",
  "block.minecraft.banner.gradient.black": "Čáhppes Bajitguovsomolsun",
  "block.minecraft.banner.gradient.blue": "Alit Bajitguovsomolsun",
  "block.minecraft.banner.gradient.brown": "Ruškes Bajitguovsomolsun",
  "block.minecraft.banner.gradient.cyan": "Turkiisa Bajitguovsomolsun",
  "block.minecraft.banner.gradient.gray": "Ránes Bajitguovsomolsun",
  "block.minecraft.banner.gradient.green": "Ruoná Bajitguovsomolsun",
  "block.minecraft.banner.gradient.light_blue": "Čuvgesalit Bajitguovsomolsun",
  "block.minecraft.banner.gradient.light_gray": "Čuvgesránes Bajitguovsomolsun",
  "block.minecraft.banner.gradient.lime": "Čuvgesruoná Bajitguovsomolsun",
  "block.minecraft.banner.gradient.magenta": "Čuvgessáhppes Bajitguovsomolsun",
  "block.minecraft.banner.gradient.orange": "Runta Bajitguovsomolsun",
  "block.minecraft.banner.gradient.pink": "Čuvgesrukses Bajitguovsomolsun",
  "block.minecraft.banner.gradient.purple": "Sáhppes Bajitguovsomolsun",
  "block.minecraft.banner.gradient.red": "Rukses Bajitguovsomolsun",
  "block.minecraft.banner.gradient.white": "Runta Bajitguovsomolsun",
  "block.minecraft.banner.gradient.yellow": "Fiskes Bajitguovsomolsun",
  "block.minecraft.banner.gradient_up.black": "Čáhppes Vuođđoguovsomolsun",
  "block.minecraft.banner.gradient_up.blue": "Alit Vuođđoguovsomolsun",
  "block.minecraft.banner.gradient_up.brown": "Ruškes Vuođđoguovsomolsun",
  "block.minecraft.banner.gradient_up.cyan": "Turkiisa Vuođđoguovsomolsun",
  "block.minecraft.banner.gradient_up.gray": "Ránes Vuođđoguovsomolsun",
  "block.minecraft.banner.gradient_up.green": "Ruoná Vuođđoguovsomolsun",
  "block.minecraft.banner.gradient_up.light_blue": "Čuvgesalit Vuođđoguovsomolsun",
  "block.minecraft.banner.gradient_up.light_gray": "Čuvgesránes Vuođđoguovsomolsun",
  "block.minecraft.banner.gradient_up.lime": "Čuvgesruoná Vuođđoguovsomolsun",
  "block.minecraft.banner.gradient_up.magenta": "Čuvgessáhppes Vuođđoguovsomolsun",
  "block.minecraft.banner.gradient_up.orange": "Runta Vuođđoguovsomolsun",
  "block.minecraft.banner.gradient_up.pink": "Čuvgesrukses Vuođđoguovsomolsun",
  "block.minecraft.banner.gradient_up.purple": "Sáhppes Vuođđoguovsomolsun",
  "block.minecraft.banner.gradient_up.red": "Rukses Vuođđoguovsomolsun",
  "block.minecraft.banner.gradient_up.white": "Vilges Vuođđoguovsomolsun",
  "block.minecraft.banner.gradient_up.yellow": "Fiskes Vuođđoguovsomolsun",
  "block.minecraft.banner.guster.black": "Čáhppes jiella",
  "block.minecraft.banner.guster.blue": "Alit jiella",
  "block.minecraft.banner.guster.brown": "Ruškes jiella",
  "block.minecraft.banner.guster.cyan": "Turkiisa jiella",
  "block.minecraft.banner.guster.gray": "Ránes jiella",
  "block.minecraft.banner.guster.green": "Ruoná jiella",
  "block.minecraft.banner.guster.light_blue": "Čuvgesalit jiella",
  "block.minecraft.banner.guster.light_gray": "Čuvgesránes jiella",
  "block.minecraft.banner.guster.lime": "Čuvgesruoná jiella",
  "block.minecraft.banner.guster.magenta": "Čuvgessáhppes jiella",
  "block.minecraft.banner.guster.orange": "Runta jiella",
  "block.minecraft.banner.guster.pink": "Čuvgesrukses jiella",
  "block.minecraft.banner.guster.purple": "Sáhppes jiella",
  "block.minecraft.banner.guster.red": "Rukses jiella",
  "block.minecraft.banner.guster.white": "Vilges jiella",
  "block.minecraft.banner.guster.yellow": "Fiskes jiella",
  "block.minecraft.banner.half_horizontal.black": "Čáhppes Badjebealli",
  "block.minecraft.banner.half_horizontal.blue": "Alit Badjebealli",
  "block.minecraft.banner.half_horizontal.brown": "Ruškes Badjebealli",
  "block.minecraft.banner.half_horizontal.cyan": "Turkiisa Badjebealli",
  "block.minecraft.banner.half_horizontal.gray": "Ránes Badjebealli",
  "block.minecraft.banner.half_horizontal.green": "Ruoná Badjebealli",
  "block.minecraft.banner.half_horizontal.light_blue": "Čuvgesalit Badjebealli",
  "block.minecraft.banner.half_horizontal.light_gray": "Čuvgesránes Badjebealli",
  "block.minecraft.banner.half_horizontal.lime": "Čuvgesruoná Badjebealli",
  "block.minecraft.banner.half_horizontal.magenta": "Čuvgessáhppes Badjebealli",
  "block.minecraft.banner.half_horizontal.orange": "Runta Badjebealli",
  "block.minecraft.banner.half_horizontal.pink": "Čuvgesrukses Badjebealli",
  "block.minecraft.banner.half_horizontal.purple": "Sáhppes Badjebealli",
  "block.minecraft.banner.half_horizontal.red": "Rukses Badjebealli",
  "block.minecraft.banner.half_horizontal.white": "Vilges Badjebealli",
  "block.minecraft.banner.half_horizontal.yellow": "Fiskes Badjebealli",
  "block.minecraft.banner.half_horizontal_bottom.black": "Čáhppes Vuollebealli",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Alit Vuollebealli",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Ruškes Vuollebealli",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Turkiisa Vuollebealli",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Ránes Vuollebealli",
  "block.minecraft.banner.half_horizontal_bottom.green": "Ruoná Vuollebealli",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Čuvgesalit Vuollebealli",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Čuvgesránes Vuollebealli",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Čuvgesruoná Vuollebealli",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Čuvgessáhppes Vuollebealli",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Runta Vuollebealli",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Čuvgesrukses Vuollebealli",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Sáhppes Vuollebealli",
  "block.minecraft.banner.half_horizontal_bottom.red": "Rukses Vuollebealli",
  "block.minecraft.banner.half_horizontal_bottom.white": "Vilges Vuollebealli",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Fiskes Vuollebealli",
  "block.minecraft.banner.half_vertical.black": "Čáhppes Gurutbealli",
  "block.minecraft.banner.half_vertical.blue": "Alit Gurutbealli",
  "block.minecraft.banner.half_vertical.brown": "Ruškes Gurutbealli",
  "block.minecraft.banner.half_vertical.cyan": "Turkiisa Gurutbealli",
  "block.minecraft.banner.half_vertical.gray": "Ránes Gurutbealli",
  "block.minecraft.banner.half_vertical.green": "Ruoná Gurutbealli",
  "block.minecraft.banner.half_vertical.light_blue": "Čuvgesalit Gurutbealli",
  "block.minecraft.banner.half_vertical.light_gray": "Čuvgesránes Gurutbealli",
  "block.minecraft.banner.half_vertical.lime": "Čuvgesruoná Gurutbealli",
  "block.minecraft.banner.half_vertical.magenta": "Čuvgessáhppes Gurutbealli",
  "block.minecraft.banner.half_vertical.orange": "Runta Gurutbealli",
  "block.minecraft.banner.half_vertical.pink": "Čuvgesrukses Gurutbealli",
  "block.minecraft.banner.half_vertical.purple": "Sáhppes Gurutbealli",
  "block.minecraft.banner.half_vertical.red": "Rukses Gurutbealli",
  "block.minecraft.banner.half_vertical.white": "Vilges Gurutbealli",
  "block.minecraft.banner.half_vertical.yellow": "Fiskes Gurutbealli",
  "block.minecraft.banner.half_vertical_right.black": "Čáhppes Olgešbealli",
  "block.minecraft.banner.half_vertical_right.blue": "Alit Olgešbealli",
  "block.minecraft.banner.half_vertical_right.brown": "Ruškes Olgešbealli",
  "block.minecraft.banner.half_vertical_right.cyan": "Turkiisa Olgešbealli",
  "block.minecraft.banner.half_vertical_right.gray": "Ránes Olgešbealli",
  "block.minecraft.banner.half_vertical_right.green": "Ruoná Olgešbealli",
  "block.minecraft.banner.half_vertical_right.light_blue": "Čuvgesalit Olgešbealli",
  "block.minecraft.banner.half_vertical_right.light_gray": "Čuvgesránes Olgešbealli",
  "block.minecraft.banner.half_vertical_right.lime": "Čuvgesruoná Olgešbealli",
  "block.minecraft.banner.half_vertical_right.magenta": "Čuvgessáhppes Olgešbealli",
  "block.minecraft.banner.half_vertical_right.orange": "Runta Olgešbealli",
  "block.minecraft.banner.half_vertical_right.pink": "Čuvgesrukses Olgešbealli",
  "block.minecraft.banner.half_vertical_right.purple": "Sáhppes Olgešbealli",
  "block.minecraft.banner.half_vertical_right.red": "Rukses Olgešbealli",
  "block.minecraft.banner.half_vertical_right.white": "Vilges Olgešbealli",
  "block.minecraft.banner.half_vertical_right.yellow": "Fiskes Olgešbealli",
  "block.minecraft.banner.mojang.black": "Čáhppes Mojangminsttar",
  "block.minecraft.banner.mojang.blue": "Alit Mojangminsttar",
  "block.minecraft.banner.mojang.brown": "Ruškes Mojangminsttar",
  "block.minecraft.banner.mojang.cyan": "Turkiisa Mojangminsttar",
  "block.minecraft.banner.mojang.gray": "Ránes Mojangminsttar",
  "block.minecraft.banner.mojang.green": "Ruoná Mojangminsttar",
  "block.minecraft.banner.mojang.light_blue": "Čuvgesalit Mojangminsttar",
  "block.minecraft.banner.mojang.light_gray": "Čuvgesránes Mojangminsttar",
  "block.minecraft.banner.mojang.lime": "Čuvgesruoná Mojangminsttar",
  "block.minecraft.banner.mojang.magenta": "Čuvgessáhppes Mojangminsttar",
  "block.minecraft.banner.mojang.orange": "Runta Mojangminsttar",
  "block.minecraft.banner.mojang.pink": "Čuvgesrukses Mojangminsttar",
  "block.minecraft.banner.mojang.purple": "Sáhppes Mojangminsttar",
  "block.minecraft.banner.mojang.red": "Rukses Mojangminsttar",
  "block.minecraft.banner.mojang.white": "Vilges Mojangminsttar",
  "block.minecraft.banner.mojang.yellow": "Fiskes Mojangminsttar",
  "block.minecraft.banner.piglin.black": "Čáhppes njunni",
  "block.minecraft.banner.piglin.blue": "Alit njunni",
  "block.minecraft.banner.piglin.brown": "Ruškes njunni",
  "block.minecraft.banner.piglin.cyan": "Čuvgesalit njunni",
  "block.minecraft.banner.piglin.gray": "Ránes njunni",
  "block.minecraft.banner.piglin.green": "Ruoná njunni",
  "block.minecraft.banner.piglin.light_blue": "Čuvgesalit njunni",
  "block.minecraft.banner.piglin.light_gray": "Čuvgesránes njunni",
  "block.minecraft.banner.piglin.lime": "Čuvgesruoná njunni",
  "block.minecraft.banner.piglin.magenta": "Čuvgessáhppes njunni",
  "block.minecraft.banner.piglin.orange": "Runta njunni",
  "block.minecraft.banner.piglin.pink": "Čuvgesrukses njunni",
  "block.minecraft.banner.piglin.purple": "Sáhppes njunni",
  "block.minecraft.banner.piglin.red": "Rukses njunni",
  "block.minecraft.banner.piglin.white": "Vilges njunni",
  "block.minecraft.banner.piglin.yellow": "Fiskes njunni",
  "block.minecraft.banner.rhombus.black": "Čáhppes Dikkel",
  "block.minecraft.banner.rhombus.blue": "Alit Dikkel",
  "block.minecraft.banner.rhombus.brown": "Ruškes Dikkel",
  "block.minecraft.banner.rhombus.cyan": "Turkiisa Dikkel",
  "block.minecraft.banner.rhombus.gray": "Ránes Dikkel",
  "block.minecraft.banner.rhombus.green": "Ruoná Dikkel",
  "block.minecraft.banner.rhombus.light_blue": "Čuvgesalit Dikkel",
  "block.minecraft.banner.rhombus.light_gray": "Čuvgesránes Dikkel",
  "block.minecraft.banner.rhombus.lime": "Čuvgesruoná Dikkel",
  "block.minecraft.banner.rhombus.magenta": "Čuvgessáhppes Dikkel",
  "block.minecraft.banner.rhombus.orange": "Runta Dikkel",
  "block.minecraft.banner.rhombus.pink": "Čuvgesrukses Dikkel",
  "block.minecraft.banner.rhombus.purple": "Sáhppes Dikkel",
  "block.minecraft.banner.rhombus.red": "Rukses Dikkel",
  "block.minecraft.banner.rhombus.white": "Vilges Dikkel",
  "block.minecraft.banner.rhombus.yellow": "Fiskes Dikkel",
  "block.minecraft.banner.skull.black": "Čáhppes Oaiveskálžominsttar",
  "block.minecraft.banner.skull.blue": "Alit Oaiveskálžominsttar",
  "block.minecraft.banner.skull.brown": "Ruškes Oaiveskálžominsttar",
  "block.minecraft.banner.skull.cyan": "Turkiisa Oaiveskálžominsttar",
  "block.minecraft.banner.skull.gray": "Ránes Oaiveskálžominsttar",
  "block.minecraft.banner.skull.green": "Ruoná Oaiveskálžominsttar",
  "block.minecraft.banner.skull.light_blue": "Čuvgesalit Oaiveskálžominsttar",
  "block.minecraft.banner.skull.light_gray": "Čuvgesránes Oaiveskálžominsttar",
  "block.minecraft.banner.skull.lime": "Čuvgesruoná Oaiveskálžominsttar",
  "block.minecraft.banner.skull.magenta": "Čuvgessáhppes Oaiveskálžominsttar",
  "block.minecraft.banner.skull.orange": "Runta Oaiveskálžominsttar",
  "block.minecraft.banner.skull.pink": "Čuvgesrukses Oaiveskálžominsttar",
  "block.minecraft.banner.skull.purple": "Sáhppes Oaiveskálžominsttar",
  "block.minecraft.banner.skull.red": "Rukses Oaiveskálžominsttar",
  "block.minecraft.banner.skull.white": "Vilges Oaiveskálžominsttar",
  "block.minecraft.banner.skull.yellow": "Fiskes Oaiveskálžominsttar",
  "block.minecraft.banner.small_stripes.black": "Čáhppes ráidá",
  "block.minecraft.banner.small_stripes.blue": "Alit ráidá",
  "block.minecraft.banner.small_stripes.brown": "Ruškat \nráidá",
  "block.minecraft.banner.small_stripes.cyan": "Turkiisa Ráida",
  "block.minecraft.banner.small_stripes.gray": "Ránis ráidá",
  "block.minecraft.banner.small_stripes.green": "Ruoná ráidá",
  "block.minecraft.banner.small_stripes.light_blue": "Čuvgesalit Ráida",
  "block.minecraft.banner.small_stripes.light_gray": "Čuovgesránes Ráida",
  "block.minecraft.banner.small_stripes.lime": "Čuvgesruoná Ráida",
  "block.minecraft.banner.small_stripes.magenta": "Čuvgessáhppes Ráida",
  "block.minecraft.banner.small_stripes.orange": "Oránša ráidá",
  "block.minecraft.banner.small_stripes.pink": "Guvgeruoksat ráidá",
  "block.minecraft.banner.small_stripes.purple": "Sáhppat ráidá",
  "block.minecraft.banner.small_stripes.red": "Ruoksat ráidá",
  "block.minecraft.banner.small_stripes.white": "Vielgat ráidá",
  "block.minecraft.banner.small_stripes.yellow": "Fiskat ráidá",
  "block.minecraft.banner.square_bottom_left.black": "Čáhppes Gurutbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_left.blue": "Alit Gurutbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_left.brown": "Ruškes Gurutbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_left.cyan": "Turkiisa Gurutbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_left.gray": "Ránes Gurutbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_left.green": "Ruoná Gurutbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_left.light_blue": "Čuvgesalit Gurutbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_left.light_gray": "Čuvgesránes Gurutbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_left.lime": "Čuvgesruoná Gurutbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_left.magenta": "Čuvgessáhppes Gurutbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_left.orange": "Runta Gurutbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_left.pink": "Čuvgesrukses Gurutbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_left.purple": "Sáhppes Gurutbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_left.red": "Rukses Gurutbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_left.white": "Vilges Gurutbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_left.yellow": "Fiskes Gurutbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_right.black": "Čáhppes Olgešbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_right.blue": "Alit Olgešbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_right.brown": "Ruškes Olgešbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_right.cyan": "Turkiisa Olgešbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_right.gray": "Ránes Olgešbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_right.green": "Ruoná Olgešbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_right.light_blue": "Čuvgesalit Olgešbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_right.light_gray": "Čuvgesránes Olgešbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_right.lime": "Čuvgesruoná Olgešbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_right.magenta": "Čuvgessáhppes Olgešbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_right.orange": "Runta Olgešbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_right.pink": "Čuvgesrukses Olgešbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_right.purple": "Sáhppes Olgešbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_right.red": "Rukses Olgešbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_right.white": "Vilges Olgešbeale Vuollegeahči",
  "block.minecraft.banner.square_bottom_right.yellow": "Fiskes Olgešbeale Vuollegeahči",
  "block.minecraft.banner.square_top_left.black": "Čáhppes Gurutbeale Badjegeahči",
  "block.minecraft.banner.square_top_left.blue": "Alit Gurutbeale Badjegeahči",
  "block.minecraft.banner.square_top_left.brown": "Ruškes Gurutbeale Badjegeahči",
  "block.minecraft.banner.square_top_left.cyan": "Turkiisa Gurutbeale Badjegeahči",
  "block.minecraft.banner.square_top_left.gray": "Ránes Gurutbeale Badjegeahči",
  "block.minecraft.banner.square_top_left.green": "Ruoná Gurutbeale Badjegeahči",
  "block.minecraft.banner.square_top_left.light_blue": "Čuvgesalit Gurutbeale Badjegeahči",
  "block.minecraft.banner.square_top_left.light_gray": "Čuvgesránes Gurutbeale Badjegeahči",
  "block.minecraft.banner.square_top_left.lime": "Čuvgesruoná Gurutbeale Badjegeahči",
  "block.minecraft.banner.square_top_left.magenta": "Čuvgessáhppes Gurutbeale Badjegeahči",
  "block.minecraft.banner.square_top_left.orange": "Runta Gurutbeale Badjegeahči",
  "block.minecraft.banner.square_top_left.pink": "Čuvgesrukses Gurutbeale Badjegeahči",
  "block.minecraft.banner.square_top_left.purple": "Sáhppes Gurutbeale Badjegeahči",
  "block.minecraft.banner.square_top_left.red": "Rukses Gurutbeale Badjegeahči",
  "block.minecraft.banner.square_top_left.white": "Vilges Gurutbeale Badjegeahči",
  "block.minecraft.banner.square_top_left.yellow": "Fiskes Gurutbeale Badjegeahči",
  "block.minecraft.banner.square_top_right.black": "Čáhppes Olgešbeale Badjegeahči",
  "block.minecraft.banner.square_top_right.blue": "Alit Olgešbeale Badjegeahči",
  "block.minecraft.banner.square_top_right.brown": "Ruškes Olgešbeale Badjegeahči",
  "block.minecraft.banner.square_top_right.cyan": "Turkiisa Olgešbeale Badjegeahči",
  "block.minecraft.banner.square_top_right.gray": "Ránes Olgešbeale Badjegeahči",
  "block.minecraft.banner.square_top_right.green": "Ruoná Olgešbeale Badjegeahči",
  "block.minecraft.banner.square_top_right.light_blue": "Čuvgesalit Olgešbeale Badjegeahči",
  "block.minecraft.banner.square_top_right.light_gray": "Čuvgesránes Olgešbeale Badjegeahči",
  "block.minecraft.banner.square_top_right.lime": "Čuvgesruoná Olgešbeale Badjegeahči",
  "block.minecraft.banner.square_top_right.magenta": "Čuvgessáhppes Olgešbeale Badjegeahči",
  "block.minecraft.banner.square_top_right.orange": "Runta Olgešbeale Badjegeahči",
  "block.minecraft.banner.square_top_right.pink": "Čuvgesrukses Olgešbeale Badjegeahči",
  "block.minecraft.banner.square_top_right.purple": "Sáhppes Olgešbeale Badjegeahči",
  "block.minecraft.banner.square_top_right.red": "Rukses Olgešbeale Badjegeahči",
  "block.minecraft.banner.square_top_right.white": "Vilges Olgešbeale Badjegeahči",
  "block.minecraft.banner.square_top_right.yellow": "Fiskes Olgešbeale Badjegeahči",
  "block.minecraft.banner.straight_cross.black": "Čáhppes Ruossa",
  "block.minecraft.banner.straight_cross.blue": "Alit Ruossa",
  "block.minecraft.banner.straight_cross.brown": "Ruškes Ruossa",
  "block.minecraft.banner.straight_cross.cyan": "Turkiisa Ruossa",
  "block.minecraft.banner.straight_cross.gray": "Ránes Ruossa",
  "block.minecraft.banner.straight_cross.green": "Ruoná Ruossa",
  "block.minecraft.banner.straight_cross.light_blue": "Čuvgesalit Ruossa",
  "block.minecraft.banner.straight_cross.light_gray": "Čuvgesránes Ruossa",
  "block.minecraft.banner.straight_cross.lime": "Čuvgesruoná Ruossa",
  "block.minecraft.banner.straight_cross.magenta": "Čuvgessáhppes Ruossa",
  "block.minecraft.banner.straight_cross.orange": "Runta Ruossa",
  "block.minecraft.banner.straight_cross.pink": "Čuvgesrukses Ruossa",
  "block.minecraft.banner.straight_cross.purple": "Sáhppes Ruossa",
  "block.minecraft.banner.straight_cross.red": "Rukses Ruossa",
  "block.minecraft.banner.straight_cross.white": "Vilges Ruossa",
  "block.minecraft.banner.straight_cross.yellow": "Fiskes Ruossa",
  "block.minecraft.banner.stripe_bottom.black": "Čáhppes Vuođđu",
  "block.minecraft.banner.stripe_bottom.blue": "Alit Vuođđu",
  "block.minecraft.banner.stripe_bottom.brown": "Ruškes Vuođđu",
  "block.minecraft.banner.stripe_bottom.cyan": "Turkiisa Vuođđu",
  "block.minecraft.banner.stripe_bottom.gray": "Ránes Vuođđu",
  "block.minecraft.banner.stripe_bottom.green": "Ruoná Vuođđu",
  "block.minecraft.banner.stripe_bottom.light_blue": "Čuvgesalit Vuođđu",
  "block.minecraft.banner.stripe_bottom.light_gray": "Čuovgesránes Vuođđu",
  "block.minecraft.banner.stripe_bottom.lime": "Čuvgesruoná Vuođđu",
  "block.minecraft.banner.stripe_bottom.magenta": "Čuvgessáhppes Vuođđu",
  "block.minecraft.banner.stripe_bottom.orange": "Runta Vuođđu",
  "block.minecraft.banner.stripe_bottom.pink": "Guvgesruokses Vuođđu",
  "block.minecraft.banner.stripe_bottom.purple": "Sáhppes Vuođđu",
  "block.minecraft.banner.stripe_bottom.red": "Rukses Vuođđu",
  "block.minecraft.banner.stripe_bottom.white": "Vilges Vuođđu",
  "block.minecraft.banner.stripe_bottom.yellow": "Fiskes Vuođđu",
  "block.minecraft.banner.stripe_center.black": "Čáhppes Guovdosárggis",
  "block.minecraft.banner.stripe_center.blue": "Alit Guovdosárggis",
  "block.minecraft.banner.stripe_center.brown": "Ruškes Guovdosárggis",
  "block.minecraft.banner.stripe_center.cyan": "Turkiisa Guovdosárggis",
  "block.minecraft.banner.stripe_center.gray": "Ránes Guovdosárggis",
  "block.minecraft.banner.stripe_center.green": "Ruoná Guovdosárggis",
  "block.minecraft.banner.stripe_center.light_blue": "Čuvgesalit Guovdosárggis",
  "block.minecraft.banner.stripe_center.light_gray": "Čuovgesránes Guovdosárggis",
  "block.minecraft.banner.stripe_center.lime": "Čuvgesruoná Guovdosárggis",
  "block.minecraft.banner.stripe_center.magenta": "Čuvgessáhppes Guovdosárggis",
  "block.minecraft.banner.stripe_center.orange": "Runta Guovdosárggis",
  "block.minecraft.banner.stripe_center.pink": "Guvgesruokses Guovdosárggis",
  "block.minecraft.banner.stripe_center.purple": "Sáhppes Guovdosárggis",
  "block.minecraft.banner.stripe_center.red": "Rukses Guovdosárggis",
  "block.minecraft.banner.stripe_center.white": "Vilges Guovdosárggis",
  "block.minecraft.banner.stripe_center.yellow": "Fiskes Guovdosárggis",
  "block.minecraft.banner.stripe_downleft.black": "Čáhppes Vinjusárggis Gurutbeallai",
  "block.minecraft.banner.stripe_downleft.blue": "Alit Vinjusárggis Gurutbeallai",
  "block.minecraft.banner.stripe_downleft.brown": "Ruškes Vinjusárggis Gurutbeallai",
  "block.minecraft.banner.stripe_downleft.cyan": "Turkiisa Vinjusárggis Gurutbeallai",
  "block.minecraft.banner.stripe_downleft.gray": "Ránes Vinjusárggis Gurutbeallai",
  "block.minecraft.banner.stripe_downleft.green": "Ruoná Vinjusárggis Gurutbeallai",
  "block.minecraft.banner.stripe_downleft.light_blue": "Čuvgesalit Vinjusárggis Gurutbeallai",
  "block.minecraft.banner.stripe_downleft.light_gray": "Čuvgesránes Vinjusárggis Gurutbeallai",
  "block.minecraft.banner.stripe_downleft.lime": "Čuvgesruoná Vinjusárggis Gurutbeallai",
  "block.minecraft.banner.stripe_downleft.magenta": "Čuvgessáhppes Vinjusárggis Gurutbeallai",
  "block.minecraft.banner.stripe_downleft.orange": "Runta Vinjusárggis Gurutbeallai",
  "block.minecraft.banner.stripe_downleft.pink": "Čuvgesrukses Vinjusárggis Gurutbeallai",
  "block.minecraft.banner.stripe_downleft.purple": "Sáhppes Vinjusárggis Gurutbeallai",
  "block.minecraft.banner.stripe_downleft.red": "Rukses Vinjusárggis Gurutbeallai",
  "block.minecraft.banner.stripe_downleft.white": "Vilges Vinjusárggis Gurutbeallai",
  "block.minecraft.banner.stripe_downleft.yellow": "Fiskes Vinjusárggis Gurutbeallai",
  "block.minecraft.banner.stripe_downright.black": "Čáhppes Vinjusárggis Olgešbeallai",
  "block.minecraft.banner.stripe_downright.blue": "Alit Vinjusárggis Olgešbeallai",
  "block.minecraft.banner.stripe_downright.brown": "Ruškes Vinjusárggis Olgešbeallai",
  "block.minecraft.banner.stripe_downright.cyan": "Turkiisa Vinjusárggis Olgešbeallai",
  "block.minecraft.banner.stripe_downright.gray": "Ránes Vinjusárggis Olgešbeallai",
  "block.minecraft.banner.stripe_downright.green": "Ruoná Vinjusárggis Olgešbeallai",
  "block.minecraft.banner.stripe_downright.light_blue": "Čuvgesalit Vinjusárggis Olgešbeallai",
  "block.minecraft.banner.stripe_downright.light_gray": "Čuvgesránes Vinjusárggis Olgešbeallai",
  "block.minecraft.banner.stripe_downright.lime": "Čuvgesruoná Vinjusárggis Olgešbeallai",
  "block.minecraft.banner.stripe_downright.magenta": "Čuvgessáhppes Vinjusárggis Olgešbeallai",
  "block.minecraft.banner.stripe_downright.orange": "Runta Vinjusárggis Olgešbeallai",
  "block.minecraft.banner.stripe_downright.pink": "Čuvgesrukses Vinjusárggis Olgešbeallai",
  "block.minecraft.banner.stripe_downright.purple": "Sáhppes Vinjusárggis Olgešbeallai",
  "block.minecraft.banner.stripe_downright.red": "Rukses Vinjusárggis Olgešbeallai",
  "block.minecraft.banner.stripe_downright.white": "Vilges Vinjusárggis Olgešbeallai",
  "block.minecraft.banner.stripe_downright.yellow": "Fiskes Vinjusárggis Olgešbeallai",
  "block.minecraft.banner.stripe_left.black": "Čáhppes Gurutsárggis",
  "block.minecraft.banner.stripe_left.blue": "Alit Gurutsárggis",
  "block.minecraft.banner.stripe_left.brown": "Ruškes Gurutsárggis",
  "block.minecraft.banner.stripe_left.cyan": "Turkiisa Gurutsárggis",
  "block.minecraft.banner.stripe_left.gray": "Ránes Gurutsárggis",
  "block.minecraft.banner.stripe_left.green": "Ruoná Gurutsárggis",
  "block.minecraft.banner.stripe_left.light_blue": "Čuvgesalit Gurutsárggis",
  "block.minecraft.banner.stripe_left.light_gray": "Čuvgesránes Gurutsárggis",
  "block.minecraft.banner.stripe_left.lime": "Čuvgesruoná Gurutsárggis",
  "block.minecraft.banner.stripe_left.magenta": "Čuvgessáhppes Gurutsárggis",
  "block.minecraft.banner.stripe_left.orange": "Runta Gurutsárggis",
  "block.minecraft.banner.stripe_left.pink": "Čuvgesrukses Gurutsárggis",
  "block.minecraft.banner.stripe_left.purple": "Sáhppes Gurutsárggis",
  "block.minecraft.banner.stripe_left.red": "Rukses Gurutsárggis",
  "block.minecraft.banner.stripe_left.white": "Vilges Gurutsárggis",
  "block.minecraft.banner.stripe_left.yellow": "Fiskes Gurutsárggis",
  "block.minecraft.banner.stripe_middle.black": "Čáhppes Veallut Guovdosárggis",
  "block.minecraft.banner.stripe_middle.blue": "Alit Veallut Guovdosárggis",
  "block.minecraft.banner.stripe_middle.brown": "Ruškes Veallut Guovdosárggis",
  "block.minecraft.banner.stripe_middle.cyan": "Turkiisa Veallut Guovdosárggis",
  "block.minecraft.banner.stripe_middle.gray": "Ránes Veallut Guovdosárggis",
  "block.minecraft.banner.stripe_middle.green": "Ruoná Veallut Guovdosárggis",
  "block.minecraft.banner.stripe_middle.light_blue": "Čuvgesalit Veallut Guovdosárggis",
  "block.minecraft.banner.stripe_middle.light_gray": "Čuovgesránes Veallut Guovdosárggis",
  "block.minecraft.banner.stripe_middle.lime": "Čuvgesruoná Veallut Guovdosárggis",
  "block.minecraft.banner.stripe_middle.magenta": "Čuvgessáhppes Veallut Guovdosárggis",
  "block.minecraft.banner.stripe_middle.orange": "Runta Veallut Guovdosárggis",
  "block.minecraft.banner.stripe_middle.pink": "Čuvgesrukses Veallut Guovdosárggis",
  "block.minecraft.banner.stripe_middle.purple": "Sáhppes Veallut Guovdosárggis",
  "block.minecraft.banner.stripe_middle.red": "Rukses Veallut Guovdosárggis",
  "block.minecraft.banner.stripe_middle.white": "Vilges Veallut Guovdosárggis",
  "block.minecraft.banner.stripe_middle.yellow": "Fiskes Veallut Guovdosárggis",
  "block.minecraft.banner.stripe_right.black": "Čáhppes Olgešsárggis",
  "block.minecraft.banner.stripe_right.blue": "Alit Olgešsárggis",
  "block.minecraft.banner.stripe_right.brown": "Ruškes Olgešsárggis",
  "block.minecraft.banner.stripe_right.cyan": "Turkiisa Olgešsárggis",
  "block.minecraft.banner.stripe_right.gray": "Ránes Olgešsárggis",
  "block.minecraft.banner.stripe_right.green": "Ruoná Olgešsárggis",
  "block.minecraft.banner.stripe_right.light_blue": "Čuvgesalit Olgešsárggis",
  "block.minecraft.banner.stripe_right.light_gray": "Čuvgesránes Olgešsárggis",
  "block.minecraft.banner.stripe_right.lime": "Čuvgesruoná Olgešsárggis",
  "block.minecraft.banner.stripe_right.magenta": "Čuvgessáhppes Olgešsárggis",
  "block.minecraft.banner.stripe_right.orange": "Runta Olgešsárggis",
  "block.minecraft.banner.stripe_right.pink": "Čuvgesruskes Olgešsárggis",
  "block.minecraft.banner.stripe_right.purple": "Sáhppes Olgešsárggis",
  "block.minecraft.banner.stripe_right.red": "Rukses Olgešsárggis",
  "block.minecraft.banner.stripe_right.white": "Vilges Olgešsárggis",
  "block.minecraft.banner.stripe_right.yellow": "Fiskes Olgešsárggis",
  "block.minecraft.banner.stripe_top.black": "Čáhppes Giera",
  "block.minecraft.banner.stripe_top.blue": "Alit Giera",
  "block.minecraft.banner.stripe_top.brown": "Ruškes Giera",
  "block.minecraft.banner.stripe_top.cyan": "Turkiisa Giera",
  "block.minecraft.banner.stripe_top.gray": "Ránes Giera",
  "block.minecraft.banner.stripe_top.green": "Ruoná Giera",
  "block.minecraft.banner.stripe_top.light_blue": "Čuvgesalit Giera",
  "block.minecraft.banner.stripe_top.light_gray": "Čuvgesránes Giera",
  "block.minecraft.banner.stripe_top.lime": "Čuvgesruoná Giera",
  "block.minecraft.banner.stripe_top.magenta": "Čuvgessáhppes Giera",
  "block.minecraft.banner.stripe_top.orange": "Runta Giera",
  "block.minecraft.banner.stripe_top.pink": "Čuvgesrukses Giera",
  "block.minecraft.banner.stripe_top.purple": "Sáhppes Giera",
  "block.minecraft.banner.stripe_top.red": "Rukses Giera",
  "block.minecraft.banner.stripe_top.white": "Vilges Giera",
  "block.minecraft.banner.stripe_top.yellow": "Fiskes Giera",
  "block.minecraft.banner.triangle_bottom.black": "Čáhppes Vuollegolmmačiegat",
  "block.minecraft.banner.triangle_bottom.blue": "Alit Vuollegolmmačiegat",
  "block.minecraft.banner.triangle_bottom.brown": "Ruškes Vuollegolmmačiegat",
  "block.minecraft.banner.triangle_bottom.cyan": "Turkiisa Vuollegolmmačiegat",
  "block.minecraft.banner.triangle_bottom.gray": "Ránes Vuollegolmmačiegat",
  "block.minecraft.banner.triangle_bottom.green": "Ruoná Vuollegolmmačiegat",
  "block.minecraft.banner.triangle_bottom.light_blue": "Čuvgesalit Vuollegolmmačiegat",
  "block.minecraft.banner.triangle_bottom.light_gray": "Čuvgesránes Vuollegolmmačiegat",
  "block.minecraft.banner.triangle_bottom.lime": "Čuvgesruoná Vuollegolmmačiegat",
  "block.minecraft.banner.triangle_bottom.magenta": "Čuvgessáhppes Vuollegolmmačiegat",
  "block.minecraft.banner.triangle_bottom.orange": "Runta Vuollegolmmačiegat",
  "block.minecraft.banner.triangle_bottom.pink": "Fiskes Vuollegolmmačiegat",
  "block.minecraft.banner.triangle_bottom.purple": "Sáhppes Vuollegolmmačiegat",
  "block.minecraft.banner.triangle_bottom.red": "Rukses Vuollegolmmačiegat",
  "block.minecraft.banner.triangle_bottom.white": "Vilges Vuollegolmmačiegat",
  "block.minecraft.banner.triangle_bottom.yellow": "Fiskes Vuollegolmmačiegat",
  "block.minecraft.banner.triangle_top.black": "Čáhppes Badjegolmmačiegat",
  "block.minecraft.banner.triangle_top.blue": "Alit Badjegolmmačiegat",
  "block.minecraft.banner.triangle_top.brown": "Ruškes Badjegolmmačiegat",
  "block.minecraft.banner.triangle_top.cyan": "Turkiisa Badjegolmmačiegat",
  "block.minecraft.banner.triangle_top.gray": "Ránes Badjegolmmačiegat",
  "block.minecraft.banner.triangle_top.green": "Ruoná Badjegolmmačiegat",
  "block.minecraft.banner.triangle_top.light_blue": "Čuvgesalit Badjegolmmačiegat",
  "block.minecraft.banner.triangle_top.light_gray": "Čuvgesránes Badjegolmmačiegat",
  "block.minecraft.banner.triangle_top.lime": "Čuvgesruoná Badjegolmmačiegat",
  "block.minecraft.banner.triangle_top.magenta": "Čuvgessáhppes Badjegolmmačiegat",
  "block.minecraft.banner.triangle_top.orange": "Runta Badjegolmmačiegat",
  "block.minecraft.banner.triangle_top.pink": "Čuvgesrukses Badjegolmmačiegat",
  "block.minecraft.banner.triangle_top.purple": "Sáhppes Badjegolmmačiegat",
  "block.minecraft.banner.triangle_top.red": "Rukses Badjegolmmačiegat",
  "block.minecraft.banner.triangle_top.white": "Vilges Badjegolmmačiegat",
  "block.minecraft.banner.triangle_top.yellow": "Fiskes Badjegolmmačiegat",
  "block.minecraft.banner.triangles_bottom.black": "Čáhppes Vuollegolmmabánát",
  "block.minecraft.banner.triangles_bottom.blue": "Alit Vuollegolmmabánát",
  "block.minecraft.banner.triangles_bottom.brown": "Ruškes Vuollegolmmabánát",
  "block.minecraft.banner.triangles_bottom.cyan": "Turkiisa Vuollegolmmabánát",
  "block.minecraft.banner.triangles_bottom.gray": "Ránes Vuollegolmmabánát",
  "block.minecraft.banner.triangles_bottom.green": "Ruoná Vuollegolmmabánát",
  "block.minecraft.banner.triangles_bottom.light_blue": "Čuvgesalit Vuollegolmmabánát",
  "block.minecraft.banner.triangles_bottom.light_gray": "Čuvgesránes Vuollegolmmabánát",
  "block.minecraft.banner.triangles_bottom.lime": "Čuvgesruoná Vuollegolmmabánát",
  "block.minecraft.banner.triangles_bottom.magenta": "Čuvgessáhppes Vuollegolmmabánát",
  "block.minecraft.banner.triangles_bottom.orange": "Runta Vuollegolmmabánát",
  "block.minecraft.banner.triangles_bottom.pink": "Čuvgesrukses Vuollegolmmabánát",
  "block.minecraft.banner.triangles_bottom.purple": "Sáhppes Vuollegolmmabánát",
  "block.minecraft.banner.triangles_bottom.red": "Rukses Vuollegolmmabánát",
  "block.minecraft.banner.triangles_bottom.white": "Vilges Vuollegolmmabánát",
  "block.minecraft.banner.triangles_bottom.yellow": "Fiskes Vuollegolmmabánát",
  "block.minecraft.banner.triangles_top.black": "Čáhppes Badjegolmmabánát",
  "block.minecraft.banner.triangles_top.blue": "Alit Badjegolmmabánát",
  "block.minecraft.banner.triangles_top.brown": "Ruškes Badjegolmmabánát",
  "block.minecraft.banner.triangles_top.cyan": "Turkiisa Badjegolmmabánát",
  "block.minecraft.banner.triangles_top.gray": "Ránes Badjegolmmabánát",
  "block.minecraft.banner.triangles_top.green": "Ruoná Badjegolmmabánát",
  "block.minecraft.banner.triangles_top.light_blue": "Čuvgesalit Badjegolmmabánát",
  "block.minecraft.banner.triangles_top.light_gray": "Čuvgesránes Badjegolmmabánát",
  "block.minecraft.banner.triangles_top.lime": "Čuvgesruoná Badjegolmmabánát",
  "block.minecraft.banner.triangles_top.magenta": "Čuvgessáhppes Badjegolmmabánát",
  "block.minecraft.banner.triangles_top.orange": "Runta Badjegolmmabánát",
  "block.minecraft.banner.triangles_top.pink": "Čuvgesrukses Badjegolmmabánát",
  "block.minecraft.banner.triangles_top.purple": "Sáhppes Badjegolmmabánát",
  "block.minecraft.banner.triangles_top.red": "Rukses Badjegolmmabánát",
  "block.minecraft.banner.triangles_top.white": "Vilges Badjegolmmabánát",
  "block.minecraft.banner.triangles_top.yellow": "Fiskes Badjegolmmabánát",
  "block.minecraft.barrel": "Fárppal",
  "block.minecraft.barrier": "Caggi",
  "block.minecraft.basalt": "Basaltta",
  "block.minecraft.beacon": "Várdočuovga",
  "block.minecraft.beacon.primary": "Primára Fápmu",
  "block.minecraft.beacon.secondary": "Sekundára Fápmu",
  "block.minecraft.bed.no_sleep": "Sáhtát dušše oađđit ihkku dahje garra dálkkis",
  "block.minecraft.bed.not_safe": "Don it sahte nohkkat dál; leat návddit lahka",
  "block.minecraft.bed.obstructed": "Dán seaŋgii ii sáhte velledit",
  "block.minecraft.bed.occupied": "Dát seanga lea váldon",
  "block.minecraft.bed.too_far_away": "Don it sáhte nohkkat dál; seanga lea menddo guhkkin eret",
  "block.minecraft.bedrock": "Báktevuođđu",
  "block.minecraft.bee_nest": "Uvlubeassi",
  "block.minecraft.beehive": "Uvluviessu",
  "block.minecraft.beetroots": "Ruksesruohttasat",
  "block.minecraft.bell": "Biellu",
  "block.minecraft.big_dripleaf": "Stuora goaikolasta",
  "block.minecraft.big_dripleaf_stem": "Stuora goaikolasta mátta",
  "block.minecraft.birch_button": "Soahkeboallu",
  "block.minecraft.birch_door": "Soahkeuksa",
  "block.minecraft.birch_fence": "Soahkeáidi",
  "block.minecraft.birch_fence_gate": "Soahkeverrát",
  "block.minecraft.birch_hanging_sign": "Heŋgejuvvon soahkegalba",
  "block.minecraft.birch_leaves": "Soahkelasttat",
  "block.minecraft.birch_log": "Soahkebelko",
  "block.minecraft.birch_planks": "Soahkefiellut",
  "block.minecraft.birch_pressure_plate": "Soahkedeattopláhtta",
  "block.minecraft.birch_sapling": "Soahkemuoraš",
  "block.minecraft.birch_shelf": "Soahkehildu",
  "block.minecraft.birch_sign": "Soahkegalba",
  "block.minecraft.birch_slab": "Soahkepláhtta",
  "block.minecraft.birch_stairs": "Soahketráhppá",
  "block.minecraft.birch_trapdoor": "Soahkeluŋká",
  "block.minecraft.birch_wall_hanging_sign": "Heŋgejuvvon soahkegalba seainnis",
  "block.minecraft.birch_wall_sign": "Heŋgojuvvon Soahkegalba",
  "block.minecraft.birch_wood": "Soahkemuorra",
  "block.minecraft.black_banner": "Čáhppes Leavga",
  "block.minecraft.black_bed": "Čáhppes Seaŋga",
  "block.minecraft.black_candle": "Čáhppes ginttal",
  "block.minecraft.black_candle_cake": "Gáhkku čáhppes gintaliin",
  "block.minecraft.black_carpet": "Čáhppes Láhtterátnu",
  "block.minecraft.black_concrete": "Čáhppes betoŋŋa",
  "block.minecraft.black_concrete_powder": "Čáhppes betoŋŋabulvvar",
  "block.minecraft.black_glazed_terracotta": "Čáhppes šelges terrakotta",
  "block.minecraft.black_shulker_box": "Čáhppes Shulkerboksa",
  "block.minecraft.black_stained_glass": "Čáhppes Glássa",
  "block.minecraft.black_stained_glass_pane": "Čáhppes Glássaruvtto",
  "block.minecraft.black_terracotta": "Čáhppes terrakotta",
  "block.minecraft.black_wool": "Čáhppes Ullu",
  "block.minecraft.blackstone": "Čáhppesgeađgi",
  "block.minecraft.blackstone_slab": "Čáhppesgeađgepláhtta",
  "block.minecraft.blackstone_stairs": "Čáhppesgeađgetráhppá",
  "block.minecraft.blackstone_wall": "Čáhppesgeađge Seaidni",
  "block.minecraft.blast_furnace": "Suddadanuvdna",
  "block.minecraft.blue_banner": "Alit Leavga",
  "block.minecraft.blue_bed": "Alit Seaŋga",
  "block.minecraft.blue_candle": "Alit ginttal",
  "block.minecraft.blue_candle_cake": "Gáhkku alit gintaliin",
  "block.minecraft.blue_carpet": "Alit Láhtterátnu",
  "block.minecraft.blue_concrete": "Alit betoŋŋa",
  "block.minecraft.blue_concrete_powder": "Alit betoŋŋabulvvar",
  "block.minecraft.blue_glazed_terracotta": "Alit šelges terrakotta",
  "block.minecraft.blue_ice": "Alitjiekŋa",
  "block.minecraft.blue_orchid": "Alit Orkidéa",
  "block.minecraft.blue_shulker_box": "Alit Shulkerboksa",
  "block.minecraft.blue_stained_glass": "Alit Glássa",
  "block.minecraft.blue_stained_glass_pane": "Alit Glássaruvtto",
  "block.minecraft.blue_terracotta": "Alit terrakotta",
  "block.minecraft.blue_wool": "Alit Ullu",
  "block.minecraft.bone_block": "Dákteblohkka",
  "block.minecraft.bookshelf": "Girjehildu",
  "block.minecraft.brain_coral": "Vuiŋŋamuš Korálla",
  "block.minecraft.brain_coral_block": "Vuoŋŋamuš Korallablohkka",
  "block.minecraft.brain_coral_fan": "Vuoŋŋamuš Koralla Fan",
  "block.minecraft.brain_coral_wall_fan": "Vuoŋŋamuš Koralla Libardahtti",
  "block.minecraft.brewing_stand": "Vuoššahat",
  "block.minecraft.brick_slab": "Muvrapláhtta",
  "block.minecraft.brick_stairs": "Muvratráhppá",
  "block.minecraft.brick_wall": "Muvraseaidni",
  "block.minecraft.bricks": "Muvra",
  "block.minecraft.brown_banner": "Ruškes Leavga",
  "block.minecraft.brown_bed": "Ruškes Seaŋga",
  "block.minecraft.brown_candle": "Ruškes ginttal",
  "block.minecraft.brown_candle_cake": "Gáhkku ruškes gintaliin",
  "block.minecraft.brown_carpet": "Ruškes Láhtterátnu",
  "block.minecraft.brown_concrete": "Ruškes betoŋŋa",
  "block.minecraft.brown_concrete_powder": "Ruškes betoŋŋabulvvar",
  "block.minecraft.brown_glazed_terracotta": "Ruškes šelges terrakotta",
  "block.minecraft.brown_mushroom": "Ruškes Guoppar",
  "block.minecraft.brown_mushroom_block": "Ruškes guopparblohkka",
  "block.minecraft.brown_shulker_box": "Ruškes Shulkerboksa",
  "block.minecraft.brown_stained_glass": "Ruškes Glássa",
  "block.minecraft.brown_stained_glass_pane": "Ruškes Glássaruvtto",
  "block.minecraft.brown_terracotta": "Ruškes terrakotta",
  "block.minecraft.brown_wool": "Ruškes Ullu",
  "block.minecraft.bubble_column": "Bulljarasrevre",
  "block.minecraft.bubble_coral": "Buillaras Korálla",
  "block.minecraft.bubble_coral_block": "Bulljaras Korallablohkka",
  "block.minecraft.bubble_coral_fan": "Bulljaras Koralla Fan",
  "block.minecraft.bubble_coral_wall_fan": "Bulljaras Koralla Libardahtti",
  "block.minecraft.budding_amethyst": "Bohciidis ametista",
  "block.minecraft.bush": "Miestta",
  "block.minecraft.cactus": "Káktus",
  "block.minecraft.cactus_flower": "Káktuslieđđi",
  "block.minecraft.cake": "Gáhkku",
  "block.minecraft.calcite": "Kalsihtta",
  "block.minecraft.calibrated_sculk_sensor": "Kalibrerejuvvon skulk-dovddan",
  "block.minecraft.campfire": "Dollagáddi",
  "block.minecraft.candle": "Ginttal",
  "block.minecraft.candle_cake": "Ginttalgáhkku",
  "block.minecraft.carrots": "Rušppit",
  "block.minecraft.cartography_table": "Kártenbeavdi",
  "block.minecraft.carved_pumpkin": "Čuhppon Gurbbet",
  "block.minecraft.cauldron": "Ruitu",
  "block.minecraft.cave_air": "Hoallu Áibmu",
  "block.minecraft.cave_vines": "Bákteráigegoargŋunsuoidni",
  "block.minecraft.cave_vines_plant": "Bákteráigegoargŋunsuoidnerássi",
  "block.minecraft.chain": "Ruovdeláhkki",
  "block.minecraft.chain_command_block": "Ráidokommándoblohkka",
  "block.minecraft.cherry_button": "Kirsamuorjemuorraboallu",
  "block.minecraft.cherry_door": "Kirsamuorjemuorrauksa",
  "block.minecraft.cherry_fence": "Kirsamuorjemuorraáidi",
  "block.minecraft.cherry_fence_gate": "Kirsamuorjemuorraverrát",
  "block.minecraft.cherry_hanging_sign": "Heŋgejuvvon kirsamuorjemuorragalba",
  "block.minecraft.cherry_leaves": "Kirsamuorjemuorralasttat",
  "block.minecraft.cherry_log": "Kirsamuorjemuorrabelko",
  "block.minecraft.cherry_planks": "Kirsamuorjemuorrafiellut",
  "block.minecraft.cherry_pressure_plate": "Kirsamuorjemuorradeattopláhtta",
  "block.minecraft.cherry_sapling": "Kirsamuorjemuoraš",
  "block.minecraft.cherry_shelf": "Kirsamuorjemuorrahildu",
  "block.minecraft.cherry_sign": "Kirsamuorjemuorragalba",
  "block.minecraft.cherry_slab": "Kirsamuorjemuorrapláhtta",
  "block.minecraft.cherry_stairs": "Kirsamuorjemuorratráhppát",
  "block.minecraft.cherry_trapdoor": "Kirsamuorjemuorraluŋká",
  "block.minecraft.cherry_wall_hanging_sign": "Kirsamuorjemuorraseaidnegalba",
  "block.minecraft.cherry_wall_sign": "Kirsamuorjemuorraseaidnegalba",
  "block.minecraft.cherry_wood": "Kirsamuorjemuorra",
  "block.minecraft.chest": "Giisá",
  "block.minecraft.chipped_anvil": "Reakčanan Stáđđi",
  "block.minecraft.chiseled_bookshelf": "Luokčajuvvon girjehildu",
  "block.minecraft.chiseled_copper": "Luokčajuvvon veaiki",
  "block.minecraft.chiseled_deepslate": "Luokčajuvvon Bodneráktu",
  "block.minecraft.chiseled_nether_bricks": "Luokčajuvvon Nethergeađgemuvra",
  "block.minecraft.chiseled_polished_blackstone": "Luokčajuvvon Bussejuvvon Čáhppesgeađgi",
  "block.minecraft.chiseled_quartz_block": "Luokčajuvvon Kvárcablohkka",
  "block.minecraft.chiseled_red_sandstone": "Luokčajuvvon rukses sáttogeađgi",
  "block.minecraft.chiseled_resin_bricks": "Luokčajuvvon gáhččemuvra",
  "block.minecraft.chiseled_sandstone": "Luokčajuvvon sáttogeađgi",
  "block.minecraft.chiseled_stone_bricks": "Luokčajuvvon Geađgemuvra",
  "block.minecraft.chiseled_tuff": "Luokčajuvvon tuffa",
  "block.minecraft.chiseled_tuff_bricks": "Luokčajuvvon tuffamuvra",
  "block.minecraft.chorus_flower": "Choruslieđđi",
  "block.minecraft.chorus_plant": "Chorusšaddu",
  "block.minecraft.clay": "Láira",
  "block.minecraft.closed_eyeblossom": "Giddanan čalbmelieđđi",
  "block.minecraft.coal_block": "Koallablohkka",
  "block.minecraft.coal_ore": "Koallamálbma",
  "block.minecraft.coarse_dirt": "Roattoseana",
  "block.minecraft.cobbled_deepslate": "Mollejuvvon Bodneráktu",
  "block.minecraft.cobbled_deepslate_slab": "Mollejuvvon Bodneráktopláhtta",
  "block.minecraft.cobbled_deepslate_stairs": "Mollejuvvon Bodneráktotráhppát",
  "block.minecraft.cobbled_deepslate_wall": "Mollejuvvon Bodneráktoseaidni",
  "block.minecraft.cobblestone": "Luoddageađgi",
  "block.minecraft.cobblestone_slab": "Luoddageađgepláhtta",
  "block.minecraft.cobblestone_stairs": "Luoddageađgetráhppá",
  "block.minecraft.cobblestone_wall": "Luoddageađgge Seaidni",
  "block.minecraft.cobweb": "Heavdnefierbmi",
  "block.minecraft.cocoa": "Kakáo",
  "block.minecraft.command_block": "Kommándoblohkka",
  "block.minecraft.comparator": "Redstone iskkadeaddji",
  "block.minecraft.composter": "Kompostár",
  "block.minecraft.conduit": "Mearrameannudeaddji",
  "block.minecraft.copper_bars": "Veaikegiddagas",
  "block.minecraft.copper_block": "Veaikeblohkka",
  "block.minecraft.copper_bulb": "Veaikelámpá",
  "block.minecraft.copper_chain": "Veaikeláhkki",
  "block.minecraft.copper_chest": "Veaikeláhkki",
  "block.minecraft.copper_door": "Veaikeuksa",
  "block.minecraft.copper_golem_statue": "Veaikehálddi bázzi",
  "block.minecraft.copper_grate": "Veaikeráspa",
  "block.minecraft.copper_lantern": "Veaikelámpá",
  "block.minecraft.copper_ore": "Veaikemálbma",
  "block.minecraft.copper_torch": "Veaikespáiddár",
  "block.minecraft.copper_trapdoor": "Veaikeluŋká",
  "block.minecraft.copper_wall_torch": "Seaidneveaikespáiddár",
  "block.minecraft.cornflower": "Rohkarássi",
  "block.minecraft.cracked_deepslate_bricks": "Luoddanan Bodneráktomuvra",
  "block.minecraft.cracked_deepslate_tiles": "Luoddanan Bodneráktotiila",
  "block.minecraft.cracked_nether_bricks": "Luoddanan Nethergeađgemuvra",
  "block.minecraft.cracked_polished_blackstone_bricks": "Luoddanan Bussejuvvon Čáhppesgeađgemuvra",
  "block.minecraft.cracked_stone_bricks": "Luoddanan Geađgemuvra",
  "block.minecraft.crafter": "Duojár",
  "block.minecraft.crafting_table": "Duodjebeavdi",
  "block.minecraft.creaking_heart": "Gihčama váibmu",
  "block.minecraft.creeper_head": "Creeper Oaivi",
  "block.minecraft.creeper_wall_head": "Gopmi Seaidneoaivi",
  "block.minecraft.crimson_button": "Skárllatboallu",
  "block.minecraft.crimson_door": "Skárllatuksa",
  "block.minecraft.crimson_fence": "Skárllatáidi",
  "block.minecraft.crimson_fence_gate": "Skárllatverrát",
  "block.minecraft.crimson_fungus": "Skárllatguoppar",
  "block.minecraft.crimson_hanging_sign": "Heŋgejuvvon skárllatgalba",
  "block.minecraft.crimson_hyphae": "Skárllatsuorus",
  "block.minecraft.crimson_nylium": "Skárllatmirkoeana",
  "block.minecraft.crimson_planks": "Skárllatfiellut",
  "block.minecraft.crimson_pressure_plate": "Skárllatdeattopláhtta",
  "block.minecraft.crimson_roots": "Skárllatruohttasat",
  "block.minecraft.crimson_shelf": "Skárllathildu",
  "block.minecraft.crimson_sign": "Skárllatgalba",
  "block.minecraft.crimson_slab": "Skárllatbealli",
  "block.minecraft.crimson_stairs": "Skárllattráhppát",
  "block.minecraft.crimson_stem": "Skárllatmátta",
  "block.minecraft.crimson_trapdoor": "Skárllatluŋká",
  "block.minecraft.crimson_wall_hanging_sign": "Heŋgejuvvon skárllatgalba seainnis",
  "block.minecraft.crimson_wall_sign": "Heŋgojuvvon Skárllatgalba",
  "block.minecraft.crying_obsidian": "Čierru obsidiána",
  "block.minecraft.cut_copper": "Čuhppon veaiki",
  "block.minecraft.cut_copper_slab": "Čuhppon Veaikepláhtta",
  "block.minecraft.cut_copper_stairs": "Čuhppon veaiketráhppá",
  "block.minecraft.cut_red_sandstone": "Njuolgejuvvon rukses sáttogeađgi",
  "block.minecraft.cut_red_sandstone_slab": "Čuhppon Rukses Sáttogeađgepláhtta",
  "block.minecraft.cut_sandstone": "Njulgejuvvon sáttogeađgi",
  "block.minecraft.cut_sandstone_slab": "Čuhppon Sáttogeađgepláhtta",
  "block.minecraft.cyan_banner": "Turkiisa Leavga",
  "block.minecraft.cyan_bed": "Turkiisa Seaŋga",
  "block.minecraft.cyan_candle": "Turkiisa ginttal",
  "block.minecraft.cyan_candle_cake": "Gáhkku čuvgesalit gintaliin",
  "block.minecraft.cyan_carpet": "Turkiisa Láhtterátnu",
  "block.minecraft.cyan_concrete": "Turkiisa betoŋŋa",
  "block.minecraft.cyan_concrete_powder": "Turkiisa betoŋŋabulvvar",
  "block.minecraft.cyan_glazed_terracotta": "Turkiisa šelges terrakotta",
  "block.minecraft.cyan_shulker_box": "Turkiisa Shulkerboksa",
  "block.minecraft.cyan_stained_glass": "Turkiisa Glássa",
  "block.minecraft.cyan_stained_glass_pane": "Turkiisa Glássaruvtto",
  "block.minecraft.cyan_terracotta": "Turkiisa terrakotta",
  "block.minecraft.cyan_wool": "Turkiisa Ullu",
  "block.minecraft.damaged_anvil": "Billašuvvan Stáđđi",
  "block.minecraft.dandelion": "Uvlorássi",
  "block.minecraft.dark_oak_button": "Sevdnjes Eaikaboallu",
  "block.minecraft.dark_oak_door": "Sevdnjes Eaikauksa",
  "block.minecraft.dark_oak_fence": "Sevdnjes Eaikaáidi",
  "block.minecraft.dark_oak_fence_gate": "Sevdnjes Eaikaverrát",
  "block.minecraft.dark_oak_hanging_sign": "Heŋgejuvvon sevdnjeseaikagalba",
  "block.minecraft.dark_oak_leaves": "Sevdnjes Eaikalasttat",
  "block.minecraft.dark_oak_log": "Sevdnjes Eaikabelko",
  "block.minecraft.dark_oak_planks": "Sevdnjes Eaikafiellut",
  "block.minecraft.dark_oak_pressure_plate": "Sevdnjes Eaikadeattopláhtta",
  "block.minecraft.dark_oak_sapling": "Sevdnjes Eaikamuoraš",
  "block.minecraft.dark_oak_shelf": "Sevdnjes Eaikahildu",
  "block.minecraft.dark_oak_sign": "Sevdnjes Eaikagalba",
  "block.minecraft.dark_oak_slab": "Sevdnjes Eaikapláhtta",
  "block.minecraft.dark_oak_stairs": "Sevdnjes Eaikatráhppá",
  "block.minecraft.dark_oak_trapdoor": "Sevdnjes Eaikaluŋká",
  "block.minecraft.dark_oak_wall_hanging_sign": "Heŋgejuvvon sevdnjeseaikagalba seainnis",
  "block.minecraft.dark_oak_wall_sign": "Heŋgojuvvon Sevdnjes Eaikagalba",
  "block.minecraft.dark_oak_wood": "Sevdnjes Eaikamuorra",
  "block.minecraft.dark_prismarine": "Sevdnjes Prismariidna",
  "block.minecraft.dark_prismarine_slab": "Sevdnjes Prismariidnapláhtta",
  "block.minecraft.dark_prismarine_stairs": "Sevdnjes Prismariidnatráhppá",
  "block.minecraft.daylight_detector": "Beaivečuovgga iski",
  "block.minecraft.dead_brain_coral": "Jápman Vuoŋŋamuš Koralla",
  "block.minecraft.dead_brain_coral_block": "Jápman Vuoŋŋamuš Korallablohkka",
  "block.minecraft.dead_brain_coral_fan": "Jápman Vuoŋŋamuš Koralla Libardahtti",
  "block.minecraft.dead_brain_coral_wall_fan": "Jápman Vuoŋŋamuškoralla Seaidnelibardahtti",
  "block.minecraft.dead_bubble_coral": "Jápman Bulljaras Koralla",
  "block.minecraft.dead_bubble_coral_block": "Jápman Bulljaras Korallablohkka",
  "block.minecraft.dead_bubble_coral_fan": "Jápman Bulljaras Koralla Libardahtti",
  "block.minecraft.dead_bubble_coral_wall_fan": "Jápman Bulljaraskoralla Seaidnelibardahtti",
  "block.minecraft.dead_bush": "Goikemiestta",
  "block.minecraft.dead_fire_coral": "Jápman Dolla Koralla",
  "block.minecraft.dead_fire_coral_block": "Jápman Dolla Korallablohkka",
  "block.minecraft.dead_fire_coral_fan": "Jápman Dolla Koralla Libardahtti",
  "block.minecraft.dead_fire_coral_wall_fan": "Jápman Dollakoralla Seaidnelibardahtti",
  "block.minecraft.dead_horn_coral": "Jápman Čoarvvás Koralla",
  "block.minecraft.dead_horn_coral_block": "Jápman Čoarvvás Korallablohkka",
  "block.minecraft.dead_horn_coral_fan": "Jápman Čoarvvás Koralla Libardahtti",
  "block.minecraft.dead_horn_coral_wall_fan": "Jápman Čoarvváskoralla Seaidnelibardahtti",
  "block.minecraft.dead_tube_coral": "Jápman Bohcci Koralla",
  "block.minecraft.dead_tube_coral_block": "Jápman Bohcci Korallablohkka",
  "block.minecraft.dead_tube_coral_fan": "Jápman Bohcci Koralla Libardahtti",
  "block.minecraft.dead_tube_coral_wall_fan": "Jápman Bohccikoralla Seaidnelibardahtti",
  "block.minecraft.decorated_pot": "Hervejuvvon kruhkka",
  "block.minecraft.deepslate": "Bodneráktu",
  "block.minecraft.deepslate_brick_slab": "Bodneráktomuvrapláhtta",
  "block.minecraft.deepslate_brick_stairs": "Bodneráktomuvratráhppá",
  "block.minecraft.deepslate_brick_wall": "Bodneráktomuvraseaidni",
  "block.minecraft.deepslate_bricks": "Bodneráktomuvra",
  "block.minecraft.deepslate_coal_ore": "Bodneráktokoallamálbma",
  "block.minecraft.deepslate_copper_ore": "Bodneráktoveaikemálbma",
  "block.minecraft.deepslate_diamond_ore": "Bodneráktodiamántamálbma",
  "block.minecraft.deepslate_emerald_ore": "Bodneráktoemeraldamálbma",
  "block.minecraft.deepslate_gold_ore": "Bodneráktogollemálbma",
  "block.minecraft.deepslate_iron_ore": "Bodneráktoruovdemálbma",
  "block.minecraft.deepslate_lapis_ore": "Bodneráktolasuramálbma",
  "block.minecraft.deepslate_redstone_ore": "Bodneráktoredstonemálbma",
  "block.minecraft.deepslate_tile_slab": "Bodneráktotiilapláhtta",
  "block.minecraft.deepslate_tile_stairs": "Bodneráktotiilatráhppá",
  "block.minecraft.deepslate_tile_wall": "Bodneráktotiilaseaidni",
  "block.minecraft.deepslate_tiles": "Bodneráktotiila",
  "block.minecraft.detector_rail": "Iskkan Ruovdemáđđi",
  "block.minecraft.diamond_block": "Diamántablohkka",
  "block.minecraft.diamond_ore": "Diamántamálbma",
  "block.minecraft.diorite": "Diorihtta",
  "block.minecraft.diorite_slab": "Diorihttapláhtta",
  "block.minecraft.diorite_stairs": "Diorihttatráhppá",
  "block.minecraft.diorite_wall": "Diorihtta Seaidni",
  "block.minecraft.dirt": "Eana",
  "block.minecraft.dirt_path": "Bálggis",
  "block.minecraft.dispenser": "Bážán",
  "block.minecraft.dragon_egg": "Drágemonni",
  "block.minecraft.dragon_head": "Dollalaggá oaivi",
  "block.minecraft.dragon_wall_head": "Dollalaggá seaidneoaivi",
  "block.minecraft.dried_ghast": "Goikan Ghast",
  "block.minecraft.dried_kelp_block": "Goikoduvvon Stárrablohkka",
  "block.minecraft.dripstone_block": "Goaikogeađgeblohkka",
  "block.minecraft.dropper": "Luoiti",
  "block.minecraft.emerald_block": "Emeraldablohkka",
  "block.minecraft.emerald_ore": "Emeraldamálbma",
  "block.minecraft.enchanting_table": "Noaidunbeavdi",
  "block.minecraft.end_gateway": "Endorverrát",
  "block.minecraft.end_portal": "Endorportála",
  "block.minecraft.end_portal_frame": "Endorportálarámma",
  "block.minecraft.end_rod": "Endorsággi",
  "block.minecraft.end_stone": "Endorgeađgi",
  "block.minecraft.end_stone_brick_slab": "Endorgeađgemuvrabealli",
  "block.minecraft.end_stone_brick_stairs": "Endor Geađgemuvratráhppá",
  "block.minecraft.end_stone_brick_wall": "Endor Geađgemuvra Seaidni",
  "block.minecraft.end_stone_bricks": "Endorgeađgemuvra",
  "block.minecraft.ender_chest": "Endorgiisá",
  "block.minecraft.exposed_chiseled_copper": "Suojehis luokčajuvvon veaiki",
  "block.minecraft.exposed_copper": "Suojehis veaiki",
  "block.minecraft.exposed_copper_bars": "Suojehis veaikegiddagas",
  "block.minecraft.exposed_copper_bulb": "Suojehis veaikelámpá",
  "block.minecraft.exposed_copper_chain": "Suojehis veaikeláhkki",
  "block.minecraft.exposed_copper_chest": "Suojehis veaikegiisá",
  "block.minecraft.exposed_copper_door": "Suojehis veaikeuksa",
  "block.minecraft.exposed_copper_golem_statue": "Suojehis veaikehálddi bázzi",
  "block.minecraft.exposed_copper_grate": "Suojehis veaikeráspa",
  "block.minecraft.exposed_copper_lantern": "Suojehis veaikelámpá",
  "block.minecraft.exposed_copper_trapdoor": "Suojehis veaikeluŋká",
  "block.minecraft.exposed_cut_copper": "Suojehis čuhppon veaiki",
  "block.minecraft.exposed_cut_copper_slab": "Suojehis čuhppon veaikebealli",
  "block.minecraft.exposed_cut_copper_stairs": "Suojehis čuhppon veaiketráhppát",
  "block.minecraft.exposed_lightning_rod": "Suojehis álddagasa dustensoabbi",
  "block.minecraft.farmland": "Gilvineana",
  "block.minecraft.fern": "Gáiski",
  "block.minecraft.fire": "Dolla",
  "block.minecraft.fire_coral": "Dolla Korálla",
  "block.minecraft.fire_coral_block": "Dolla Korallablohkka",
  "block.minecraft.fire_coral_fan": "Dolla Koralla Fan",
  "block.minecraft.fire_coral_wall_fan": "Dolla Koralla Libardahtti",
  "block.minecraft.firefly_bush": "Dollačurotmiestta",
  "block.minecraft.fletching_table": "Njuollabeavdi",
  "block.minecraft.flower_pot": "Lieđđekruhkku",
  "block.minecraft.flowering_azalea": "Lieđđudeaddji asalea",
  "block.minecraft.flowering_azalea_leaves": "Lieđđudeaddji asalealasttat",
  "block.minecraft.frogspawn": "Šlubboaivemonit",
  "block.minecraft.frosted_ice": "Ruosttajiekŋa",
  "block.minecraft.furnace": "Uvdna",
  "block.minecraft.gilded_blackstone": "Gollás Čáhppesgeađgi",
  "block.minecraft.glass": "Glássa",
  "block.minecraft.glass_pane": "Glássaruvtto",
  "block.minecraft.glow_lichen": "Áhcagas jeagil",
  "block.minecraft.glowstone": "Čuovgageađgi",
  "block.minecraft.gold_block": "Golleblohkka",
  "block.minecraft.gold_ore": "Gollemálbma",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Granihtta",
  "block.minecraft.granite_slab": "Granihttapláhtta",
  "block.minecraft.granite_stairs": "Granihttatráhppá",
  "block.minecraft.granite_wall": "Granihtta Seaidni",
  "block.minecraft.grass": "Suoidni",
  "block.minecraft.grass_block": "Suoidneblohkka",
  "block.minecraft.gravel": "Čievra",
  "block.minecraft.gray_banner": "Ránes Leavga",
  "block.minecraft.gray_bed": "Ránes Seaŋga",
  "block.minecraft.gray_candle": "Ránes ginttal",
  "block.minecraft.gray_candle_cake": "Gáhkku ránis gintaliin",
  "block.minecraft.gray_carpet": "Ránes Láhtterátnu",
  "block.minecraft.gray_concrete": "Ránes betoŋŋa",
  "block.minecraft.gray_concrete_powder": "Ránes betoŋŋabulvvar",
  "block.minecraft.gray_glazed_terracotta": "Ránes šelges terrakotta",
  "block.minecraft.gray_shulker_box": "Ránes Shulkerboksa",
  "block.minecraft.gray_stained_glass": "Ránes Glássa",
  "block.minecraft.gray_stained_glass_pane": "Ránes Glássaruvtto",
  "block.minecraft.gray_terracotta": "Ránes terrakotta",
  "block.minecraft.gray_wool": "Ránes Ullu",
  "block.minecraft.green_banner": "Ruoná Leavga",
  "block.minecraft.green_bed": "Ruoná Seaŋga",
  "block.minecraft.green_candle": "Ruoná ginttal",
  "block.minecraft.green_candle_cake": "Gáhkku ruoná gintaliin",
  "block.minecraft.green_carpet": "Ruoná Láhtterátnu",
  "block.minecraft.green_concrete": "Ruoná betoŋŋa",
  "block.minecraft.green_concrete_powder": "Ruoná betoŋŋabulvvar",
  "block.minecraft.green_glazed_terracotta": "Ruoná šelges terrakotta",
  "block.minecraft.green_shulker_box": "Ruoná Shulkerboksa",
  "block.minecraft.green_stained_glass": "Ruoná Glássa",
  "block.minecraft.green_stained_glass_pane": "Ruoná Glássaruvtto",
  "block.minecraft.green_terracotta": "Ruoná terrakotta",
  "block.minecraft.green_wool": "Ruoná Ullu",
  "block.minecraft.grindstone": "Sadjingeađgi",
  "block.minecraft.hanging_roots": "Sluŋkeruohttasat",
  "block.minecraft.hay_block": "Suoidnegubá",
  "block.minecraft.heavy_core": "Lossa guovddáš",
  "block.minecraft.heavy_weighted_pressure_plate": "Lossadeattupláhtta",
  "block.minecraft.honey_block": "Honnetblohkka",
  "block.minecraft.honeycomb_block": "Honnetbihttáblohkka",
  "block.minecraft.hopper": "Njammi",
  "block.minecraft.horn_coral": "Čoarve korálla",
  "block.minecraft.horn_coral_block": "Čoarvvás Korallablohkka",
  "block.minecraft.horn_coral_fan": "Čoarvvás Koralla Fan",
  "block.minecraft.horn_coral_wall_fan": "Čoarvvás Koralla Libardahtti",
  "block.minecraft.ice": "Jiekŋa",
  "block.minecraft.infested_chiseled_stone_bricks": "Njommon Luokčajuvvon Geađgemuvra",
  "block.minecraft.infested_cobblestone": "Njommon luoddageađgi",
  "block.minecraft.infested_cracked_stone_bricks": "Njommon Luoddanan Geađgemuvra",
  "block.minecraft.infested_deepslate": "Njommon Bodneráktu",
  "block.minecraft.infested_mossy_stone_bricks": "Njommon jeagilduvvan geađgemuvra",
  "block.minecraft.infested_stone": "Njommongeađgi",
  "block.minecraft.infested_stone_bricks": "Njommon Geađgemuvra",
  "block.minecraft.iron_bars": "Ruovdegiddagas",
  "block.minecraft.iron_block": "Ruovdeblohkka",
  "block.minecraft.iron_chain": "Ruovdeláhkki",
  "block.minecraft.iron_door": "Ruovdeuksa",
  "block.minecraft.iron_ore": "Ruovdemálbma",
  "block.minecraft.iron_trapdoor": "Ruovdeluŋká",
  "block.minecraft.jack_o_lantern": "Gurbbetčuovga",
  "block.minecraft.jigsaw": "Ásahanblohkka",
  "block.minecraft.jukebox": "Skearročuojanas",
  "block.minecraft.jungle_button": "Suhkkesvuovdeboallu",
  "block.minecraft.jungle_door": "Suhkkesvuvdemuorrauksa",
  "block.minecraft.jungle_fence": "Suhkkesvuovdeáidi",
  "block.minecraft.jungle_fence_gate": "Suhkkesvuovdeverrát",
  "block.minecraft.jungle_hanging_sign": "Heŋgejuvvon suhkkesvuovdegalba",
  "block.minecraft.jungle_leaves": "Suhkkesvuovdelasttat",
  "block.minecraft.jungle_log": "Suhkkesvuovdebelko",
  "block.minecraft.jungle_planks": "Suhkkesvuovdefiellut",
  "block.minecraft.jungle_pressure_plate": "Suhkkesvuovdedeattopláhtta",
  "block.minecraft.jungle_sapling": "Suhkkesvuovdemuoraš",
  "block.minecraft.jungle_shelf": "Suhkkesvuovdemuorrahildu",
  "block.minecraft.jungle_sign": "Suhkkesvuovdegalba",
  "block.minecraft.jungle_slab": "Suhkkesvuovdepláhtta",
  "block.minecraft.jungle_stairs": "Suhkkesvuovdetráhppá",
  "block.minecraft.jungle_trapdoor": "Suhkkesvuovdeluŋká",
  "block.minecraft.jungle_wall_hanging_sign": "Heŋgejuvvon suhkkesvuovdegalba seainnis",
  "block.minecraft.jungle_wall_sign": "Heŋgojuvvon Suhkkesvuovdegalba",
  "block.minecraft.jungle_wood": "Suhkkesvuovdemuorra",
  "block.minecraft.kelp": "Stárra",
  "block.minecraft.kelp_plant": "Stárra",
  "block.minecraft.ladder": "Ráidalas",
  "block.minecraft.lantern": "Lámpá",
  "block.minecraft.lapis_block": "Lasurablohkka",
  "block.minecraft.lapis_ore": "Lasuramálbma",
  "block.minecraft.large_amethyst_bud": "Stuora ametistaurbi",
  "block.minecraft.large_fern": "Stuora Gáiski",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Lavaruitu",
  "block.minecraft.leaf_litter": "Gahččan goikelasttat",
  "block.minecraft.lectern": "Sárdnestuollu",
  "block.minecraft.lever": "Geavja",
  "block.minecraft.light": "Čuovga",
  "block.minecraft.light_blue_banner": "Čuvgesalit Leavga",
  "block.minecraft.light_blue_bed": "Čuvgesalit Seaŋga",
  "block.minecraft.light_blue_candle": "Čuvgesalit ginttal",
  "block.minecraft.light_blue_candle_cake": "Gáhkku čuvgesalit gintaliin",
  "block.minecraft.light_blue_carpet": "Čuvgesalit Láhtterátnu",
  "block.minecraft.light_blue_concrete": "Čuvgesalit betoŋŋa",
  "block.minecraft.light_blue_concrete_powder": "Čuvgesalit betoŋŋabulvvar",
  "block.minecraft.light_blue_glazed_terracotta": "Čuvgesalit šelges terrakotta",
  "block.minecraft.light_blue_shulker_box": "Čuvgesalit Shulkerboksa",
  "block.minecraft.light_blue_stained_glass": "Čuvgesalit Glássa",
  "block.minecraft.light_blue_stained_glass_pane": "Čuvgesalit Glássaruvtto",
  "block.minecraft.light_blue_terracotta": "Čuvgesalit terrakotta",
  "block.minecraft.light_blue_wool": "Čuvgesalit Ullu",
  "block.minecraft.light_gray_banner": "Čuovgesránes Leavga",
  "block.minecraft.light_gray_bed": "Čuvgesránes Seaŋga",
  "block.minecraft.light_gray_candle": "Čuovgesránes ginttal",
  "block.minecraft.light_gray_candle_cake": "Gáhkku čuvgesránis gintaliin",
  "block.minecraft.light_gray_carpet": "Čuvgesránes Láhtterátnu",
  "block.minecraft.light_gray_concrete": "Čuvgesránes betoŋŋa",
  "block.minecraft.light_gray_concrete_powder": "Čuvgesránes betoŋŋabulvvar",
  "block.minecraft.light_gray_glazed_terracotta": "Čuvgesránes šelges terrakotta",
  "block.minecraft.light_gray_shulker_box": "Čuvgesránes Shulkerboksa",
  "block.minecraft.light_gray_stained_glass": "Čuvgesránes Glássa",
  "block.minecraft.light_gray_stained_glass_pane": "Čuvgesránes Glássaruvtto",
  "block.minecraft.light_gray_terracotta": "Čuvgesránes terrakotta",
  "block.minecraft.light_gray_wool": "Čuvgesránes Ullu",
  "block.minecraft.light_weighted_pressure_plate": "Geahpadeattupláhtta",
  "block.minecraft.lightning_rod": "Álddagasa dustensoabbi",
  "block.minecraft.lilac": "Siriidna",
  "block.minecraft.lily_of_the_valley": "Ávželieđđi",
  "block.minecraft.lily_pad": "Govdodanlieđđi",
  "block.minecraft.lime_banner": "Čuvgesruoná Leavga",
  "block.minecraft.lime_bed": "Čuvgesruoná Seaŋga",
  "block.minecraft.lime_candle": "Čuvgesruoná ginttal",
  "block.minecraft.lime_candle_cake": "Gáhkku čuvgesruoná gintaliin",
  "block.minecraft.lime_carpet": "Lime Láhtterátnu",
  "block.minecraft.lime_concrete": "Čuvgesruoná betoŋŋa",
  "block.minecraft.lime_concrete_powder": "Čuvgesruonaá betoŋŋabulvvar",
  "block.minecraft.lime_glazed_terracotta": "Čuvgesruoná šelges terrakotta",
  "block.minecraft.lime_shulker_box": "Čuvgesruoná Shulkerboksa",
  "block.minecraft.lime_stained_glass": "Čuvgesruoná Glássa",
  "block.minecraft.lime_stained_glass_pane": "Čuvgesruoná Glássaruvtto",
  "block.minecraft.lime_terracotta": "Čuvgesruoná terrakotta",
  "block.minecraft.lime_wool": "Čuvgesruoná Ullu",
  "block.minecraft.lodestone": "Láidengeađgi",
  "block.minecraft.loom": "Gákkesmuorat",
  "block.minecraft.magenta_banner": "Čuvgessáhppes Leavga",
  "block.minecraft.magenta_bed": "Čuvgessáhppes Seaŋga",
  "block.minecraft.magenta_candle": "Čuvgessáhppes ginttal",
  "block.minecraft.magenta_candle_cake": "Gáhkku čuvgessáhppes gintaliin",
  "block.minecraft.magenta_carpet": "Čuvgessáhppes Láhtterátnu",
  "block.minecraft.magenta_concrete": "Čuvgessáhppes betoŋŋa",
  "block.minecraft.magenta_concrete_powder": "Čuvgessáhppes betoŋŋabulvvar",
  "block.minecraft.magenta_glazed_terracotta": "Čuvgessáhppes šelges terrakotta",
  "block.minecraft.magenta_shulker_box": "Čuvgessáhppes Shulkerboksa",
  "block.minecraft.magenta_stained_glass": "Magenta Glássa",
  "block.minecraft.magenta_stained_glass_pane": "Magenta Glássaruvtto",
  "block.minecraft.magenta_terracotta": "Čuvgessáhppes terrakotta",
  "block.minecraft.magenta_wool": "Čuvgessáhppes Ullu",
  "block.minecraft.magma_block": "Magmablohkka",
  "block.minecraft.mangrove_button": "Mangroveboallu",
  "block.minecraft.mangrove_door": "Mangroveuksa",
  "block.minecraft.mangrove_fence": "Mangroveáidi",
  "block.minecraft.mangrove_fence_gate": "Mangroveverrát",
  "block.minecraft.mangrove_hanging_sign": "Heŋgejuvvon mangrovegalba",
  "block.minecraft.mangrove_leaves": "Mangrovelasttat",
  "block.minecraft.mangrove_log": "Mangrovebelko",
  "block.minecraft.mangrove_planks": "Mangrovefiellut",
  "block.minecraft.mangrove_pressure_plate": "Mangrovedeattopláhtta",
  "block.minecraft.mangrove_propagule": "Mangrovegilvva",
  "block.minecraft.mangrove_roots": "Mangroveruohttasat",
  "block.minecraft.mangrove_shelf": "Mangrovehildu",
  "block.minecraft.mangrove_sign": "Mangrovegalba",
  "block.minecraft.mangrove_slab": "Mangrovepláhtta",
  "block.minecraft.mangrove_stairs": "Mangrovetráhppát",
  "block.minecraft.mangrove_trapdoor": "Mangroveluŋká",
  "block.minecraft.mangrove_wall_hanging_sign": "Heŋgejuvvon mangrovegalba seainnis",
  "block.minecraft.mangrove_wall_sign": "Heŋgojuvvon Mangrovegalba",
  "block.minecraft.mangrove_wood": "Mangrovemuorra",
  "block.minecraft.medium_amethyst_bud": "Gaskasturrosaš ametistaurbi",
  "block.minecraft.melon": "Melovdna",
  "block.minecraft.melon_stem": "Meluvdna Máddu",
  "block.minecraft.moss_block": "Darfeblohkka",
  "block.minecraft.moss_carpet": "Darfegovččas",
  "block.minecraft.mossy_cobblestone": "Jeagilduvvan luoddageađgi",
  "block.minecraft.mossy_cobblestone_slab": "Jeagilduvvan luoddageađgebealli",
  "block.minecraft.mossy_cobblestone_stairs": "Jeagilduvvan luoddageađgetráhppá",
  "block.minecraft.mossy_cobblestone_wall": "Jeagilduvvan luoddageađgeseaidni",
  "block.minecraft.mossy_stone_brick_slab": "Jeagilduvvan geađgemuvrabealli",
  "block.minecraft.mossy_stone_brick_stairs": "Jeagilduvvan geađgemuvratráhppá",
  "block.minecraft.mossy_stone_brick_wall": "Jeagilduvvan geađgemuvraseaidni",
  "block.minecraft.mossy_stone_bricks": "Jeagilduvvan geađgemuvra",
  "block.minecraft.moving_piston": "Sirddašeamin Hoigadeaddji",
  "block.minecraft.mud": "Stánželáira",
  "block.minecraft.mud_brick_slab": "Garraláiramuvrapláhtta",
  "block.minecraft.mud_brick_stairs": "Garraláiramuvratráhppá",
  "block.minecraft.mud_brick_wall": "Garraláiramuvraseaidni",
  "block.minecraft.mud_bricks": "Garraláiramuvra",
  "block.minecraft.muddy_mangrove_roots": "Mohttás Mangroveruohttasat",
  "block.minecraft.mushroom_stem": "Guopparmáddu",
  "block.minecraft.mycelium": "Mirkoeana",
  "block.minecraft.nether_brick_fence": "Nethermuvraáidi",
  "block.minecraft.nether_brick_slab": "Nethermuvrabealli",
  "block.minecraft.nether_brick_stairs": "Nethermuvratráhppá",
  "block.minecraft.nether_brick_wall": "Nethermuvra Seaidni",
  "block.minecraft.nether_bricks": "Nethermuvra",
  "block.minecraft.nether_gold_ore": "Nether gollemálbma",
  "block.minecraft.nether_portal": "Nether Portála",
  "block.minecraft.nether_quartz_ore": "Netherkvárcamálbma",
  "block.minecraft.nether_sprouts": "Netherrahttá",
  "block.minecraft.nether_wart": "Netherspártu",
  "block.minecraft.nether_wart_block": "Nether Spártoblohkka",
  "block.minecraft.netherite_block": "Netheriitablohkka",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Nuohttablohkka",
  "block.minecraft.oak_button": "Eaikaboallu",
  "block.minecraft.oak_door": "Eaikauksa",
  "block.minecraft.oak_fence": "Eaikaáidi",
  "block.minecraft.oak_fence_gate": "Eaikaverrát",
  "block.minecraft.oak_hanging_sign": "Heŋgejuvvon eaikagalba",
  "block.minecraft.oak_leaves": "Eaikalasttat",
  "block.minecraft.oak_log": "Eaikabelko",
  "block.minecraft.oak_planks": "Eaikafiellut",
  "block.minecraft.oak_pressure_plate": "Eaikadeattopláhtta",
  "block.minecraft.oak_sapling": "Eaikamuoraš",
  "block.minecraft.oak_shelf": "Eaikahildu",
  "block.minecraft.oak_sign": "Eaikagalba",
  "block.minecraft.oak_slab": "Eaikapláhtta",
  "block.minecraft.oak_stairs": "Eaikatráhppá",
  "block.minecraft.oak_trapdoor": "Eaikaluŋká",
  "block.minecraft.oak_wall_hanging_sign": "Heŋgejuvvon eaikagalba seainnis",
  "block.minecraft.oak_wall_sign": "Heŋgojuvvon Eaikagalba",
  "block.minecraft.oak_wood": "Eaikamuorra",
  "block.minecraft.observer": "Áici",
  "block.minecraft.obsidian": "Obsidiána",
  "block.minecraft.ochre_froglight": "Okrasaš rihccecuoppočuovga",
  "block.minecraft.ominous_banner": "Bahávuoiŋŋa leavga",
  "block.minecraft.open_eyeblossom": "Rabas čalbmelieđđi",
  "block.minecraft.orange_banner": "Runta Leavga",
  "block.minecraft.orange_bed": "Runta Seaŋga",
  "block.minecraft.orange_candle": "Runta ginttal",
  "block.minecraft.orange_candle_cake": "Gáhkku runta gintaliin",
  "block.minecraft.orange_carpet": "Runta Láhtterátnu",
  "block.minecraft.orange_concrete": "Runta betoŋŋa",
  "block.minecraft.orange_concrete_powder": "Runta betoŋŋabulvvar",
  "block.minecraft.orange_glazed_terracotta": "Runta šelges terrakotta",
  "block.minecraft.orange_shulker_box": "Runta Shulkerboksa",
  "block.minecraft.orange_stained_glass": "Runta Glássa",
  "block.minecraft.orange_stained_glass_pane": "Runta Glássaruvtto",
  "block.minecraft.orange_terracotta": "Runta terrakotta",
  "block.minecraft.orange_tulip": "Runta Tulipána",
  "block.minecraft.orange_wool": "Runta Ullu",
  "block.minecraft.oxeye_daisy": "Báhpačehporas",
  "block.minecraft.oxidized_chiseled_copper": "Giimman luokčajuvvon veaiki",
  "block.minecraft.oxidized_copper": "Giimman veaiki",
  "block.minecraft.oxidized_copper_bars": "Giimman veaikegiddagas",
  "block.minecraft.oxidized_copper_bulb": "Giimman veaikelámpá",
  "block.minecraft.oxidized_copper_chain": "Giimman veaikeláhkki",
  "block.minecraft.oxidized_copper_chest": "Giimman veaikegiisá",
  "block.minecraft.oxidized_copper_door": "Giimman veaikeuksa",
  "block.minecraft.oxidized_copper_golem_statue": "Giimman veaikehálddi bázzi",
  "block.minecraft.oxidized_copper_grate": "Giimman veaikeráspa",
  "block.minecraft.oxidized_copper_lantern": "Giimman veaikelámpá",
  "block.minecraft.oxidized_copper_trapdoor": "Giimman veaikeluŋká",
  "block.minecraft.oxidized_cut_copper": "Giimman čuhppon veaiki",
  "block.minecraft.oxidized_cut_copper_slab": "Giimman čuhppon veaikebealli",
  "block.minecraft.oxidized_cut_copper_stairs": "Giimman čuhppon veaiketráhppát",
  "block.minecraft.oxidized_lightning_rod": "Giimman álddagasa dustensoabbi",
  "block.minecraft.packed_ice": "Garrajiekŋa",
  "block.minecraft.packed_mud": "Garraláira",
  "block.minecraft.pale_hanging_moss": "Šovkes sluŋkejeagil",
  "block.minecraft.pale_moss_block": "Šovkes darfeblohkka",
  "block.minecraft.pale_moss_carpet": "Šovkes darfegovččas",
  "block.minecraft.pale_oak_button": "Šovkes eaikaboallu",
  "block.minecraft.pale_oak_door": "Šovkes eaikauksa",
  "block.minecraft.pale_oak_fence": "Šovkes eaikaáidi",
  "block.minecraft.pale_oak_fence_gate": "Šovkes eaikaverrát",
  "block.minecraft.pale_oak_hanging_sign": "Šovkes eaikagalba seainnis",
  "block.minecraft.pale_oak_leaves": "Šovkes eaikalasttat",
  "block.minecraft.pale_oak_log": "Šovkes eaikabelko",
  "block.minecraft.pale_oak_planks": "Šovkes eaikafiellut",
  "block.minecraft.pale_oak_pressure_plate": "Šovkes eaikadeattopláhtta",
  "block.minecraft.pale_oak_sapling": "Šovkes eaikamuoraš",
  "block.minecraft.pale_oak_shelf": "Šovkes eaikahildu",
  "block.minecraft.pale_oak_sign": "Šovkes eaikagalba",
  "block.minecraft.pale_oak_slab": "Šovkes eaikapláhtta",
  "block.minecraft.pale_oak_stairs": "Šovkes eaikatráhppá",
  "block.minecraft.pale_oak_trapdoor": "Šovkes eaikaluŋká",
  "block.minecraft.pale_oak_wall_hanging_sign": "Heŋgejuvvon šovkes eaikagalba seainnis",
  "block.minecraft.pale_oak_wall_sign": "Heŋgojuvvon šovkes eaikagalba",
  "block.minecraft.pale_oak_wood": "Šovkes eaika",
  "block.minecraft.pearlescent_froglight": "Helbmosaš rihccecuoppočuovga",
  "block.minecraft.peony": "Piovdna",
  "block.minecraft.petrified_oak_slab": "Geađgás Eaikapláhtta",
  "block.minecraft.piglin_head": "Piglinoaivi",
  "block.minecraft.piglin_wall_head": "Piglin seaidneoaivi",
  "block.minecraft.pink_banner": "Čuvgesrukses Leavga",
  "block.minecraft.pink_bed": "Čuvgesrukses Seaŋga",
  "block.minecraft.pink_candle": "Guvgesruokses ginttal",
  "block.minecraft.pink_candle_cake": "Gáhkku čuvgesrukses gintaliin",
  "block.minecraft.pink_carpet": "Vilgesruokses Láhtterátnu",
  "block.minecraft.pink_concrete": "Čuvgesrukses betoŋŋa",
  "block.minecraft.pink_concrete_powder": "Čuvgesrukses betoŋŋabulvvar",
  "block.minecraft.pink_glazed_terracotta": "Vilgesrukses šelges terrakotta",
  "block.minecraft.pink_petals": "Rosa lieđđelasta",
  "block.minecraft.pink_shulker_box": "Čuvgesrukses Shulkerboksa",
  "block.minecraft.pink_stained_glass": "Čuvgesruoksat Glássa",
  "block.minecraft.pink_stained_glass_pane": "Čuvgesrukses Glássaruvtto",
  "block.minecraft.pink_terracotta": "Rosa terrakotta",
  "block.minecraft.pink_tulip": "Čuvgesrukses Tulipána",
  "block.minecraft.pink_wool": "Čuvgesrukses ullu",
  "block.minecraft.piston": "Hoigi",
  "block.minecraft.piston_head": "Hoigadeaddji Oaivi",
  "block.minecraft.pitcher_crop": "Muggarássegilvva",
  "block.minecraft.pitcher_plant": "Muggarássi",
  "block.minecraft.player_head": "Spealleoaivi",
  "block.minecraft.player_head.named": "%s Oaivi",
  "block.minecraft.player_wall_head": "Heŋgojuvvon Spealleoaivi",
  "block.minecraft.podzol": "Podsola",
  "block.minecraft.pointed_dripstone": "Goaikogeađgecuipi",
  "block.minecraft.polished_andesite": "Bussejuvvon Ándasihtta",
  "block.minecraft.polished_andesite_slab": "Bussejuvvon Ándasihttapláhtta",
  "block.minecraft.polished_andesite_stairs": "Bussejuvvon Ándasihttatráhppá",
  "block.minecraft.polished_basalt": "Bussejuvvon Basaltta",
  "block.minecraft.polished_blackstone": "Bussejuvvon Čáhppesgeađgi",
  "block.minecraft.polished_blackstone_brick_slab": "Bussejuvvon Čáhppesgeađgemuvrapláhtta",
  "block.minecraft.polished_blackstone_brick_stairs": "Bussejuvvon Čáhppesgeađgemuvratráhppá",
  "block.minecraft.polished_blackstone_brick_wall": "Bussejuvvon Čáhppesgeađgemuvraseaidni",
  "block.minecraft.polished_blackstone_bricks": "Bussejuvvon Čáhppesgeađgemuvra",
  "block.minecraft.polished_blackstone_button": "Bussejuvvon Čáhppesgeađgeboallu",
  "block.minecraft.polished_blackstone_pressure_plate": "Bussejuvvon Čáhppesgeađgedeattopláhtta",
  "block.minecraft.polished_blackstone_slab": "Bussejuvvon Čáhppesgeađgepláhtta",
  "block.minecraft.polished_blackstone_stairs": "Bussejuvvon Čáhppesgeađgetráhppá",
  "block.minecraft.polished_blackstone_wall": "Bussejuvvon Čáhppesgeađge Seaidni",
  "block.minecraft.polished_deepslate": "Bussejuvvon Bodneráktu",
  "block.minecraft.polished_deepslate_slab": "Bussejuvvon Bodneráktopláhtta",
  "block.minecraft.polished_deepslate_stairs": "Bussejuvvon Bodneráktotráhppát",
  "block.minecraft.polished_deepslate_wall": "Bussejuvvon Bodneráktoseaidni",
  "block.minecraft.polished_diorite": "Bussejuvvon Diorihtta",
  "block.minecraft.polished_diorite_slab": "Bussejuvvon Diorihttapláhtta",
  "block.minecraft.polished_diorite_stairs": "Bussejuvvon Diorihttatráhppá",
  "block.minecraft.polished_granite": "Bussejuvvon Granihtta",
  "block.minecraft.polished_granite_slab": "Bussejuvvon Granihttapláhtta",
  "block.minecraft.polished_granite_stairs": "Bussejuvvon Granihttatráhppá",
  "block.minecraft.polished_tuff": "Bussejuvvon tuffa",
  "block.minecraft.polished_tuff_slab": "Bussejuvvon tuffabealli",
  "block.minecraft.polished_tuff_stairs": "Bussejuvvon tuffatráhppát",
  "block.minecraft.polished_tuff_wall": "Bussejuvvon tuffaseaidni",
  "block.minecraft.poppy": "Ajerássi",
  "block.minecraft.potatoes": "Buđehat",
  "block.minecraft.potted_acacia_sapling": "Gilvojuvvon acaciamuoraš",
  "block.minecraft.potted_allium": "Gilvojuvvon ruksesluovvar",
  "block.minecraft.potted_azalea_bush": "Gilvojuvvon asalea",
  "block.minecraft.potted_azure_bluet": "Gilvojuvvon nuorsá",
  "block.minecraft.potted_bamboo": "Gilvojuvvon bamboa",
  "block.minecraft.potted_birch_sapling": "Gilvojuvvon soagáš",
  "block.minecraft.potted_blue_orchid": "Gilvojuvvon alit orkidéa",
  "block.minecraft.potted_brown_mushroom": "Gilvojuvvon ruškesguoppar",
  "block.minecraft.potted_cactus": "Gilvojuvvon káktus",
  "block.minecraft.potted_cherry_sapling": "Gilvojuvvon kirsamuorjemuoraš",
  "block.minecraft.potted_closed_eyeblossom": "Giddanan čalbmelieđđi kruhkas",
  "block.minecraft.potted_cornflower": "Gilvojuvvon rohkarássi",
  "block.minecraft.potted_crimson_fungus": "Gilvojuvvon skárllatguoppar",
  "block.minecraft.potted_crimson_roots": "Gilvojuvvon skárllatruohttasat",
  "block.minecraft.potted_dandelion": "Gilvojuvvon uvlorássi",
  "block.minecraft.potted_dark_oak_sapling": "Gilvojuvvon Sevdnjes Eaikamuoraš",
  "block.minecraft.potted_dead_bush": "Gilvojuvvon goikemiestta",
  "block.minecraft.potted_fern": "Gilvojuvvon gáiska",
  "block.minecraft.potted_flowering_azalea_bush": "Gilvojuvvon lieđđudeaddji asalea",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Gilvos Suhkesvuovdemuoraš",
  "block.minecraft.potted_lily_of_the_valley": "Gilvojuvvon ávželieđđi",
  "block.minecraft.potted_mangrove_propagule": "Gilvojuvvon mangrovemuoraš",
  "block.minecraft.potted_oak_sapling": "Gilvojuvvon eaikkaš",
  "block.minecraft.potted_open_eyeblossom": "Rahpasan čalbmelieđđi kruhkas",
  "block.minecraft.potted_orange_tulip": "Gilvojuvvon runta tulipána",
  "block.minecraft.potted_oxeye_daisy": "Gilvojuvvon báhpačehporas",
  "block.minecraft.potted_pale_oak_sapling": "Gilvojuvvon šovkes eaikamuoraš",
  "block.minecraft.potted_pink_tulip": "Gilvojuvvon čuvgesrukses tulipána",
  "block.minecraft.potted_poppy": "Gilvojuvvon ajerássi",
  "block.minecraft.potted_red_mushroom": "Gilvojuvvon Ruksesguoppar",
  "block.minecraft.potted_red_tulip": "Gilvojuvvon rukses tulipána",
  "block.minecraft.potted_spruce_sapling": "Gilvojuvvon guosaš",
  "block.minecraft.potted_torchflower": "Gilvojuvvon spáddárlieđđi",
  "block.minecraft.potted_warped_fungus": "Gilvojuvvon Bonjoguoppar",
  "block.minecraft.potted_warped_roots": "Gilvojuvvon Bonjoruohttasat",
  "block.minecraft.potted_white_tulip": "Gilvojuvvon vilges tulipána",
  "block.minecraft.potted_wither_rose": "Gilvojuvvon witherrosa",
  "block.minecraft.powder_snow": "Oppas",
  "block.minecraft.powder_snow_cauldron": "Oppasruitu",
  "block.minecraft.powered_rail": "Rávdnjás ruovdemáđđi",
  "block.minecraft.prismarine": "Prismariidna",
  "block.minecraft.prismarine_brick_slab": "Prismariidnamuvrapláhtta",
  "block.minecraft.prismarine_brick_stairs": "Prismariidnamuvratráhppá",
  "block.minecraft.prismarine_bricks": "Prismariidnamuvra",
  "block.minecraft.prismarine_slab": "Prismariidnapláhtta",
  "block.minecraft.prismarine_stairs": "Prismariidnatráhppá",
  "block.minecraft.prismarine_wall": "Prismariidnaseaidni",
  "block.minecraft.pumpkin": "Gurbbet",
  "block.minecraft.pumpkin_stem": "Murbbet Máddu",
  "block.minecraft.purple_banner": "Sáhppes Leavga",
  "block.minecraft.purple_bed": "Sáhppes Seaŋga",
  "block.minecraft.purple_candle": "Sáhppes ginttal",
  "block.minecraft.purple_candle_cake": "Gáhkku sáhppes gintaliin",
  "block.minecraft.purple_carpet": "Sáhppes Láhtterátnu",
  "block.minecraft.purple_concrete": "Sáhppes betoŋŋa",
  "block.minecraft.purple_concrete_powder": "Sáhppes betoŋŋabulvvar",
  "block.minecraft.purple_glazed_terracotta": "Sáhppes šelges terrakotta",
  "block.minecraft.purple_shulker_box": "Sáhppes Shulkerboksa",
  "block.minecraft.purple_stained_glass": "Sáhppes Glássa",
  "block.minecraft.purple_stained_glass_pane": "Sáhppes Glássaruvtto",
  "block.minecraft.purple_terracotta": "Sáhppes terrakotta",
  "block.minecraft.purple_wool": "Sáhppes Ullu",
  "block.minecraft.purpur_block": "Purpurblohkka",
  "block.minecraft.purpur_pillar": "Purpurstoalpu",
  "block.minecraft.purpur_slab": "Purpurpláhtta",
  "block.minecraft.purpur_stairs": "Purpurtráhppá",
  "block.minecraft.quartz_block": "Kvárcablohkka",
  "block.minecraft.quartz_bricks": "Kvarcamuvra",
  "block.minecraft.quartz_pillar": "Kvárcastoalpu",
  "block.minecraft.quartz_slab": "Kvárcapláhtta",
  "block.minecraft.quartz_stairs": "Kvárcatráhppá",
  "block.minecraft.rail": "Ruovdemáđđi",
  "block.minecraft.raw_copper_block": "Roavvaveaikeblohkka",
  "block.minecraft.raw_gold_block": "Roavvagolleblohkka",
  "block.minecraft.raw_iron_block": "Roavvaruovdeblohkka",
  "block.minecraft.red_banner": "Rukses Leavga",
  "block.minecraft.red_bed": "Rukses Seaŋga",
  "block.minecraft.red_candle": "Rukses ginttal",
  "block.minecraft.red_candle_cake": "Gáhkku rukses gintaliin",
  "block.minecraft.red_carpet": "Rukses Láhtterátnu",
  "block.minecraft.red_concrete": "Rukses betoŋŋa",
  "block.minecraft.red_concrete_powder": "Rukses betoŋŋabulvvar",
  "block.minecraft.red_glazed_terracotta": "Rukses šelges terrakotta",
  "block.minecraft.red_mushroom": "Rukses guoppar",
  "block.minecraft.red_mushroom_block": "Rukses guopparblohkka",
  "block.minecraft.red_nether_brick_slab": "Rukses nethermuvrabealli",
  "block.minecraft.red_nether_brick_stairs": "Rukses Nethermuvratráhppá",
  "block.minecraft.red_nether_brick_wall": "Rukses Nethermuvra Seaidni",
  "block.minecraft.red_nether_bricks": "Rukses Nethermuvra",
  "block.minecraft.red_sand": "Ruksessáttu",
  "block.minecraft.red_sandstone": "﻿Rukses Sáttogeađgi",
  "block.minecraft.red_sandstone_slab": "Rukses Sáttogeađgepláhtta",
  "block.minecraft.red_sandstone_stairs": "Rukses sáttogeađgetráhppá",
  "block.minecraft.red_sandstone_wall": "Ruksessáttogeađge Seaidni",
  "block.minecraft.red_shulker_box": "Rukses Shulkerboksa",
  "block.minecraft.red_stained_glass": "Rukses Glássa",
  "block.minecraft.red_stained_glass_pane": "Rukses Glássaruvtto",
  "block.minecraft.red_terracotta": "Rukses terrakotta",
  "block.minecraft.red_tulip": "Rukses Tulipána",
  "block.minecraft.red_wool": "Rukses ullu",
  "block.minecraft.redstone_block": "Redstoneblohkka",
  "block.minecraft.redstone_lamp": "Redstonečuovga",
  "block.minecraft.redstone_ore": "Redstonemálbma",
  "block.minecraft.redstone_torch": "Redstonespáiddar",
  "block.minecraft.redstone_wall_torch": "Redstone seaidnespáiddar",
  "block.minecraft.redstone_wire": "Redstonebáddi",
  "block.minecraft.reinforced_deepslate": "Nanosmuvvan Bodneráktu",
  "block.minecraft.repeater": "Redstone geardduheaddji",
  "block.minecraft.repeating_command_block": "Geardduheaddji kommándoblohkka",
  "block.minecraft.resin_block": "Gáhččeblohkka",
  "block.minecraft.resin_brick_slab": "Gáhččemuvrabealli",
  "block.minecraft.resin_brick_stairs": "Gáhččemuvratráhppá",
  "block.minecraft.resin_brick_wall": "Gáhččemuvraseaidni",
  "block.minecraft.resin_bricks": "Gáhččemuvra",
  "block.minecraft.resin_clump": "Gáhččečoaltu",
  "block.minecraft.respawn_anchor": "Ealáskanáŋkor",
  "block.minecraft.rooted_dirt": "Ruohtaseana",
  "block.minecraft.rose_bush": "Rosamiestta",
  "block.minecraft.sand": "Sáttu",
  "block.minecraft.sandstone": "Sáttogeađgi",
  "block.minecraft.sandstone_slab": "Sáttogeađgepláhtta",
  "block.minecraft.sandstone_stairs": "Sáttogeađgetráhppá",
  "block.minecraft.sandstone_wall": "Sáttogeađge Seaidni",
  "block.minecraft.scaffolding": "Luovvi",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk-katalysáhtor",
  "block.minecraft.sculk_sensor": "Sculk-dovddan",
  "block.minecraft.sculk_shrieker": "Sculk-riehči",
  "block.minecraft.sculk_vein": "Sculk-suotna",
  "block.minecraft.sea_lantern": "Mearračuovga",
  "block.minecraft.sea_pickle": "Mearrašaddu",
  "block.minecraft.seagrass": "Debbot",
  "block.minecraft.set_spawn": "Ealáskanbáiki bidjon",
  "block.minecraft.short_dry_grass": "Oanehis goikerásit",
  "block.minecraft.short_grass": "Oanehis rásit",
  "block.minecraft.shroomlight": "Guopparčuovga",
  "block.minecraft.shulker_box": "Shulkerboksa",
  "block.minecraft.skeleton_skull": "Dákterikki Oaiveskálžu",
  "block.minecraft.skeleton_wall_skull": "Dákterikki Seaindeoaiveskálžu",
  "block.minecraft.slime_block": "Njivleblohkka",
  "block.minecraft.small_amethyst_bud": "Unna ametistaurbi",
  "block.minecraft.small_dripleaf": "Unna goaikolasta",
  "block.minecraft.smithing_table": "Rávdebádjebeavdi",
  "block.minecraft.smoker": "Suovastanuvdna",
  "block.minecraft.smooth_basalt": "Fiinna basalta",
  "block.minecraft.smooth_quartz": "Livttis Kvárcablohkka",
  "block.minecraft.smooth_quartz_slab": "Livttis Kvárcapláhtta",
  "block.minecraft.smooth_quartz_stairs": "Livttis Kvárcatráhppá",
  "block.minecraft.smooth_red_sandstone": "Livttis Rukses Sáttogeađgi",
  "block.minecraft.smooth_red_sandstone_slab": "Livttis Rukses Sáttogeađgepláhtta",
  "block.minecraft.smooth_red_sandstone_stairs": "Livttis Rukses Sáttogeađgetráhppá",
  "block.minecraft.smooth_sandstone": "Livttis Sáttogeađgi",
  "block.minecraft.smooth_sandstone_slab": "Livttis Sáttogeađgepláhta",
  "block.minecraft.smooth_sandstone_stairs": "Livttis Sáttogeađgetráhppá",
  "block.minecraft.smooth_stone": "Fiinna geađgi",
  "block.minecraft.smooth_stone_slab": "Livttis Geađgepláhtta",
  "block.minecraft.sniffer_egg": "Suosti monni",
  "block.minecraft.snow": "Muohta",
  "block.minecraft.snow_block": "Muohtablohkka",
  "block.minecraft.soul_campfire": "Siellodollagáddi",
  "block.minecraft.soul_fire": "Siellodolla",
  "block.minecraft.soul_lantern": "Siellolámpá",
  "block.minecraft.soul_sand": "Siellosáttu",
  "block.minecraft.soul_soil": "Sielloeana",
  "block.minecraft.soul_torch": "Siellospáiddar",
  "block.minecraft.soul_wall_torch": "Siello Seaidnespáiddár",
  "block.minecraft.spawn.not_valid": "Dus ii leat ruovttuseaŋga dahje devdon ealáskanáŋkor, dahje juobbá lei caggon",
  "block.minecraft.spawner": "Stálloealáskahtti",
  "block.minecraft.spawner.desc1": "Geavat ealáskanmoni:",
  "block.minecraft.spawner.desc2": "Bidját guđe ealli ealáska",
  "block.minecraft.sponge": "Guopparas",
  "block.minecraft.spore_blossom": "Iđuslieđđi",
  "block.minecraft.spruce_button": "Guossaboallu",
  "block.minecraft.spruce_door": "Guossauksa",
  "block.minecraft.spruce_fence": "Guossaáidi",
  "block.minecraft.spruce_fence_gate": "Guossaverrát",
  "block.minecraft.spruce_hanging_sign": "Heŋgejuvvon guossagalba",
  "block.minecraft.spruce_leaves": "Guossalasttat",
  "block.minecraft.spruce_log": "Guossabelko",
  "block.minecraft.spruce_planks": "Guossafiellut",
  "block.minecraft.spruce_pressure_plate": "Guossadeattopláhtta",
  "block.minecraft.spruce_sapling": "Guossamuoraš",
  "block.minecraft.spruce_shelf": "Guossahildu",
  "block.minecraft.spruce_sign": "Guossagalba",
  "block.minecraft.spruce_slab": "Guossapláhtta",
  "block.minecraft.spruce_stairs": "Guossatráhppá",
  "block.minecraft.spruce_trapdoor": "Guossaluŋká",
  "block.minecraft.spruce_wall_hanging_sign": "Heŋgejuvvon guossagalba seainnis",
  "block.minecraft.spruce_wall_sign": "Heŋgojuvvon Guossagalba",
  "block.minecraft.spruce_wood": "Guossamuorra",
  "block.minecraft.sticky_piston": "Njivllas hoigi",
  "block.minecraft.stone": "Geađgi",
  "block.minecraft.stone_brick_slab": "Geađgemuvrapláhtta",
  "block.minecraft.stone_brick_stairs": "Geađgemuvratráhppá",
  "block.minecraft.stone_brick_wall": "Geađgemuvra Seaidni",
  "block.minecraft.stone_bricks": "Geađgemuvra",
  "block.minecraft.stone_button": "Geađgeboallu",
  "block.minecraft.stone_pressure_plate": "Geađgedeattopláhtta",
  "block.minecraft.stone_slab": "Geađgepláhtta",
  "block.minecraft.stone_stairs": "Geađgetráhppá",
  "block.minecraft.stonecutter": "Geađgečuohppi",
  "block.minecraft.stripped_acacia_log": "Vullojuvvon Acaciabelko",
  "block.minecraft.stripped_acacia_wood": "Vullojuvvon Acaciamuorra",
  "block.minecraft.stripped_bamboo_block": "Ferkojuvvon bámbublohkka",
  "block.minecraft.stripped_birch_log": "Vullojuvvon Soahkebelko",
  "block.minecraft.stripped_birch_wood": "Vullojuvvon Soahkemuorra",
  "block.minecraft.stripped_cherry_log": "Vullojuvvon kirsamuorjemuorrabelko",
  "block.minecraft.stripped_cherry_wood": "Vullojuvvon kirsamuorjemuorra",
  "block.minecraft.stripped_crimson_hyphae": "Vullojuvvon Skárllatsuorus",
  "block.minecraft.stripped_crimson_stem": "Vullojuvvon Skárllatađđa",
  "block.minecraft.stripped_dark_oak_log": "Vullojuvvon Sevdnjes Eaikabelko",
  "block.minecraft.stripped_dark_oak_wood": "Vullojuvvon Sevdnjes Eaikamuorra",
  "block.minecraft.stripped_jungle_log": "Vullojuvvon Suhkkesvuovdebelko",
  "block.minecraft.stripped_jungle_wood": "Vullojuvvon Suhkkesvuovdemuorra",
  "block.minecraft.stripped_mangrove_log": "Vullojuvvon Mangrovebelko",
  "block.minecraft.stripped_mangrove_wood": "Vullojuvvon Mangrovemuorra",
  "block.minecraft.stripped_oak_log": "Vullojuvvon Eaikabelko",
  "block.minecraft.stripped_oak_wood": "Vullojuvvon Eaikamuorra",
  "block.minecraft.stripped_pale_oak_log": "Vullojuvvon šovkes eaikabelko",
  "block.minecraft.stripped_pale_oak_wood": "Vullojuvvon šovkes eaika",
  "block.minecraft.stripped_spruce_log": "Vullojuvvon Guossabelko",
  "block.minecraft.stripped_spruce_wood": "Vullojuvvon Guossamuorra",
  "block.minecraft.stripped_warped_hyphae": "Vullojuvvon Bonjosuorus",
  "block.minecraft.stripped_warped_stem": "Vullojuvvon Bonjonađđa",
  "block.minecraft.structure_block": "Huskehusblohkka",
  "block.minecraft.structure_void": "Guorossadji huksehusas",
  "block.minecraft.sugar_cane": "Sohkargoalšu",
  "block.minecraft.sunflower": "Beaivvášlieđđi",
  "block.minecraft.suspicious_gravel": "Imašlaš čievra",
  "block.minecraft.suspicious_sand": "Imašlaš sáttu",
  "block.minecraft.sweet_berry_bush": "Váranmiestta",
  "block.minecraft.tall_dry_grass": "Alla goikerásit",
  "block.minecraft.tall_grass": "Alla Suoidni",
  "block.minecraft.tall_seagrass": "Allá debbot",
  "block.minecraft.target": "Deaivvus",
  "block.minecraft.terracotta": "Terrakotta",
  "block.minecraft.test_block": "Iskkadanblohkka",
  "block.minecraft.test_instance_block": "Dáhpáhusaid iskkadanblohkka",
  "block.minecraft.tinted_glass": "Seđđes láse",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT-bávkaleamit leat jáddaduvvon",
  "block.minecraft.torch": "Spáiddar",
  "block.minecraft.torchflower": "Spáiddárlieđđi",
  "block.minecraft.torchflower_crop": "Spáiddárlieđđegilvva",
  "block.minecraft.trapped_chest": "Darvvihahttingiisá",
  "block.minecraft.trial_spawner": "Geahččalusealáskahtti",
  "block.minecraft.tripwire": "Guossanbáddi",
  "block.minecraft.tripwire_hook": "Guossanbátti Sággi",
  "block.minecraft.tube_coral": "Bohcci Koralla",
  "block.minecraft.tube_coral_block": "Bohcci Korallablohkka",
  "block.minecraft.tube_coral_fan": "Bohcci Koralla Fan",
  "block.minecraft.tube_coral_wall_fan": "Bohcci Koralla Libardahtti",
  "block.minecraft.tuff": "Tuffageađgi",
  "block.minecraft.tuff_brick_slab": "Tuffamuvrabealli",
  "block.minecraft.tuff_brick_stairs": "Tuffamuvratráhppát",
  "block.minecraft.tuff_brick_wall": "Tuffamuvraseaidni",
  "block.minecraft.tuff_bricks": "Tuffamuvra",
  "block.minecraft.tuff_slab": "Tuffabealli",
  "block.minecraft.tuff_stairs": "Tuffatráhppát",
  "block.minecraft.tuff_wall": "Tuffaseaidni",
  "block.minecraft.turtle_egg": "Galbarihccemonni",
  "block.minecraft.twisting_vines": "Gierrinan goargŋunšaddu",
  "block.minecraft.twisting_vines_plant": "Gierrinan goargŋunšattu rássi",
  "block.minecraft.vault": "Lohkkadat",
  "block.minecraft.verdant_froglight": "Ruonásaš rihccecuoppočuovga",
  "block.minecraft.vine": "Goargŋunsuoidni",
  "block.minecraft.void_air": "Gomuvuohta",
  "block.minecraft.wall_torch": "Seaidne Spáiddar",
  "block.minecraft.warped_button": "Bonjoboallu",
  "block.minecraft.warped_door": "Bonjouksa",
  "block.minecraft.warped_fence": "Bonjoáidi",
  "block.minecraft.warped_fence_gate": "Bonjoverrát",
  "block.minecraft.warped_fungus": "Bonjoguoppar",
  "block.minecraft.warped_hanging_sign": "Heŋgejuvvon bonjogalba",
  "block.minecraft.warped_hyphae": "Bonjosuorus",
  "block.minecraft.warped_nylium": "Skuibesmirkoeana",
  "block.minecraft.warped_planks": "Bonjofiellut",
  "block.minecraft.warped_pressure_plate": "Bonjodeattopláhtta",
  "block.minecraft.warped_roots": "Bonjoruohttasat",
  "block.minecraft.warped_shelf": "Bonjohildu",
  "block.minecraft.warped_sign": "Bonjogalba",
  "block.minecraft.warped_slab": "Bonjopláhtta",
  "block.minecraft.warped_stairs": "Bonjotráhppát",
  "block.minecraft.warped_stem": "Bonjonađđa",
  "block.minecraft.warped_trapdoor": "Bonjoluŋká",
  "block.minecraft.warped_wall_hanging_sign": "Heŋgejuvvon bonjogalba seainnis",
  "block.minecraft.warped_wall_sign": "Heŋgojuvvon Bonjogalba",
  "block.minecraft.warped_wart_block": "Bonjospártoblohkka",
  "block.minecraft.water": "Čáhci",
  "block.minecraft.water_cauldron": "Čáhceruitu",
  "block.minecraft.waxed_chiseled_copper": "Váksajuvvon luokčajuvvon veaiki",
  "block.minecraft.waxed_copper_bars": "Váksajuvvon veaikegiddagas",
  "block.minecraft.waxed_copper_block": "Váksajuvvon veaikeblohkka",
  "block.minecraft.waxed_copper_bulb": "Váksajuvvon veaikelámpá",
  "block.minecraft.waxed_copper_chain": "Váksajuvvon veaikeláhkki",
  "block.minecraft.waxed_copper_chest": "Váksajuvvon veaikegiisá",
  "block.minecraft.waxed_copper_door": "Váksajuvvon veaikeuksa",
  "block.minecraft.waxed_copper_golem_statue": "Váksajuvvon veaikehálddi bázzi",
  "block.minecraft.waxed_copper_grate": "Váksajuvvon veaikeráspa",
  "block.minecraft.waxed_copper_lantern": "Váksajuvvon veaikelámpá",
  "block.minecraft.waxed_copper_trapdoor": "Váksajuvvon veaikeluŋká",
  "block.minecraft.waxed_cut_copper": "Váksajuvvon čuhppon veaiki",
  "block.minecraft.waxed_cut_copper_slab": "Váksajuvvon čuhppon veaikebealli",
  "block.minecraft.waxed_cut_copper_stairs": "Váksajuvvon čuhppon veaiketráhppát",
  "block.minecraft.waxed_exposed_chiseled_copper": "Váksajuvvon suojehis luokčajuvvon veaiki",
  "block.minecraft.waxed_exposed_copper": "Váksajuvvon suojehis veaiki",
  "block.minecraft.waxed_exposed_copper_bars": "Váksajuvvon suojehis veaikegiddagas",
  "block.minecraft.waxed_exposed_copper_bulb": "Váksajuvvon suojehis veaikelámpá",
  "block.minecraft.waxed_exposed_copper_chain": "Váksajuvvon suojehis veaikeláhkki",
  "block.minecraft.waxed_exposed_copper_chest": "Váksajuvvon suojehis veaikegiisá",
  "block.minecraft.waxed_exposed_copper_door": "Váksajuvvon suojehis veaikeuksa",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Váksajuvvon suojehis veaikehálddi bázzi",
  "block.minecraft.waxed_exposed_copper_grate": "Váksajuvvon suojehis veaikeráspa",
  "block.minecraft.waxed_exposed_copper_lantern": "Váksajuvvon suojehis veaikelámpá",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Váksajuvvon suojehis veaikeluŋká",
  "block.minecraft.waxed_exposed_cut_copper": "Váksajuvvon suojehis čuhppon veaiki",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Váksajuvvon suojehis čuhppon veaikebealli",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Váksajuvvon suojehis čuhppon veaiketráhppát",
  "block.minecraft.waxed_exposed_lightning_rod": "Váksajuvvon suojehis álddagasa dustensoabbi",
  "block.minecraft.waxed_lightning_rod": "Váksajuvvon álddagasa dustensoabbi",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Váksajuvvon giimman luokčajuvvon veaiki",
  "block.minecraft.waxed_oxidized_copper": "Váksajuvvon giimman veaiki",
  "block.minecraft.waxed_oxidized_copper_bars": "Váksajuvvon giimman veaikegiddagas",
  "block.minecraft.waxed_oxidized_copper_bulb": "Váksajuvvon giimman veaikelámpá",
  "block.minecraft.waxed_oxidized_copper_chain": "Váksajuvvon giimman veaikeláhkki",
  "block.minecraft.waxed_oxidized_copper_chest": "Váksajuvvon giimman veaikegiisá",
  "block.minecraft.waxed_oxidized_copper_door": "Váksajuvvon giimman veaikeuksa",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Váksajuvvon giimman veaikehálddi bázzi",
  "block.minecraft.waxed_oxidized_copper_grate": "Váskajuvvon giimman veaikeráspa",
  "block.minecraft.waxed_oxidized_copper_lantern": "Váksajuvvon giimman veaikelámpá",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Váskajuvvon giimman veaikeluŋká",
  "block.minecraft.waxed_oxidized_cut_copper": "Váksajuvvon giimman čuhppon veaiki",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Váksajuvvon giimman čuhppon veaikebealli",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Váksajuvvon giimman čuhppon veaiketráhppát",
  "block.minecraft.waxed_oxidized_lightning_rod": "Váksajuvvon giimman álddagasa dustensoabbi",
  "block.minecraft.waxed_weathered_chiseled_copper": "Váksajuvvon giimmagoahtan luokčajuvvon veaiki",
  "block.minecraft.waxed_weathered_copper": "Váksajuvvon giimmagoahtan veaiki",
  "block.minecraft.waxed_weathered_copper_bars": "Váksajuvvon giimmagoahtan veaikegiddagas",
  "block.minecraft.waxed_weathered_copper_bulb": "Váksajuvvon giimmagoahtan veaikelámpá",
  "block.minecraft.waxed_weathered_copper_chain": "Váksajuvvon giimmagoahtan veaikeláhkki",
  "block.minecraft.waxed_weathered_copper_chest": "Váksajuvvon giimmagoahtan veaikegiisá",
  "block.minecraft.waxed_weathered_copper_door": "Váksajuvvon giimmagoahtan veaikeuksa",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Váksajuvvon giimmagoahtan veaikehálddi bázzi",
  "block.minecraft.waxed_weathered_copper_grate": "Váksajuvvon giimmagoahtan veaikeráspa",
  "block.minecraft.waxed_weathered_copper_lantern": "Váksajuvvon giimmagoahtan veaikelámpá",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Váksajuvvon giimmagoahtan veaikeluŋká",
  "block.minecraft.waxed_weathered_cut_copper": "Váksajuvvon giimmagoahtan čuhppon veaiki",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Váksajuvvon giimmagoahtan čuhppon veaikebealli",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Váksajuvvon giimmagoahtan čuhppon veaiketráhppát",
  "block.minecraft.waxed_weathered_lightning_rod": "Váksajuvvon giimmagoahtan álddagasa dustensoabbi",
  "block.minecraft.weathered_chiseled_copper": "Giimmagoahtan luokčajuvvon veaiki",
  "block.minecraft.weathered_copper": "Giimmagoahtan veaiki",
  "block.minecraft.weathered_copper_bars": "Giimmagoahtan veaikegiddagas",
  "block.minecraft.weathered_copper_bulb": "Giimmagoahtan veaikelámpá",
  "block.minecraft.weathered_copper_chain": "Giimmagoahtan veaikeláhkki",
  "block.minecraft.weathered_copper_chest": "Giimmagoahtan veaikegiisá",
  "block.minecraft.weathered_copper_door": "Giimmagoahtan veaikeuksa",
  "block.minecraft.weathered_copper_golem_statue": "Giimmagoahtan veaikehálddi bázzi",
  "block.minecraft.weathered_copper_grate": "Giimmagoahtan veaikeráspa",
  "block.minecraft.weathered_copper_lantern": "Giimmagoahtan veaikelámpá",
  "block.minecraft.weathered_copper_trapdoor": "Giimmagoahtan veaikeluŋká",
  "block.minecraft.weathered_cut_copper": "Giimmagoahtan čuhppon veaiki",
  "block.minecraft.weathered_cut_copper_slab": "Giimmagoahtan čuhppon veaikebealli",
  "block.minecraft.weathered_cut_copper_stairs": "Giimmagoahtan čuhppon veaiketráhppát",
  "block.minecraft.weathered_lightning_rod": "Giimmagoahtan álddagasa dustensoabbi",
  "block.minecraft.weeping_vines": "Ganjaldan goargŋunšaddu",
  "block.minecraft.weeping_vines_plant": "Ganjaldan goargŋunšattu rássi",
  "block.minecraft.wet_sponge": "Njuoska guopparas",
  "block.minecraft.wheat": "Nisugordne Siepma",
  "block.minecraft.white_banner": "Vilges Leavga",
  "block.minecraft.white_bed": "Vilges Seaŋga",
  "block.minecraft.white_candle": "Vilges ginttal",
  "block.minecraft.white_candle_cake": "Gáhkku vilges gintaliin",
  "block.minecraft.white_carpet": "Vilges Láhtterátnu",
  "block.minecraft.white_concrete": "Vilges betoŋŋa",
  "block.minecraft.white_concrete_powder": "Vilges betoŋŋabulvvar",
  "block.minecraft.white_glazed_terracotta": "Vilges šelges terrakotta",
  "block.minecraft.white_shulker_box": "Vilges Shulkerboksa",
  "block.minecraft.white_stained_glass": "Vilges Glássa",
  "block.minecraft.white_stained_glass_pane": "Vilges Glássaruvtto",
  "block.minecraft.white_terracotta": "Vilges terrakotta",
  "block.minecraft.white_tulip": "Vilges Tulipána",
  "block.minecraft.white_wool": "Vilges Ullu",
  "block.minecraft.wildflowers": "Meahccelieđit",
  "block.minecraft.wither_rose": "Witherlieđđi",
  "block.minecraft.wither_skeleton_skull": "Wither Dákterikki Oaiveskálžu",
  "block.minecraft.wither_skeleton_wall_skull": "Wither Dákterikki Seaidne Oaiveskálžu",
  "block.minecraft.yellow_banner": "Fiskes Leavga",
  "block.minecraft.yellow_bed": "Fiskes Seaŋga",
  "block.minecraft.yellow_candle": "Fiskes ginttal",
  "block.minecraft.yellow_candle_cake": "Gáhkku fiskes gintaliin",
  "block.minecraft.yellow_carpet": "Fiskes Láhtterátnu",
  "block.minecraft.yellow_concrete": "Fiskes betoŋŋa",
  "block.minecraft.yellow_concrete_powder": "Fiskes betoŋŋabulvvar",
  "block.minecraft.yellow_glazed_terracotta": "Fiskes šelges terrakotta",
  "block.minecraft.yellow_shulker_box": "Fiskes Shulkerboksa",
  "block.minecraft.yellow_stained_glass": "Fiskes Glássa",
  "block.minecraft.yellow_stained_glass_pane": "Fiskes Glássaruvtto",
  "block.minecraft.yellow_terracotta": "Fiskes terrakotta",
  "block.minecraft.yellow_wool": "Fiskes Ullu",
  "block.minecraft.zombie_head": "Jámeža oaivi",
  "block.minecraft.zombie_wall_head": "Jámeža Seaidneoaivi",
  "item.minecraft.acacia_boat": "Acaciafanas",
  "item.minecraft.acacia_chest_boat": "Acaciafanas mas giisá",
  "item.minecraft.allay_spawn_egg": "Hálddi Ealáskanmonni",
  "item.minecraft.amethyst_shard": "Ametistamoallu",
  "item.minecraft.angler_pottery_shard": "Vuokka kruhkkamoallu",
  "item.minecraft.angler_pottery_sherd": "Vuokka kruhkkamoallu",
  "item.minecraft.apple": "Ebel",
  "item.minecraft.archer_pottery_shard": "Dávgebáhčči kruhkkamoallu",
  "item.minecraft.archer_pottery_sherd": "Dávgebáhčči kruhkkamoallu",
  "item.minecraft.armadillo_scute": "Armadillo skálžu",
  "item.minecraft.armadillo_spawn_egg": "Armadillo ealáskanmonni",
  "item.minecraft.armor_stand": "Suodjebiktasiid čajeheaddji",
  "item.minecraft.arms_up_pottery_shard": "Geigejuvvon gieđaid ruhkkamoallu",
  "item.minecraft.arms_up_pottery_sherd": "Geigejuvvon gieđaid kruhkkamoallu",
  "item.minecraft.arrow": "Njuolla",
  "item.minecraft.axolotl_bucket": "Aksolohtalskállu",
  "item.minecraft.axolotl_spawn_egg": "Aksolohtala Ealáskanmonni",
  "item.minecraft.baked_potato": "Liggejuvvon buđet",
  "item.minecraft.bamboo_chest_raft": "Bámbufanas mas giisá",
  "item.minecraft.bamboo_raft": "Bámbufanas",
  "item.minecraft.bat_spawn_egg": "Girdisáhpána Ealáskanmonni",
  "item.minecraft.bee_spawn_egg": "Uvllu Ealáskanmonni",
  "item.minecraft.beef": "Njuoska Gusabiergu",
  "item.minecraft.beetroot": "Ruksesruohtas",
  "item.minecraft.beetroot_seeds": "Ruksesruohtasgilvagat",
  "item.minecraft.beetroot_soup": "Ruksesruohtasmálli",
  "item.minecraft.birch_boat": "Soahkefanas",
  "item.minecraft.birch_chest_boat": "Soahkefanas mas giisá",
  "item.minecraft.black_bundle": "Čáhppes dávvirbursa",
  "item.minecraft.black_dye": "Čáhppes Ivdni",
  "item.minecraft.black_harness": "Čáhppes leaŋggat",
  "item.minecraft.blade_pottery_shard": "Ávjju kruhkkamoallu",
  "item.minecraft.blade_pottery_sherd": "Ávjju kruhkkamoallu",
  "item.minecraft.blaze_powder": "Buollistálu bulvvar",
  "item.minecraft.blaze_rod": "Buollistálu sággi",
  "item.minecraft.blaze_spawn_egg": "Buollistálu Ealáskanmonni",
  "item.minecraft.blue_bundle": "Alit dávvirbursa",
  "item.minecraft.blue_dye": "Alit Ivdni",
  "item.minecraft.blue_egg": "Alit monni",
  "item.minecraft.blue_harness": "Alit leaŋggat",
  "item.minecraft.bogged_spawn_egg": "Jeakkeža ealáskanmonni",
  "item.minecraft.bolt_armor_trim_smithing_template": "Rávdebádjemálle",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Návlli suodjalushearva",
  "item.minecraft.bone": "Dákti",
  "item.minecraft.bone_meal": "Dáktejáffu",
  "item.minecraft.book": "Girji",
  "item.minecraft.bordure_indented_banner_pattern": "Barvvasravdda leavgamálle",
  "item.minecraft.bow": "Dávgi",
  "item.minecraft.bowl": "Bollu",
  "item.minecraft.bread": "Láibi",
  "item.minecraft.breeze_rod": "Ruvaža sággi",
  "item.minecraft.breeze_spawn_egg": "Ruvaža ealáskanmonni",
  "item.minecraft.brewer_pottery_shard": "Vuošši kruhkkamoallu",
  "item.minecraft.brewer_pottery_sherd": "Vuošši kruhkkamoallu",
  "item.minecraft.brewing_stand": "Vuoššahat",
  "item.minecraft.brick": "Muvrabihttá",
  "item.minecraft.brown_bundle": "Ruškes dávvirbursa",
  "item.minecraft.brown_dye": "Ruškes Ivdni",
  "item.minecraft.brown_egg": "Ruškes monni",
  "item.minecraft.brown_harness": "Ruškes leaŋggat",
  "item.minecraft.brush": "Kusta",
  "item.minecraft.bucket": "Gievdni",
  "item.minecraft.bundle": "Dávvirbursa",
  "item.minecraft.bundle.empty": "Guoros",
  "item.minecraft.bundle.empty.description": "Sáhttá vurkkodit ovtta lána iešguđet dávviriid",
  "item.minecraft.bundle.full": "Dievva",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Buollán kruhkkamoallu",
  "item.minecraft.burn_pottery_sherd": "Buollán kruhkkamoallu",
  "item.minecraft.camel_husk_spawn_egg": "Kamelajámeža ealáskanmonni",
  "item.minecraft.camel_spawn_egg": "Kamela ealáskanmonni",
  "item.minecraft.carrot": "Rušpi",
  "item.minecraft.carrot_on_a_stick": "Rušpi Oaggunstávrras",
  "item.minecraft.cat_spawn_egg": "Bussá Ealáskanmonni",
  "item.minecraft.cauldron": "Ruitu",
  "item.minecraft.cave_spider_spawn_egg": "Hoalluheavnni Ealáskanmonni",
  "item.minecraft.chainmail_boots": "Viđjegápmagat",
  "item.minecraft.chainmail_chestplate": "Viđjeraddepánsár",
  "item.minecraft.chainmail_helmet": "Viđjejealbma",
  "item.minecraft.chainmail_leggings": "Viđjebuvssat",
  "item.minecraft.charcoal": "Čađđa",
  "item.minecraft.cherry_boat": "Kirsamuorjemuorrafanas",
  "item.minecraft.cherry_chest_boat": "Kirsamuorjemuorrafanas mas giisá",
  "item.minecraft.chest_minecart": "Roggangielká mas giisá",
  "item.minecraft.chicken": "Njuoska Vuoncábiergu",
  "item.minecraft.chicken_spawn_egg": "Vuoncá Ealáskanmonni",
  "item.minecraft.chorus_fruit": "Chorusšattus",
  "item.minecraft.clay_ball": "Láiraspábba",
  "item.minecraft.clock": "Diibmu",
  "item.minecraft.coal": "Koalla",
  "item.minecraft.coast_armor_trim_smithing_template": "Rávdebádjemálle",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Mearrarittu suodjalushearva",
  "item.minecraft.cocoa_beans": "Kakáošaddu",
  "item.minecraft.cod": "Njuoska Dorski",
  "item.minecraft.cod_bucket": "Dorskeskállu",
  "item.minecraft.cod_spawn_egg": "Dorski Ealáskanmonni",
  "item.minecraft.command_block_minecart": "Roggangielká mas kommándoblohkka",
  "item.minecraft.compass": "Kompássa",
  "item.minecraft.cooked_beef": "Steaika",
  "item.minecraft.cooked_chicken": "Basson Vuoncábiergu",
  "item.minecraft.cooked_cod": "Basson Dorski",
  "item.minecraft.cooked_mutton": "Basson Lábbabiergu",
  "item.minecraft.cooked_porkchop": "Basson Spiidnečoarbealli",
  "item.minecraft.cooked_rabbit": "Basson Njoammelbiergu",
  "item.minecraft.cooked_salmon": "Basson Luossa",
  "item.minecraft.cookie": "Keaksa",
  "item.minecraft.copper_axe": "Veaikeákšu",
  "item.minecraft.copper_boots": "Veaikegápmagat",
  "item.minecraft.copper_chestplate": "Veaikeraddesuodjalus",
  "item.minecraft.copper_golem_spawn_egg": "Veaikehálddi ealáskanmonni",
  "item.minecraft.copper_helmet": "Veaikegahpir",
  "item.minecraft.copper_hoe": "Veaikeguohkki",
  "item.minecraft.copper_horse_armor": "Heastta veaikesuodjalus",
  "item.minecraft.copper_ingot": "Veaiki",
  "item.minecraft.copper_leggings": "Veaikebuvssat",
  "item.minecraft.copper_nautilus_armor": "Veaikehelbmoskálžosuodjalusbivttas",
  "item.minecraft.copper_nugget": "Veaikebihttáš",
  "item.minecraft.copper_pickaxe": "Veaikebiikaákšu",
  "item.minecraft.copper_shovel": "Veaikegoaivu",
  "item.minecraft.copper_spear": "Veaikesáiti",
  "item.minecraft.copper_sword": "Veaikemiehkki",
  "item.minecraft.cow_spawn_egg": "Gusa Ealáskanmonni",
  "item.minecraft.creaking_spawn_egg": "Gihčama ealáskanmonni",
  "item.minecraft.creeper_banner_pattern": "Leavga minsttár",
  "item.minecraft.creeper_banner_pattern.desc": "Creeperminsttar",
  "item.minecraft.creeper_banner_pattern.new": "Creeper leavgamálle",
  "item.minecraft.creeper_spawn_egg": "Creepera Ealáskanmonni",
  "item.minecraft.crossbow": "Dávgebissu",
  "item.minecraft.crossbow.projectile": "Luođđa:",
  "item.minecraft.crossbow.projectile.multiple": "Luođđa: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Luođđa: %s",
  "item.minecraft.cyan_bundle": "Turkiisa dávvirbursa",
  "item.minecraft.cyan_dye": "Turkiisa Idvni",
  "item.minecraft.cyan_harness": "Čuvgesalit leaŋggat",
  "item.minecraft.danger_pottery_shard": "Várálašvuođa kruhkkamoallu",
  "item.minecraft.danger_pottery_sherd": "Várálašvuođa kruhkkamoallu",
  "item.minecraft.dark_oak_boat": "Sevdnjes Eaikafanas",
  "item.minecraft.dark_oak_chest_boat": "Sevdnjeseaikafanas mas giisá",
  "item.minecraft.debug_stick": "Sivvaohcansoabbi",
  "item.minecraft.debug_stick.empty": "%s eai leat mearrádusat",
  "item.minecraft.debug_stick.select": "válljejuvvon \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" šadda %s",
  "item.minecraft.diamond": "Diamánta",
  "item.minecraft.diamond_axe": "Diamántaákšu",
  "item.minecraft.diamond_boots": "Diamántagápmagat",
  "item.minecraft.diamond_chestplate": "Diamántaraddepánsár",
  "item.minecraft.diamond_helmet": "Diamántajealbma",
  "item.minecraft.diamond_hoe": "Diamántaguohkki",
  "item.minecraft.diamond_horse_armor": "Heastta diamántasuodjalus",
  "item.minecraft.diamond_leggings": "Diamántabuvssat",
  "item.minecraft.diamond_nautilus_armor": "Diamántahelbmoskálžosuodjalusbivttas",
  "item.minecraft.diamond_pickaxe": "Diamántabiikaákšu",
  "item.minecraft.diamond_shovel": "Diamántagoaivu",
  "item.minecraft.diamond_spear": "Diamántasáiti",
  "item.minecraft.diamond_sword": "Diamántamiehkki",
  "item.minecraft.disc_fragment_5": "Skearrobihttáš",
  "item.minecraft.disc_fragment_5.desc": "Musihkkaskearru - 5",
  "item.minecraft.dolphin_spawn_egg": "Delfiinna Ealáskanmonni",
  "item.minecraft.donkey_spawn_egg": "Ása Ealáskanmonni",
  "item.minecraft.dragon_breath": "Dollalaggá vuoiŋŋastat",
  "item.minecraft.dried_kelp": "Goikaduvvon Stárra",
  "item.minecraft.drowned_spawn_egg": "Heavvanan Ealáskanmonni",
  "item.minecraft.dune_armor_trim_smithing_template": "Rávdebádjemálle",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Sáttočasttasa suodjalushearva",
  "item.minecraft.echo_shard": "Skádjamoallu",
  "item.minecraft.egg": "Monni",
  "item.minecraft.elder_guardian_spawn_egg": "Dološ Várjaleaddji Ealáskanmonni",
  "item.minecraft.elytra": "Soajit",
  "item.minecraft.emerald": "Emerálda",
  "item.minecraft.enchanted_book": "Noidojuvvon girji",
  "item.minecraft.enchanted_golden_apple": "Noidojuvvon Golleebel",
  "item.minecraft.end_crystal": "Endorkristálla",
  "item.minecraft.ender_dragon_spawn_egg": "Endordollalaggá ealáskanmonni",
  "item.minecraft.ender_eye": "Endorčalbmi",
  "item.minecraft.ender_pearl": "Endorhelbmo",
  "item.minecraft.enderman_spawn_egg": "Endorolbmo Ealáskanmonni",
  "item.minecraft.endermite_spawn_egg": "Endermite Ealáskanmonni",
  "item.minecraft.evoker_spawn_egg": "Gonstošeaddji Ealáskanmonni",
  "item.minecraft.experience_bottle": "Noaidobohtal",
  "item.minecraft.explorer_pottery_shard": "Suokkardeaddji kruhkkamoallu",
  "item.minecraft.explorer_pottery_sherd": "Suokkardeaddji kruhkkamoallu",
  "item.minecraft.eye_armor_trim_smithing_template": "Rávdebádjemálle",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Čalmmi suodjalushearva",
  "item.minecraft.feather": "Dolgi",
  "item.minecraft.fermented_spider_eye": "Fermenterejuvvon Heavdnečalbmi",
  "item.minecraft.field_masoned_banner_pattern": "Muvrra leavgaminsttar",
  "item.minecraft.filled_map": "Kárta",
  "item.minecraft.fire_charge": "Buolligeađgi",
  "item.minecraft.firework_rocket": "Rakeahtta",
  "item.minecraft.firework_rocket.flight": "Girdináigi:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Rahkeahttanásti",
  "item.minecraft.firework_star.black": "Čáhppat",
  "item.minecraft.firework_star.blue": "Alit",
  "item.minecraft.firework_star.brown": "Ruškat",
  "item.minecraft.firework_star.custom_color": "Iešlágan",
  "item.minecraft.firework_star.cyan": "Turkiisa",
  "item.minecraft.firework_star.fade_to": "Guovssut",
  "item.minecraft.firework_star.flicker": "Ravkkuhit",
  "item.minecraft.firework_star.gray": "Ránis",
  "item.minecraft.firework_star.green": "Ruoná",
  "item.minecraft.firework_star.light_blue": "Čuvgesalit",
  "item.minecraft.firework_star.light_gray": "Čuovgesránes",
  "item.minecraft.firework_star.lime": "Čuvesruoná",
  "item.minecraft.firework_star.magenta": "Čuvgessáhppes",
  "item.minecraft.firework_star.orange": "Runta",
  "item.minecraft.firework_star.pink": "Čuvgesrukses",
  "item.minecraft.firework_star.purple": "Sáhppat",
  "item.minecraft.firework_star.red": "Ruoksat",
  "item.minecraft.firework_star.shape": "Imašminsttar",
  "item.minecraft.firework_star.shape.burst": "Reatká miehtá",
  "item.minecraft.firework_star.shape.creeper": "Creeperlagan",
  "item.minecraft.firework_star.shape.large_ball": "Stuora luođđa",
  "item.minecraft.firework_star.shape.small_ball": "Unna luođđa",
  "item.minecraft.firework_star.shape.star": "Nástelagan",
  "item.minecraft.firework_star.trail": "Bálggis",
  "item.minecraft.firework_star.white": "Vielgat",
  "item.minecraft.firework_star.yellow": "Fiskat",
  "item.minecraft.fishing_rod": "Oaggunstávrá",
  "item.minecraft.flint": "Didnu",
  "item.minecraft.flint_and_steel": "Cahkkehanruovdi",
  "item.minecraft.flow_armor_trim_smithing_template": "Rávdebádjemálle",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Rávnnji suodjalushearva",
  "item.minecraft.flow_banner_pattern": "Leavgamálle",
  "item.minecraft.flow_banner_pattern.desc": "Golgan",
  "item.minecraft.flow_banner_pattern.new": "Rávnnji leavgamálle",
  "item.minecraft.flow_pottery_sherd": "Golgama kruhkkamoallu",
  "item.minecraft.flower_banner_pattern": "Leavgamálle",
  "item.minecraft.flower_banner_pattern.desc": "Lieđđeminsttar",
  "item.minecraft.flower_banner_pattern.new": "Lieđi leavgaminsttar",
  "item.minecraft.flower_pot": "Lieđđekruhkku",
  "item.minecraft.fox_spawn_egg": "Riebana Ealáskanmonni",
  "item.minecraft.friend_pottery_shard": "Ustiba kruhkkamoallu",
  "item.minecraft.friend_pottery_sherd": "Ustiba kruhkkamoallu",
  "item.minecraft.frog_spawn_egg": "Rihccecubbo ealáskanmonni",
  "item.minecraft.furnace_minecart": "Roggangielká mas uvdna",
  "item.minecraft.ghast_spawn_egg": "Ghast Ealáskanmonni",
  "item.minecraft.ghast_tear": "Ghast gaŋaldat",
  "item.minecraft.glass_bottle": "Lásebohtal",
  "item.minecraft.glistering_melon_slice": "Šelges Meluvdnabihttáš",
  "item.minecraft.globe_banner_pattern": "Leavgamálle",
  "item.minecraft.globe_banner_pattern.desc": "Máilmmeminsttar",
  "item.minecraft.globe_banner_pattern.new": "Máilmmi leavgaminsttar",
  "item.minecraft.glow_berries": "Čuovgi muorjjit",
  "item.minecraft.glow_ink_sac": "Áhcagas ivdnečoalli",
  "item.minecraft.glow_item_frame": "Áhcagas dávvirrámma",
  "item.minecraft.glow_squid_spawn_egg": "Áhcagas áhkárguoli ealáskanmonni",
  "item.minecraft.glowstone_dust": "Čuovgageađggedopmu",
  "item.minecraft.goat_horn": "Gáicačoarvi",
  "item.minecraft.goat_spawn_egg": "Gáicca Ealáskanmonni",
  "item.minecraft.gold_ingot": "Golli",
  "item.minecraft.gold_nugget": "Gollebihttáš",
  "item.minecraft.golden_apple": "Golleebel",
  "item.minecraft.golden_axe": "Golleákšu",
  "item.minecraft.golden_boots": "Gollegápmagat",
  "item.minecraft.golden_carrot": "Gollerušpi",
  "item.minecraft.golden_chestplate": "Golleraddepánsár",
  "item.minecraft.golden_helmet": "Gollejealbma",
  "item.minecraft.golden_hoe": "Golleguohkki",
  "item.minecraft.golden_horse_armor": "Heastta gollesuodjalus",
  "item.minecraft.golden_leggings": "Gollebuvssat",
  "item.minecraft.golden_nautilus_armor": "Gollehelbmoskálžosuodjalusbivttas",
  "item.minecraft.golden_pickaxe": "Gollebiikaákšu",
  "item.minecraft.golden_shovel": "Gollegoaivu",
  "item.minecraft.golden_spear": "Gollesáiti",
  "item.minecraft.golden_sword": "Gollemiehkki",
  "item.minecraft.gray_bundle": "Ránes dávvirbursa",
  "item.minecraft.gray_dye": "Ránes Ivdni",
  "item.minecraft.gray_harness": "Ránes leaŋggat",
  "item.minecraft.green_bundle": "Ruoná dávvirbursa",
  "item.minecraft.green_dye": "Ruoná Ivdni",
  "item.minecraft.green_harness": "Ruoná leaŋggat",
  "item.minecraft.guardian_spawn_egg": "Várjaleaddji Ealáskanmonni",
  "item.minecraft.gunpowder": "Rukta",
  "item.minecraft.guster_banner_pattern": "Leavgamálle",
  "item.minecraft.guster_banner_pattern.desc": "Jiella",
  "item.minecraft.guster_banner_pattern.new": "Jiela leavgamálle",
  "item.minecraft.guster_pottery_sherd": "Jiela kruhkkamoallu",
  "item.minecraft.happy_ghast_spawn_egg": "Lihkolaš Ghast Ealáskanmonni",
  "item.minecraft.harness": "Leaŋggat",
  "item.minecraft.heart_of_the_sea": "Mearaváibmu",
  "item.minecraft.heart_pottery_shard": "Váimmu kruhkkamoallu",
  "item.minecraft.heart_pottery_sherd": "Váimmu kruhkkamoallu",
  "item.minecraft.heartbreak_pottery_shard": "Váibmoduolbmi kruhkkamoallu",
  "item.minecraft.heartbreak_pottery_sherd": "Váibmoduolbmi kruhkkamoallu",
  "item.minecraft.hoglin_spawn_egg": "Hoglina Ealáskanmonni",
  "item.minecraft.honey_bottle": "Honnetbohtal",
  "item.minecraft.honeycomb": "Honnetbihttá",
  "item.minecraft.hopper_minecart": "Roggangielká mas njammi",
  "item.minecraft.horse_spawn_egg": "Heasta Ealáskanmonni",
  "item.minecraft.host_armor_trim_smithing_template": "Rávdebádjemálle",
  "item.minecraft.host_armor_trim_smithing_template.new": "Bálvaleaddji suodjalushearva",
  "item.minecraft.howl_pottery_shard": "Hovluma kruhkkamoallu",
  "item.minecraft.howl_pottery_sherd": "Hovluma kruhkkamoallu",
  "item.minecraft.husk_spawn_egg": "Goikejámeža Ealáskanmonni",
  "item.minecraft.ink_sac": "Čáhppesivdnečoalli",
  "item.minecraft.iron_axe": "Ruovdeákšu",
  "item.minecraft.iron_boots": "Ruovdegápmagat",
  "item.minecraft.iron_chestplate": "Ruovderaddepánsár",
  "item.minecraft.iron_golem_spawn_egg": "Ruovdejiehtanasa ealáskanmonni",
  "item.minecraft.iron_helmet": "Ruovdejealbma",
  "item.minecraft.iron_hoe": "Ruovdeguohkki",
  "item.minecraft.iron_horse_armor": "Heastta ruovdesuodjalus",
  "item.minecraft.iron_ingot": "Ruovdi",
  "item.minecraft.iron_leggings": "Ruovdebuvssat",
  "item.minecraft.iron_nautilus_armor": "Ruovdehelbmoskálžosuodjalusbivttas",
  "item.minecraft.iron_nugget": "Ruovdebihttáš",
  "item.minecraft.iron_pickaxe": "Ruovdebiikaákšu",
  "item.minecraft.iron_shovel": "Ruovdegoaivu",
  "item.minecraft.iron_spear": "Ruovdesáiti",
  "item.minecraft.iron_sword": "Ruovdemiehkki",
  "item.minecraft.item_frame": "Dávvirrámma",
  "item.minecraft.jungle_boat": "Suhkesvuovdefanas",
  "item.minecraft.jungle_chest_boat": "Suhkesvuovdefanas mas giisá",
  "item.minecraft.knowledge_book": "Máhttogirji",
  "item.minecraft.lapis_lazuli": "Lasura",
  "item.minecraft.lava_bucket": "Lavagievdni",
  "item.minecraft.lead": "Lávži",
  "item.minecraft.leather": "Sisti",
  "item.minecraft.leather_boots": "Sistegápmagat",
  "item.minecraft.leather_chestplate": "Sistebáidi",
  "item.minecraft.leather_helmet": "Sistegahpir",
  "item.minecraft.leather_horse_armor": "Heastta náhkkesuodjalus",
  "item.minecraft.leather_leggings": "Sistebuvssat",
  "item.minecraft.light_blue_bundle": "Čuvgesalit dávvirbursa",
  "item.minecraft.light_blue_dye": "Čuvgesalit Ivdni",
  "item.minecraft.light_blue_harness": "Čuvgesalit leaŋggat",
  "item.minecraft.light_gray_bundle": "Čuovgesránes dávvirbursa",
  "item.minecraft.light_gray_dye": "Čuvgesránes Ivdni",
  "item.minecraft.light_gray_harness": "Čuvgesránes leaŋggat",
  "item.minecraft.lime_bundle": "Čuvgesruoná dávvirbursa",
  "item.minecraft.lime_dye": "Čuvgesruoná Ivdni",
  "item.minecraft.lime_harness": "Čuvgesruoná leaŋggat",
  "item.minecraft.lingering_potion": "Bissovaš jugus",
  "item.minecraft.lingering_potion.effect.awkward": "Bissovaš Vuođđojugus",
  "item.minecraft.lingering_potion.effect.empty": "Bissovaš Duojatkas Jugus",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Bissovaš buollingierdevašvuođa noaidejugus",
  "item.minecraft.lingering_potion.effect.harming": "Bissovaš sorbmema noaidejugus",
  "item.minecraft.lingering_potion.effect.healing": "Bissovaš fáhkkaheakka noaidejugus",
  "item.minecraft.lingering_potion.effect.infested": "Bissovaš njoammuma noaidejugus",
  "item.minecraft.lingering_potion.effect.invisibility": "Bissovaš oainnameahttunvuođa noaidejugus",
  "item.minecraft.lingering_potion.effect.leaping": "Bissovaš liigenjuikema noaidejugus",
  "item.minecraft.lingering_potion.effect.levitation": "Bissovaš girdima noaidejugus",
  "item.minecraft.lingering_potion.effect.luck": "Bissovaš lihku noaidejugus",
  "item.minecraft.lingering_potion.effect.mundane": "Dábálaš bissovaš jugus",
  "item.minecraft.lingering_potion.effect.night_vision": "Bissovaš idjaoainnu noaidejugus",
  "item.minecraft.lingering_potion.effect.oozing": "Bissovaš njivlli noaidejugus",
  "item.minecraft.lingering_potion.effect.poison": "Bissovaš mirkkolaš noaidejugus",
  "item.minecraft.lingering_potion.effect.regeneration": "Bissovaš buorráneami noaidejugus",
  "item.minecraft.lingering_potion.effect.slow_falling": "Bissovaš njoazesgahčči noaidejugus",
  "item.minecraft.lingering_potion.effect.slowness": "Bissovaš hiđisvuođa noaidejugus",
  "item.minecraft.lingering_potion.effect.strength": "Bissovaš vuoimmi noaidejugus",
  "item.minecraft.lingering_potion.effect.swiftness": "Bissovaš johtilvuođa noaidejugus",
  "item.minecraft.lingering_potion.effect.thick": "Suhkkes bissovaš jugus",
  "item.minecraft.lingering_potion.effect.turtle_master": "Bissovaš galbarihcceipmila noaidejugus",
  "item.minecraft.lingering_potion.effect.water": "Bissovaš čáhcebohtal",
  "item.minecraft.lingering_potion.effect.water_breathing": "Bissovaš čáhcevuoiŋŋama noaidejugus",
  "item.minecraft.lingering_potion.effect.weakness": "Bissovaš geanohisvuođa noaidejugus",
  "item.minecraft.lingering_potion.effect.weaving": "Bissovaš gođđima noaidejugus",
  "item.minecraft.lingering_potion.effect.wind_charged": "Bissovaš bieggadoarohasa noaidejugus",
  "item.minecraft.llama_spawn_egg": "Llama Ealáskanmonni",
  "item.minecraft.lodestone_compass": "Láidengeađgekompássa",
  "item.minecraft.mace": "Veažir",
  "item.minecraft.magenta_bundle": "Čuvgessáhppes dávvirbursa",
  "item.minecraft.magenta_dye": "Čuvgessáhppes Ivdni",
  "item.minecraft.magenta_harness": "Čuvgessáhppes leaŋggat",
  "item.minecraft.magma_cream": "Magmakreamma",
  "item.minecraft.magma_cube_spawn_egg": "Magmaealli Ealáskanmonni",
  "item.minecraft.mangrove_boat": "Mangrovefanas",
  "item.minecraft.mangrove_chest_boat": "Mangrovefanas mas giisá",
  "item.minecraft.map": "Guoros Kárta",
  "item.minecraft.melon_seeds": "Meluvdnagilvagat",
  "item.minecraft.melon_slice": "Meluvdna Bihttá",
  "item.minecraft.milk_bucket": "Mielkegievdni",
  "item.minecraft.minecart": "Roggangielká",
  "item.minecraft.miner_pottery_shard": "Ruvkeroggi kruhkkamoallu",
  "item.minecraft.miner_pottery_sherd": "Ruvkeroggi kruhkkamoallu",
  "item.minecraft.mojang_banner_pattern": "Leavgamálle",
  "item.minecraft.mojang_banner_pattern.desc": "Mojangminsttar",
  "item.minecraft.mojang_banner_pattern.new": "Dávvira leavgamálle",
  "item.minecraft.mooshroom_spawn_egg": "Mooshrooma Ealáskanmonni",
  "item.minecraft.mourner_pottery_shard": "Morašeaddji kruhkkamoallu",
  "item.minecraft.mourner_pottery_sherd": "Morašeaddji kruhkkamoallu",
  "item.minecraft.mule_spawn_egg": "Muvlla Ealáskanmonni",
  "item.minecraft.mushroom_stew": "Guopparmálli",
  "item.minecraft.music_disc_11": "Musihkkaskearru",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Musihkkaskearru",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Musihkkaskearru",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Musihkkaskearru",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Musihkkaskearru",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Musihkkaskearru",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Musihkkaskearru",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Musihkkaskearru",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Musihkkaboksa)",
  "item.minecraft.music_disc_far": "Musihkkaskearru",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Musihkkaskearru",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Musihkkaskearru",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Musihkkaskearru",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Musihkkaskearru",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Musihkkaskearru",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Musihkkaskearru",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Musihkkaskearru",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Musihkkaskearru",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Musihkkaskearru",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Musihkkaskearru",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Musihkkaskearru",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Musihkkaskearru",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Njuoska Lábbabiergu",
  "item.minecraft.name_tag": "Nammalihppu",
  "item.minecraft.nautilus_shell": "Helbmoskálžu",
  "item.minecraft.nautilus_spawn_egg": "Helbmoskálžoealli ealáskanmonni",
  "item.minecraft.nether_brick": "Nethermuvra",
  "item.minecraft.nether_star": "Nether Násti",
  "item.minecraft.nether_wart": "Netherspártu",
  "item.minecraft.netherite_axe": "Netheriitaákšu",
  "item.minecraft.netherite_boots": "Netheriitagapmagat",
  "item.minecraft.netherite_chestplate": "Netheriitaraddepánsár",
  "item.minecraft.netherite_helmet": "Netheriitajealbma",
  "item.minecraft.netherite_hoe": "Netheriitaguohkki",
  "item.minecraft.netherite_horse_armor": "Heasta netheriitasuodjalus",
  "item.minecraft.netherite_ingot": "Netheriita",
  "item.minecraft.netherite_leggings": "Netheriitabuvssat",
  "item.minecraft.netherite_nautilus_armor": "Netheriitahelbmoskálžosuodjalusbivttas",
  "item.minecraft.netherite_pickaxe": "Netheriitabiikaákšu",
  "item.minecraft.netherite_scrap": "Netheriitabihttážat",
  "item.minecraft.netherite_shovel": "Netheriitagoaivu",
  "item.minecraft.netherite_spear": "Netheriitasáiti",
  "item.minecraft.netherite_sword": "Netheriitamiehkki",
  "item.minecraft.netherite_upgrade_smithing_template": "Rávdebádjemálle",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netheriita buoridus",
  "item.minecraft.oak_boat": "Eaikafanas",
  "item.minecraft.oak_chest_boat": "Eaikafanas mas giisá",
  "item.minecraft.ocelot_spawn_egg": "Meahccebussá Ealáskanmonni",
  "item.minecraft.ominous_bottle": "Bahávuoiŋŋa bohtal",
  "item.minecraft.ominous_trial_key": "Bahávuoiŋŋa geahččalusčoavdda",
  "item.minecraft.orange_bundle": "Runta dávvirbursa",
  "item.minecraft.orange_dye": "Runta Ivdni",
  "item.minecraft.orange_harness": "Runta leaŋggat",
  "item.minecraft.painting": "Govva",
  "item.minecraft.pale_oak_boat": "Šovkes eaikafanas",
  "item.minecraft.pale_oak_chest_boat": "Šovkes eaikafanas mas lea fanas",
  "item.minecraft.panda_spawn_egg": "Panda Ealáskanmonni",
  "item.minecraft.paper": "Bábir",
  "item.minecraft.parched_spawn_egg": "Buollánjámeža ealáskanmonni",
  "item.minecraft.parrot_spawn_egg": "Papegoia Ealáskanmonni",
  "item.minecraft.phantom_membrane": "Idjagopmi Cuozza",
  "item.minecraft.phantom_spawn_egg": "Idjagopmi Ealáskanmonni",
  "item.minecraft.pig_spawn_egg": "Spiinni Ealáskanmonni",
  "item.minecraft.piglin_banner_pattern": "Leavgamálle",
  "item.minecraft.piglin_banner_pattern.desc": "Njunni",
  "item.minecraft.piglin_banner_pattern.new": "Spiidnenjuni leavgamálle",
  "item.minecraft.piglin_brute_spawn_egg": "Piglin bahálačča Ealáskanmonni",
  "item.minecraft.piglin_spawn_egg": "Piglina Ealáskanmonni",
  "item.minecraft.pillager_spawn_egg": "Rievvára Ealáskanmonni",
  "item.minecraft.pink_bundle": "Guvgesrukses dávvirbursa",
  "item.minecraft.pink_dye": "Čuvgesrukses Ivdni",
  "item.minecraft.pink_harness": "Čuvgesrukses leaŋggat",
  "item.minecraft.pitcher_plant": "Muggarássi",
  "item.minecraft.pitcher_pod": "Muggarássekruhkka",
  "item.minecraft.plenty_pottery_shard": "Valjitvuođa kruhkkamoallu",
  "item.minecraft.plenty_pottery_sherd": "Valjitvuođa kruhkkamoallu",
  "item.minecraft.poisonous_potato": "Mirkkolaš buđet",
  "item.minecraft.polar_bear_spawn_egg": "Jiekŋaguovžža Ealáskanmonni",
  "item.minecraft.popped_chorus_fruit": "Rahpasan chorusšattus",
  "item.minecraft.porkchop": "Njuoska spiidnečoarbealli",
  "item.minecraft.potato": "Buđet",
  "item.minecraft.potion": "Noaidejugus",
  "item.minecraft.potion.effect.awkward": "Vuođđojugus",
  "item.minecraft.potion.effect.empty": "Duojatkas Jugus",
  "item.minecraft.potion.effect.fire_resistance": "Buollingierdevašvuođa noaidejugus",
  "item.minecraft.potion.effect.harming": "Sorbmema noaidejugus",
  "item.minecraft.potion.effect.healing": "Fáhkkaheakka noaidejugus",
  "item.minecraft.potion.effect.infested": "Njoammuma noaidejugus",
  "item.minecraft.potion.effect.invisibility": "Oainnameahttunvuođa noaidejugus",
  "item.minecraft.potion.effect.leaping": "Liigenjuikema noaidejugus",
  "item.minecraft.potion.effect.levitation": "Girdima noaidejugus",
  "item.minecraft.potion.effect.luck": "Lihku noaidejugus",
  "item.minecraft.potion.effect.mundane": "Dábálaš jugus",
  "item.minecraft.potion.effect.night_vision": "Idjaoainnu noaidejugus",
  "item.minecraft.potion.effect.oozing": "Njivlli noaidejugus",
  "item.minecraft.potion.effect.poison": "Mirkkolaš noaidejugus",
  "item.minecraft.potion.effect.regeneration": "Buorráneami noaidejugus",
  "item.minecraft.potion.effect.slow_falling": "Njoazesgahčči noaidejugus",
  "item.minecraft.potion.effect.slowness": "Hiđisvuođa noaidejugus",
  "item.minecraft.potion.effect.strength": "Vuoimmi noaidejugus",
  "item.minecraft.potion.effect.swiftness": "Johtilvuođa noaidejugus",
  "item.minecraft.potion.effect.thick": "Suhkkes jugus",
  "item.minecraft.potion.effect.turtle_master": "Galbarihcceipmila noaidejugus",
  "item.minecraft.potion.effect.water": "Čáhcebohtal",
  "item.minecraft.potion.effect.water_breathing": "Čáhcevuoiŋŋama noaidejugus",
  "item.minecraft.potion.effect.weakness": "Geanohisvuođa noaidejugus",
  "item.minecraft.potion.effect.weaving": "Gođđima noaidejugus",
  "item.minecraft.potion.effect.wind_charged": "Bieggadoarohasa noaidejugus",
  "item.minecraft.pottery_shard_archer": "Dávgebáhčči kruhkkamoallu",
  "item.minecraft.pottery_shard_arms_up": "Geigejuvvon gieđaid kruhkkamoallu",
  "item.minecraft.pottery_shard_prize": "Bálkkášumi ruhkkamoallu",
  "item.minecraft.pottery_shard_skull": "Oaiveskálžžu ruhkkamoallu",
  "item.minecraft.powder_snow_bucket": "Oppasgievdni",
  "item.minecraft.prismarine_crystals": "Prismariidnakristálla",
  "item.minecraft.prismarine_shard": "Prismariidnamoallu",
  "item.minecraft.prize_pottery_shard": "Bálkkášumi ruhkkamoallu",
  "item.minecraft.prize_pottery_sherd": "Bálkkášumi kruhkkamoallu",
  "item.minecraft.pufferfish": "Mirkoguolli",
  "item.minecraft.pufferfish_bucket": "Mirkoguolleskállu",
  "item.minecraft.pufferfish_spawn_egg": "Mirkoguoli Ealáskanmonni",
  "item.minecraft.pumpkin_pie": "Gurbbet Paia",
  "item.minecraft.pumpkin_seeds": "Murbbetgilvagat",
  "item.minecraft.purple_bundle": "Sáhppes dávvirbursa",
  "item.minecraft.purple_dye": "Sáhppes Ivdni",
  "item.minecraft.purple_harness": "Sáhppes leaŋggat",
  "item.minecraft.quartz": "Netherkvártsa",
  "item.minecraft.rabbit": "Njuoska Njoammelbiergu",
  "item.minecraft.rabbit_foot": "Njoammeljuolgi",
  "item.minecraft.rabbit_hide": "Njoammelduolji",
  "item.minecraft.rabbit_spawn_egg": "Njoammila Ealáskanmonni",
  "item.minecraft.rabbit_stew": "Njoammelmálli",
  "item.minecraft.raiser_armor_trim_smithing_template": "Rávdebádjemálle",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Ceggejeaddji suodjalushearva",
  "item.minecraft.ravager_spawn_egg": "Mollenstálu Ealáskanmonni",
  "item.minecraft.raw_copper": "Roavvaveaiki",
  "item.minecraft.raw_gold": "Roavvagolli",
  "item.minecraft.raw_iron": "Roavvaruovdi",
  "item.minecraft.recovery_compass": "Máhcahankompássa",
  "item.minecraft.red_bundle": "Rukses dávvirbursa",
  "item.minecraft.red_dye": "Rukses Ivdni",
  "item.minecraft.red_harness": "Rukses leaŋggat",
  "item.minecraft.redstone": "Redstonedopmu",
  "item.minecraft.resin_brick": "Gáhččemuvra",
  "item.minecraft.resin_clump": "Gáhččečoaltu",
  "item.minecraft.rib_armor_trim_smithing_template": "Rávdebádjemálle",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Erttetdávtti suodjalushearva",
  "item.minecraft.rotten_flesh": "Guohcagan Biergu",
  "item.minecraft.saddle": "Riidensálat",
  "item.minecraft.salmon": "Njuoska Luossa",
  "item.minecraft.salmon_bucket": "Luossaskállu",
  "item.minecraft.salmon_spawn_egg": "Luosa Ealáskanmonni",
  "item.minecraft.scrape_pottery_sherd": "Faskkuma kruhkkamoallu",
  "item.minecraft.scute": "Skálžu",
  "item.minecraft.sentry_armor_trim_smithing_template": "Rávdebádjemálle",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Vávtta suodjalushearva",
  "item.minecraft.shaper_armor_trim_smithing_template": "Rávdebádjemálle",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Hábmejeaddji suodjalushearva",
  "item.minecraft.sheaf_pottery_shard": "Bonjaldaga kruhkkamoallu",
  "item.minecraft.sheaf_pottery_sherd": "Bonjaldaga kruhkkamoallu",
  "item.minecraft.shears": "Skárret",
  "item.minecraft.sheep_spawn_egg": "Sávzza Ealáskanmonni",
  "item.minecraft.shelter_pottery_shard": "Suoji kruhkkamoallu",
  "item.minecraft.shelter_pottery_sherd": "Suoji kruhkkamoallu",
  "item.minecraft.shield": "Galba",
  "item.minecraft.shield.black": "Čáhppes Galba",
  "item.minecraft.shield.blue": "Alit Galba",
  "item.minecraft.shield.brown": "Ruškes Galba",
  "item.minecraft.shield.cyan": "Turkiisa Galba",
  "item.minecraft.shield.gray": "Ránes Galba",
  "item.minecraft.shield.green": "Ruoná Galba",
  "item.minecraft.shield.light_blue": "Čuvgesalit Galba",
  "item.minecraft.shield.light_gray": "Čuvgesránes Galba",
  "item.minecraft.shield.lime": "Čuvgesruoná Galba",
  "item.minecraft.shield.magenta": "Čuvgessáhppes Galba",
  "item.minecraft.shield.orange": "Runta Galba",
  "item.minecraft.shield.pink": "Čuvgesrukses Galba",
  "item.minecraft.shield.purple": "Sáhppes Galba",
  "item.minecraft.shield.red": "Rukses Galba",
  "item.minecraft.shield.white": "Vilges Galba",
  "item.minecraft.shield.yellow": "Fiskes Galba",
  "item.minecraft.shulker_shell": "Shulker Skálžu",
  "item.minecraft.shulker_spawn_egg": "Shulkera Ealáskanmonni",
  "item.minecraft.sign": "Galba",
  "item.minecraft.silence_armor_trim_smithing_template": "Rávdebádjemálle",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Jaskatvuođa suodjalushearva",
  "item.minecraft.silverfish_spawn_egg": "Silbasáhpána Ealáskanmonni",
  "item.minecraft.skeleton_horse_spawn_egg": "Dákteriggeheasta Ealáskanmonni",
  "item.minecraft.skeleton_spawn_egg": "Dákterikki Ealáskanmonni",
  "item.minecraft.skull_banner_pattern": "Leavgamálle",
  "item.minecraft.skull_banner_pattern.desc": "Oaiveskálžominsttar",
  "item.minecraft.skull_banner_pattern.new": "Oaiveskálžžu leavgamálle",
  "item.minecraft.skull_pottery_shard": "Oaiveskálžžu ruhkkamoallu",
  "item.minecraft.skull_pottery_sherd": "Oaiveskálžžu kruhkkamoallu",
  "item.minecraft.slime_ball": "Njivlespábba",
  "item.minecraft.slime_spawn_egg": "Njivleealli Ealáskanmonni",
  "item.minecraft.smithing_template": "Rávdebádjemálle",
  "item.minecraft.smithing_template.applies_to": "Gullá dása:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Lasit bárra dahje kristálla",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Suodjalusbivttas",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Lasit suodjebiktasa",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Materiálat & Kristállat",
  "item.minecraft.smithing_template.ingredients": "Ávnnasoasit:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Lasit netheriita",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamántasuodjalus",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Lasit diamánta suodjebiktasa, vearjju, dahje reaiddu",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netheriita",
  "item.minecraft.smithing_template.upgrade": "Ođasmahtte: ",
  "item.minecraft.sniffer_spawn_egg": "Sustti Ealáskanmonni",
  "item.minecraft.snort_pottery_shard": "Sustašeami kruhkkamoallu",
  "item.minecraft.snort_pottery_sherd": "Sustašeami kruhkkamoallu",
  "item.minecraft.snout_armor_trim_smithing_template": "Rávdebádjemálle",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Spiidnenjuni suodjalushearva",
  "item.minecraft.snow_golem_spawn_egg": "Muohtaáddjá ealáskanmonni",
  "item.minecraft.snowball": "Muohtačahkir",
  "item.minecraft.spectral_arrow": "Suotnjar Njuolla",
  "item.minecraft.spider_eye": "Heavdnečalbmi",
  "item.minecraft.spider_spawn_egg": "Heavnni Ealáskanmonni",
  "item.minecraft.spire_armor_trim_smithing_template": "Rávdebádjemálle",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Toarnna suodjalusbivttas",
  "item.minecraft.splash_potion": "Diškalanjugus",
  "item.minecraft.splash_potion.effect.awkward": "Vuođđodiškalanjugus",
  "item.minecraft.splash_potion.effect.empty": "Duojakas Diškalanjugus",
  "item.minecraft.splash_potion.effect.fire_resistance": "Buollingierdevašvuođa diškalanjugus",
  "item.minecraft.splash_potion.effect.harming": "Sorbmema diškalanjugus",
  "item.minecraft.splash_potion.effect.healing": "Fáhkkaheakka diškalanjugus",
  "item.minecraft.splash_potion.effect.infested": "Njoammuma diškalanjugus",
  "item.minecraft.splash_potion.effect.invisibility": "Oainnameahttunvuođa diškalanjugus",
  "item.minecraft.splash_potion.effect.leaping": "Njuikema diškalanjugus",
  "item.minecraft.splash_potion.effect.levitation": "Girdima diškalanjugus",
  "item.minecraft.splash_potion.effect.luck": "Lihku diškalanjugus",
  "item.minecraft.splash_potion.effect.mundane": "Dábálaš diškalanjugus",
  "item.minecraft.splash_potion.effect.night_vision": "Idjaoainnu diškalanjugus",
  "item.minecraft.splash_potion.effect.oozing": "Njivlli diškalanjugus",
  "item.minecraft.splash_potion.effect.poison": "Mirkku diškalanjugus",
  "item.minecraft.splash_potion.effect.regeneration": "Buorráneami diškalanjugus",
  "item.minecraft.splash_potion.effect.slow_falling": "Njoazesgahččama diškalanjugus",
  "item.minecraft.splash_potion.effect.slowness": "Hiđisvuođa diškalanjugus",
  "item.minecraft.splash_potion.effect.strength": "Vuoimmi diškalanjugus",
  "item.minecraft.splash_potion.effect.swiftness": "Leavttu diškalanjugus",
  "item.minecraft.splash_potion.effect.thick": "Suhkkes diškalanjugus",
  "item.minecraft.splash_potion.effect.turtle_master": "Galbarihcceipmila diškalanjugus",
  "item.minecraft.splash_potion.effect.water": "Čázi diškalanjugus",
  "item.minecraft.splash_potion.effect.water_breathing": "Čáhcevuoigŋama diškalanjugus",
  "item.minecraft.splash_potion.effect.weakness": "Geanohisvuođa diškalanjugus",
  "item.minecraft.splash_potion.effect.weaving": "Gođđima diškalanjugus",
  "item.minecraft.splash_potion.effect.wind_charged": "Bieggadoarohasa diškalanjugus",
  "item.minecraft.spruce_boat": "Guossafanas",
  "item.minecraft.spruce_chest_boat": "Guossafanas mas giisá",
  "item.minecraft.spyglass": "Giikan",
  "item.minecraft.squid_spawn_egg": "Áhkárguoli Ealáskanmonni",
  "item.minecraft.stick": "Soabbi",
  "item.minecraft.stone_axe": "Geađgeákšu",
  "item.minecraft.stone_hoe": "Geađgeguohkki",
  "item.minecraft.stone_pickaxe": "Geađgebiikaákšu",
  "item.minecraft.stone_shovel": "Geađgegoaivu",
  "item.minecraft.stone_spear": "Geađgesáiti",
  "item.minecraft.stone_sword": "Geađgemiehkki",
  "item.minecraft.stray_spawn_egg": "Vádjoleaddji Ealáskanmonni",
  "item.minecraft.strider_spawn_egg": "Gálašeaddji Ealáskanmonni",
  "item.minecraft.string": "Láigi",
  "item.minecraft.sugar": "Sohkar",
  "item.minecraft.suspicious_stew": "Imašlaš málli",
  "item.minecraft.sweet_berries": "Váramat",
  "item.minecraft.tadpole_bucket": "Šlubboaiveskállu",
  "item.minecraft.tadpole_spawn_egg": "Šlubboaivvi ealáskanmonni",
  "item.minecraft.tide_armor_trim_smithing_template": "Rávdebádjemálle",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Ollečázi suodjalushearva",
  "item.minecraft.tipped_arrow": "Budnjon Njuolla",
  "item.minecraft.tipped_arrow.effect.awkward": "Budnjon njuolla",
  "item.minecraft.tipped_arrow.effect.empty": "Duojatkas Budnjonnjuolla",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Buollingierdevašvuođa njuolla",
  "item.minecraft.tipped_arrow.effect.harming": "Sorbmema njuolla",
  "item.minecraft.tipped_arrow.effect.healing": "Fáhkkaheakka njuolla",
  "item.minecraft.tipped_arrow.effect.infested": "Njoammuma njuolla",
  "item.minecraft.tipped_arrow.effect.invisibility": "Oainnameahttunvuođa njuolla",
  "item.minecraft.tipped_arrow.effect.leaping": "Njuikema njuolla",
  "item.minecraft.tipped_arrow.effect.levitation": "Girdima njuolla",
  "item.minecraft.tipped_arrow.effect.luck": "Lihku njuolla",
  "item.minecraft.tipped_arrow.effect.mundane": "Budnjon njuolla",
  "item.minecraft.tipped_arrow.effect.night_vision": "Idjaoainnu njuolla",
  "item.minecraft.tipped_arrow.effect.oozing": "Njivlli njuolla",
  "item.minecraft.tipped_arrow.effect.poison": "Mirkku njuolla",
  "item.minecraft.tipped_arrow.effect.regeneration": "Buorráneami njuolla",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Njoazesgahččama njuolla",
  "item.minecraft.tipped_arrow.effect.slowness": "Hiđisvuođa njuolla",
  "item.minecraft.tipped_arrow.effect.strength": "Vuoimmi njuolla",
  "item.minecraft.tipped_arrow.effect.swiftness": "Leavttu njuolla",
  "item.minecraft.tipped_arrow.effect.thick": "Budnjon njuolla",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Galbarihcceipmila njuolla",
  "item.minecraft.tipped_arrow.effect.water": "Diškalannjuolla",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Čáhcevuoigŋama njuolla",
  "item.minecraft.tipped_arrow.effect.weakness": "Geanohisvuođa njuolla",
  "item.minecraft.tipped_arrow.effect.weaving": "Gođđima njuolla",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Bieggadoarohasa njuolla",
  "item.minecraft.tnt_minecart": "Roggangielká mas TNT",
  "item.minecraft.torchflower_seeds": "Spáiddárlieđđegilvagat",
  "item.minecraft.totem_of_undying": "Jápmemeahttunvuođa árdna",
  "item.minecraft.trader_llama_spawn_egg": "Vuovdaleaddji Llama Ealáskanmonni",
  "item.minecraft.trial_key": "Geahččalusčoavdda",
  "item.minecraft.trident": "Háŋgu",
  "item.minecraft.tropical_fish": "Trohpalaš guolli",
  "item.minecraft.tropical_fish_bucket": "Trohpalašguolleskállu",
  "item.minecraft.tropical_fish_spawn_egg": "Trohpalaš guoli Ealáskanmonni",
  "item.minecraft.turtle_helmet": "Skálžogahpir",
  "item.minecraft.turtle_scute": "Galbarihcci skálžu",
  "item.minecraft.turtle_spawn_egg": "Galbarihcci Ealáskanmonni",
  "item.minecraft.vex_armor_trim_smithing_template": "Rávdebádjemálle",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Biidnogopmi suodjalushearva",
  "item.minecraft.vex_spawn_egg": "Biidnogopmi Ealáskanmonni",
  "item.minecraft.villager_spawn_egg": "Gillilačča Ealáskanmonni",
  "item.minecraft.vindicator_spawn_egg": "Vávtta Ealáskanmonni",
  "item.minecraft.wandering_trader_spawn_egg": "Johttigávppašeaddji Ealáskanmonni",
  "item.minecraft.ward_armor_trim_smithing_template": "Rávdebádjemálle",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Gohcci suodjalushearva",
  "item.minecraft.warden_spawn_egg": "Gozi ealáskanmonni",
  "item.minecraft.warped_fungus_on_a_stick": "Bonjoguoppar Stággus",
  "item.minecraft.water_bucket": "Čáhcegievdni",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Rávdebádjemálle",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Ofelačča suodjalushearva",
  "item.minecraft.wheat": "Nisugordni",
  "item.minecraft.wheat_seeds": "Nisogilvagat",
  "item.minecraft.white_bundle": "Vilges dávvirbursa",
  "item.minecraft.white_dye": "Vilges Ivdni",
  "item.minecraft.white_harness": "Vilges leaŋggat",
  "item.minecraft.wild_armor_trim_smithing_template": "Rávdebádjemálle",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Meahci suodjalushearva",
  "item.minecraft.wind_charge": "Bieggadoarohas",
  "item.minecraft.witch_spawn_egg": "Noaiddi Ealáskanmonni",
  "item.minecraft.wither_skeleton_spawn_egg": "Witherdákterikki Ealáskanmonni",
  "item.minecraft.wither_spawn_egg": "Withera ealáskanmonni",
  "item.minecraft.wolf_armor": "Gumppe suodjalusbivttas",
  "item.minecraft.wolf_spawn_egg": "Gumpe Ealáskanmonni",
  "item.minecraft.wooden_axe": "Muorraákšu",
  "item.minecraft.wooden_hoe": "Muorraguohkki",
  "item.minecraft.wooden_pickaxe": "Muorrabiikaákšu",
  "item.minecraft.wooden_shovel": "Muorragoaivu",
  "item.minecraft.wooden_spear": "Muorrasáiti",
  "item.minecraft.wooden_sword": "Muorramiehkki",
  "item.minecraft.writable_book": "Girji ja čállindolgi",
  "item.minecraft.written_book": "Čállon Girji",
  "item.minecraft.yellow_bundle": "Fiskes dávvirbursa",
  "item.minecraft.yellow_dye": "Fiskes Ivdni",
  "item.minecraft.yellow_harness": "Fiskes leaŋggat",
  "item.minecraft.zoglin_spawn_egg": "Zoglina Ealáskanmonni",
  "item.minecraft.zombie_horse_spawn_egg": "Jámešheasta Ealáskanmonni",
  "item.minecraft.zombie_nautilus_spawn_egg": "Helbmoskálžoeallejámeža ealáskanmonni",
  "item.minecraft.zombie_spawn_egg": "Jámeža Ealáskanmonni",
  "item.minecraft.zombie_villager_spawn_egg": "Jámeš Gillilačča Ealáskanmonni",
  "item.minecraft.zombified_piglin_spawn_egg": "Piglinjábmi Ealáskanmonni"
}
export const se_no = items; 
